import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AppInstallUrn created URN. */
  AppInstallUrn: { input: any; output: any; }
  /** ArticleTagUrn created URN. */
  ArticleTagUrn: { input: any; output: any; }
  /** ArticleUrn created URN. */
  ArticleUrn: { input: any; output: any; }
  /** ChannelEmailUrn created URN. */
  ChannelEmailUrn: { input: any; output: any; }
  /** ChannelInviteUrn created URN. */
  ChannelInviteUrn: { input: any; output: any; }
  /** CompanyUrn created URN. */
  CompanyUrn: { input: any; output: any; }
  /** DashboardUrn created URN. */
  DashboardUrn: { input: any; output: any; }
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: any; output: any; }
  /** FormExternalUrn created URN. */
  FormExternalUrn: { input: any; output: any; }
  /** FormFieldUrn created URN. */
  FormFieldUrn: { input: any; output: any; }
  /** FormUrn created URN. */
  FormUrn: { input: any; output: any; }
  /** HandleUrn created URN. */
  HandleUrn: { input: any; output: any; }
  /** IntegrationUrn created URN. */
  IntegrationUrn: { input: any; output: any; }
  /** Standard key value string pair */
  Map: { input: any; output: any; }
  /** MetricsDashboardUrn created URN. */
  MetricsDashboardUrn: { input: any; output: any; }
  /** PortalUrn created URN. */
  PortalUrn: { input: any; output: any; }
  /** QueueUrn created URN. */
  QueueUrn: { input: any; output: any; }
  /** RoutingPolicyUrn created URN. */
  RoutingPolicyUrn: { input: any; output: any; }
  /** TicketCustomContextUrn created URN. */
  TicketCustomContextUrn: { input: any; output: any; }
  /** TicketMessageUrn created URN. */
  TicketMessageUrn: { input: any; output: any; }
  /** TicketStateUrn created URN. */
  TicketStateUrn: { input: any; output: any; }
  /** TicketTaskUrn created URN. */
  TicketTaskUrn: { input: any; output: any; }
  /** TicketUrn created URN. */
  TicketUrn: { input: any; output: any; }
  /** Urn */
  Urn: { input: any; output: any; }
  /** UserGroupUrn created URN. */
  UserGroupUrn: { input: any; output: any; }
  /** UserSessionUrn created URN. */
  UserSessionUrn: { input: any; output: any; }
  /** UserUrn created URN. */
  UserUrn: { input: any; output: any; }
  /** WorkflowServiceActionChildUrn created URN. */
  WorkflowServiceActionChildUrn: { input: any; output: any; }
  /** WorkflowServiceActionOutputUrn created URN. */
  WorkflowServiceActionOutputUrn: { input: any; output: any; }
  /** WorkflowServiceActionUrn created URN. */
  WorkflowServiceActionUrn: { input: any; output: any; }
  /** WorkflowServiceUrn created URN. */
  WorkflowServiceUrn: { input: any; output: any; }
  /** WorkflowStepUrn created URN. */
  WorkflowStepUrn: { input: any; output: any; }
  /** WorkflowUrn created URN. */
  WorkflowUrn: { input: any; output: any; }
};

export type Action = {
  __typename?: 'Action';
  deflection?: Maybe<ActionDeflection>;
  feedback?: Maybe<ActionFeedback>;
};

/** What type of context is this action running in? */
export enum ActionContextType {
  Request = 'REQUEST',
  Ticket = 'TICKET',
  Webhook = 'WEBHOOK'
}

export type ActionDeflection = {
  __typename?: 'ActionDeflection';
  isSuccessful: Scalars['Boolean']['output'];
};

/** Condition controlling when an action is allowed to execute */
export enum ActionExecuteStartCondition {
  AfterStarted = 'AFTER_STARTED',
  BeforeOrAfterStarted = 'BEFORE_OR_AFTER_STARTED'
}

export type ActionFeedback = {
  __typename?: 'ActionFeedback';
  isCommentAllowed: Scalars['Boolean']['output'];
  responseMessage?: Maybe<Scalars['String']['output']>;
  selectedIndex: Scalars['Float']['output'];
  type: FeedbackType;
};

/** The function to execute. */
export enum ActionFunction {
  CapitalCase = 'CAPITAL_CASE',
  DateFormat = 'DATE_FORMAT',
  JsonJoin = 'JSON_JOIN',
  JsonPath = 'JSON_PATH',
  LowerCase = 'LOWER_CASE',
  PadEnd = 'PAD_END',
  PadStart = 'PAD_START',
  RegexpMatch = 'REGEXP_MATCH',
  Replace = 'REPLACE',
  Substring = 'SUBSTRING',
  UpperCase = 'UPPER_CASE'
}

export type ActionInput = {
  path: Array<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  value?: InputMaybe<ActionInputBody>;
};

export type ActionInputBody = {
  feedback?: InputMaybe<ActionInputFeedback>;
};

export type ActionInputFeedback = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ActionSettings = {
  __typename?: 'ActionSettings';
  startCondition?: Maybe<ActionExecuteStartCondition>;
};

export type ActionSettingsInput = {
  startCondition?: InputMaybe<ActionExecuteStartCondition>;
};

/** Assignment Preferences */
export enum AgentAssignmentPreference {
  AutoSynchronize = 'AUTO_SYNCHRONIZE',
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type Approval = {
  __typename?: 'Approval';
  integrationId: Scalars['IntegrationUrn']['output'];
  type: ApprovalType;
};

export type ApprovalFormInput = {
  questions: Array<ApprovalQuestionInput>;
};

export type ApprovalInput = {
  integrationId: Scalars['IntegrationUrn']['input'];
  type: ApprovalType;
};

export type ApprovalQuestionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<ApprovalQuestionOptionInput>>;
  type: ApprovalQuestionType;
};

export type ApprovalQuestionOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Approval question type */
export enum ApprovalQuestionType {
  Choice = 'CHOICE',
  MultipleChoice = 'MULTIPLE_CHOICE'
}

/** Type of approval */
export enum ApprovalType {
  Manager = 'MANAGER'
}

export type Article = {
  __typename?: 'Article';
  /** Article body */
  body: RichBody;
  createdDate: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['Urn']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ArticleUrn']['output'];
  modifiedDate: Scalars['DateTime']['output'];
  portal: Portal;
  portalId: Scalars['PortalUrn']['output'];
  previewText?: Maybe<Scalars['String']['output']>;
  publishedBy?: Maybe<User>;
  publishedById?: Maybe<Scalars['Urn']['output']>;
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<ArticleTag>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ArticleAnswer = {
  __typename?: 'ArticleAnswer';
  /** body */
  body: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Types of possible feedback */
export enum ArticleFeedbackType {
  Helpful = 'HELPFUL',
  NotHelpful = 'NOT_HELPFUL'
}

export type ArticleInput = {
  body: Scalars['String']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Tags used to identify the article */
  tagIds?: InputMaybe<Array<Scalars['ArticleTagUrn']['input']>>;
  /** Article title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArticlePublishInput = {
  /** The date when the article should be published */
  publishDate: Scalars['DateTime']['input'];
};

export type ArticleResults = {
  __typename?: 'ArticleResults';
  answer?: Maybe<ArticleAnswer>;
  count: Scalars['Float']['output'];
  nextPageToken?: Maybe<Scalars['String']['output']>;
  results: Array<Article>;
};

export type ArticleSearchOptions = {
  /** Should also search external articles. */
  shouldSearchExternal: Scalars['Boolean']['input'];
};

export type ArticleTag = {
  __typename?: 'ArticleTag';
  childIds: Array<Scalars['ArticleTagUrn']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ArticleTagUrn']['output'];
  indexPageId?: Maybe<Scalars['ArticleUrn']['output']>;
  title: Scalars['String']['output'];
};

export type ArticleTagInput = {
  childIds: Array<Scalars['ArticleTagUrn']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  indexPageId?: InputMaybe<Scalars['ArticleUrn']['input']>;
  title: Scalars['String']['input'];
};

export type ArtificialIntelligencePrompt = {
  __typename?: 'ArtificialIntelligencePrompt';
  response: Scalars['String']['output'];
};

export type ArtificialIntelligencePromptInput = {
  input: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type ArtificialIntelligenceSettings = {
  __typename?: 'ArtificialIntelligenceSettings';
  isEnabled: Scalars['Boolean']['output'];
};

export type ArtificialIntelligenceSettingsInput = {
  isEnabled: Scalars['Boolean']['input'];
};

export type ArtificialIntelligenceSummary = {
  __typename?: 'ArtificialIntelligenceSummary';
  /** The tone of the customer */
  agentTone?: Maybe<Scalars['String']['output']>;
  /** The prediction of a satisfaction value */
  expectedSatisfaction?: Maybe<Scalars['Float']['output']>;
  /** Any generated recommendation to improve the customer satisfaction */
  recommendation?: Maybe<Scalars['String']['output']>;
  /** The sentiment of the customer */
  sentiment?: Maybe<Scalars['String']['output']>;
  /** The summary of the conversation */
  summary?: Maybe<Scalars['String']['output']>;
};

/** User assignment type */
export enum AssignmentType {
  None = 'NONE',
  RoundRobin = 'ROUND_ROBIN'
}

/** Which type of object */
export enum AsyncObjectType {
  Action = 'ACTION',
  ChatStatus = 'CHAT_STATUS',
  DeflectionSource = 'DEFLECTION_SOURCE',
  Email = 'EMAIL',
  FieldsInContext = 'FIELDS_IN_CONTEXT',
  FieldInContext = 'FIELD_IN_CONTEXT',
  Group = 'GROUP',
  Priority = 'PRIORITY',
  Queue = 'QUEUE',
  RequestType = 'REQUEST_TYPE',
  Severity = 'SEVERITY',
  SlaTier = 'SLA_TIER',
  Tags = 'TAGS',
  TicketState = 'TICKET_STATE',
  Timezone = 'TIMEZONE',
  User = 'USER'
}

export type AttachmentCreateInput = {
  /** Attachment Filename */
  filename: Scalars['String']['input'];
  /** Attachment Filename */
  mimeType: Scalars['String']['input'];
  /** Should the token be stored and create a short, long lasting url instead of a long one. This is useful for long living and not-as-secure attachments such as application icons. */
  shouldStore?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Float']['input'];
};

export type AttachmentCreated = {
  __typename?: 'AttachmentCreated';
  error?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** The user object. */
export type Bot = {
  __typename?: 'Bot';
  /** The bot avatar image. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The id of the bot user. */
  id: Scalars['UserUrn']['output'];
  /** The bot name. */
  name: Scalars['String']['output'];
  /** The type of bot. */
  type?: Maybe<BotType>;
};

/** Represents the type of bot */
export enum BotType {
  Slack = 'SLACK'
}

export type ChannelInvite = {
  __typename?: 'ChannelInvite';
  channelNameTemplate: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ChannelInviteUrn']['output'];
  introductionTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  settings: ChatSettings;
};

export type ChannelInviteInput = {
  channelNameTemplate: Scalars['String']['input'];
  description: Scalars['String']['input'];
  introductionTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  settings: ChatSettingsInput;
};

/** Action to take when the channel menu is triggered. */
export enum ChannelMenuAction {
  CreatePrivateTicket = 'CREATE_PRIVATE_TICKET',
  CreatePublicTicket = 'CREATE_PUBLIC_TICKET',
  Disabled = 'DISABLED',
  StartDirectMessage = 'START_DIRECT_MESSAGE',
  TextOnly = 'TEXT_ONLY'
}

/** How should the channel handle new messages? Start a ticket from a thread, add to a thread for the channel, or wait for manual action? */
export enum ChannelMode {
  Manual = 'MANUAL',
  SingleThread = 'SINGLE_THREAD',
  Threaded = 'THREADED'
}

export type ChannelTagCreateInput = {
  channelIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelTagCreated = {
  __typename?: 'ChannelTagCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type Chat = {
  __typename?: 'Chat';
  assignedDate?: Maybe<Scalars['DateTime']['output']>;
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['Urn']['output']>;
  canCurrentUserEdit?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  creator: User;
  creatorId: Scalars['Urn']['output'];
  currentUserLastReadDate?: Maybe<Scalars['DateTime']['output']>;
  currentUserLastResponseDate?: Maybe<Scalars['DateTime']['output']>;
  finishedDate?: Maybe<Scalars['DateTime']['output']>;
  hasUnreadByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  hasUnrespondedByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  holdNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['Urn']['output'];
  isAssignedToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserParticipating?: Maybe<Scalars['Boolean']['output']>;
  lastMessage?: Maybe<Scalars['String']['output']>;
  lastUserMessageDate?: Maybe<Scalars['DateTime']['output']>;
  modifiedDate?: Maybe<Scalars['DateTime']['output']>;
  priority?: Maybe<TicketPriority>;
  searchContext?: Maybe<ChatSearchResultContext>;
  sort?: Maybe<ChatSort>;
  source?: Maybe<ChatSource>;
  state?: Maybe<TicketState>;
  stateId?: Maybe<Scalars['TicketStateUrn']['output']>;
  status: ChatStatus;
  subject?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Ticket>;
  ticketId?: Maybe<Scalars['TicketUrn']['output']>;
  ticketNumber?: Maybe<Scalars['Float']['output']>;
};

export type ChatAddParticipantInput = {
  /** What is the chat you want to add the useres to?. */
  chatId?: InputMaybe<Scalars['Urn']['input']>;
  /** The note that will be sent and visible by the participating users. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** List of which users to add */
  participantIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  /** Should add the current user to the list of participants. */
  shouldAddSelf?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatAssignInput = {
  /** Who should the ticket be assigned to. This can be either a user id or a queue id. If assigned to self, can be left blank. */
  assigneeId?: InputMaybe<Scalars['Urn']['input']>;
  /** Any message to add to the assignment. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Should assign to current user. */
  shouldAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should unassign. */
  shouldUnassign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatEndInput = {
  /** Not defined if assiging ticket to self. */
  chatId?: InputMaybe<Scalars['Urn']['input']>;
  /** Ticket message to associate with the ticket. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** List of tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatLeaveParticipantInput = {
  /** Which chat ids do you want to leave. */
  chatIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  /** The note that will be sent and visible by the participating users. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Which participant to leave. If not specified, defaults to the current user. */
  participantId?: InputMaybe<Scalars['Urn']['input']>;
};

export type ChatResults = {
  __typename?: 'ChatResults';
  chats: Array<Chat>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ChatSearchResultContext = {
  __typename?: 'ChatSearchResultContext';
  previews?: Maybe<Array<ChatSearchResultPreviewContext>>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type ChatSearchResultPreviewContext = {
  __typename?: 'ChatSearchResultPreviewContext';
  field?: Maybe<Scalars['String']['output']>;
  previews?: Maybe<Array<Scalars['String']['output']>>;
};

export type ChatSettings = {
  __typename?: 'ChatSettings';
  formIds?: Maybe<Array<Scalars['FormUrn']['output']>>;
  id: Scalars['Urn']['output'];
  identities?: Maybe<Array<Scalars['Urn']['output']>>;
  identitiesType?: Maybe<ChatSettingsIdentitiesType>;
  options?: Maybe<ChatSettingsOptions>;
  slaTierId?: Maybe<Scalars['RoutingPolicyUrn']['output']>;
  welcomeMessage?: Maybe<DisplayText>;
};

export type ChatSettingsChannelEmail = {
  __typename?: 'ChatSettingsChannelEmail';
  feedbackIntroduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shouldSendFeedback?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatSettingsChannelEmailInput = {
  feedbackIntroduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shouldSendFeedback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatSettingsChannelMenu = {
  __typename?: 'ChatSettingsChannelMenu';
  action: ChannelMenuAction;
  afterImageUrl?: Maybe<Scalars['String']['output']>;
  afterText?: Maybe<DisplayText>;
  menuButtonText?: Maybe<Scalars['String']['output']>;
  menuText?: Maybe<DisplayText>;
  welcomeMessage?: Maybe<DisplayText>;
};

export type ChatSettingsChannelMenuInput = {
  action: ChannelMenuAction;
  afterImageUrl?: InputMaybe<Scalars['String']['input']>;
  afterText?: InputMaybe<DisplayTextInput>;
  menuButtonText?: InputMaybe<Scalars['String']['input']>;
  menuText?: InputMaybe<DisplayTextInput>;
  welcomeMessage?: InputMaybe<DisplayTextInput>;
};

export type ChatSettingsDeflection = {
  __typename?: 'ChatSettingsDeflection';
  identity?: Maybe<Scalars['Urn']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatSettingsDeflectionInput = {
  identity?: InputMaybe<Scalars['Urn']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatSettingsEmojiAction = {
  __typename?: 'ChatSettingsEmojiAction';
  allowedExecuteGroups: Array<Scalars['UserGroupUrn']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emoji: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['WorkflowUrn']['output']>;
};

export type ChatSettingsEmojiActionInput = {
  allowedExecuteGroups: Array<Scalars['UserGroupUrn']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emoji: Scalars['String']['input'];
  workflowId?: InputMaybe<Scalars['WorkflowUrn']['input']>;
};

/** Which chat settings to return */
export enum ChatSettingsFilter {
  All = 'ALL',
  ChannelTags = 'CHANNEL_TAGS',
  SlackChannels = 'SLACK_CHANNELS'
}

/** Specifies the type of meta identities selected. */
export enum ChatSettingsIdentitiesType {
  Inherit = 'INHERIT',
  None = 'NONE',
  Selected = 'SELECTED'
}

export type ChatSettingsInput = {
  formIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  identities?: InputMaybe<Array<Scalars['Urn']['input']>>;
  identitiesType?: InputMaybe<ChatSettingsIdentitiesType>;
  options?: InputMaybe<ChatSettingsOptionsInput>;
  slaTierId?: InputMaybe<Scalars['RoutingPolicyUrn']['input']>;
  welcomeMessage?: InputMaybe<DisplayTextInput>;
};

export type ChatSettingsOptions = {
  __typename?: 'ChatSettingsOptions';
  channelMenu?: Maybe<ChatSettingsChannelMenu>;
  deflection?: Maybe<ChatSettingsDeflection>;
  email?: Maybe<ChatSettingsChannelEmail>;
  slack?: Maybe<ChatSettingsSlack>;
  tag?: Maybe<ChatSettingsTag>;
};

export type ChatSettingsOptionsInput = {
  channelMenu?: InputMaybe<ChatSettingsChannelMenuInput>;
  deflection?: InputMaybe<ChatSettingsDeflectionInput>;
  email?: InputMaybe<ChatSettingsChannelEmailInput>;
  slack?: InputMaybe<ChatSettingsSlackInput>;
};

export type ChatSettingsSlack = {
  __typename?: 'ChatSettingsSlack';
  approvedBotIds?: Maybe<Array<Scalars['UserUrn']['output']>>;
  canFillOutForm?: Maybe<Scalars['Boolean']['output']>;
  channelMode?: Maybe<ChannelMode>;
  emojiActions?: Maybe<Array<ChatSettingsEmojiAction>>;
  ignoreTicketsFromEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  routingPolicies?: Maybe<Array<Scalars['RoutingPolicyUrn']['output']>>;
  shouldAllowUsersAddParticipants?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  ticketCreatedTemplate?: Maybe<Scalars['String']['output']>;
  workspaceName?: Maybe<Scalars['String']['output']>;
};

export type ChatSettingsSlackInput = {
  approvedBotIds?: InputMaybe<Array<Scalars['UserUrn']['input']>>;
  canFillOutForm?: InputMaybe<Scalars['Boolean']['input']>;
  channelMode?: InputMaybe<ChannelMode>;
  emojiActions?: InputMaybe<Array<ChatSettingsEmojiActionInput>>;
  ignoreTicketsFromEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  routingPolicies?: InputMaybe<Array<Scalars['RoutingPolicyUrn']['input']>>;
  shouldAllowUsersAddParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  ticketCreatedTemplate?: InputMaybe<Scalars['String']['input']>;
  workspaceName?: InputMaybe<Scalars['String']['input']>;
};

export type ChatSettingsTag = {
  __typename?: 'ChatSettingsTag';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatSort = {
  __typename?: 'ChatSort';
  channelIndex?: Maybe<Scalars['Float']['output']>;
  noGroupIndex?: Maybe<Scalars['Float']['output']>;
  priortyIndex?: Maybe<Scalars['Float']['output']>;
  userIndex?: Maybe<Scalars['Float']['output']>;
};

export type ChatSortInput = {
  chatIds: Array<Scalars['Urn']['input']>;
  groupBy: DashboardGroupBy;
};

export type ChatSource = {
  __typename?: 'ChatSource';
  id?: Maybe<Scalars['Urn']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  sourceIdentity?: Maybe<Scalars['Urn']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents the status of the conversation */
export enum ChatStatus {
  Assigned = 'ASSIGNED',
  ChatRequested = 'CHAT_REQUESTED',
  Connected = 'CONNECTED',
  DeflectionWaiting = 'DEFLECTION_WAITING',
  Finished = 'FINISHED',
  Ignored = 'IGNORED',
  OnHold = 'ON_HOLD',
  Snoozed = 'SNOOZED'
}

export type Company = {
  __typename?: 'Company';
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['CompanyUrn']['output'];
  name: Scalars['String']['output'];
};

export type CompanyInput = {
  domainName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CompanyResults = {
  __typename?: 'CompanyResults';
  count: Scalars['Float']['output'];
  nextPageToken?: Maybe<Scalars['String']['output']>;
  results: Array<Company>;
};

/** How two values should be compared. */
export enum Comparison {
  Contains = 'CONTAINS',
  DoesntContain = 'DOESNT_CONTAIN',
  DoesntExist = 'DOESNT_EXIST',
  Equal = 'EQUAL',
  Exists = 'EXISTS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  NotEqual = 'NOT_EQUAL',
  Regexp = 'REGEXP'
}

export type ConversationSource = {
  __typename?: 'ConversationSource';
  id: Scalars['Urn']['output'];
  label: Scalars['String']['output'];
  sourceIdentity: Scalars['Urn']['output'];
  type?: Maybe<ConversationSourceType>;
  url?: Maybe<Scalars['String']['output']>;
};

/** What is the conversation source */
export enum ConversationSourceType {
  ConversationGroup = 'CONVERSATION_GROUP',
  Email = 'EMAIL',
  SlackChannel = 'SLACK_CHANNEL'
}

export type CustomField = {
  __typename?: 'CustomField';
  displayValue?: Maybe<Scalars['String']['output']>;
  formField?: Maybe<FormField>;
  formFieldId: Scalars['FormFieldUrn']['output'];
  type?: Maybe<FormFieldType>;
  value?: Maybe<CustomFieldValue>;
};

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  displayValue?: Maybe<Scalars['String']['output']>;
  formFieldId: Scalars['FormFieldUrn']['output'];
  number?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  string?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FormFieldType>;
};

export type CustomFieldValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  displayValue?: InputMaybe<Scalars['String']['input']>;
  formFieldId: Scalars['FormFieldUrn']['input'];
  number?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  string?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormFieldType>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  /** The id of the dashboard */
  id: Scalars['DashboardUrn']['output'];
  /** The name of the dashboard */
  name: Scalars['String']['output'];
  /** Dashboard specific settings */
  settings?: Maybe<DashboardSettings>;
  /** The collection of ticket states and their metadata */
  ticketStates: Array<DashboardTicketState>;
};

/** Which field to use to group the dashboard columns */
export enum DashboardGroupBy {
  Assignee = 'ASSIGNEE',
  Channel = 'CHANNEL',
  CompanyGroup = 'COMPANY_GROUP',
  NoGroup = 'NO_GROUP',
  Priority = 'PRIORITY',
  Queue = 'QUEUE',
  User = 'USER'
}

export type DashboardInput = {
  /** The name of the dashboard */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The collection of ticket states and their metadata */
  settings?: InputMaybe<DashboardSettingsInput>;
  /** The collection of ticket states and their metadata */
  ticketStates?: InputMaybe<Array<DashboardTicketStateInput>>;
};

export type DashboardSettings = {
  __typename?: 'DashboardSettings';
  /** Which column to use to group the dashboard */
  groupBy?: Maybe<DashboardGroupBy>;
  /** The number of last conversation items to display */
  lastConversationCount?: Maybe<Scalars['Float']['output']>;
  /** Should wrap the dashboard columns */
  shouldWrap?: Maybe<Scalars['Boolean']['output']>;
  /** Which column to use to sort the dashboard */
  sortBy?: Maybe<DashboardSortBy>;
  /** Which tickets to return. All or just some */
  ticketView?: Maybe<TicketView>;
  /** How shoud the dashboard display the tickets */
  view?: Maybe<DashboardView>;
};

export type DashboardSettingsInput = {
  /** Which column to use to group the dashboard */
  groupBy?: InputMaybe<DashboardGroupBy>;
  /** The number of last conversation items to display */
  lastConversationCount?: InputMaybe<Scalars['Float']['input']>;
  /** Should wrap the dashboard columns */
  shouldWrap?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which column to use to sort the dashboard */
  sortBy?: InputMaybe<DashboardSortBy>;
  /** Which tickets to return. All or just some */
  ticketView?: InputMaybe<TicketView>;
  /** How shoud the dashboard display the tickets */
  view?: InputMaybe<DashboardView>;
};

/** Whcih field to use to sort the dashboard columns */
export enum DashboardSortBy {
  CreatedDateAscending = 'CREATED_DATE_ASCENDING',
  CreatedDateDescending = 'CREATED_DATE_DESCENDING',
  LastResponseDateAscending = 'LAST_RESPONSE_DATE_ASCENDING',
  LastResponseDateDescending = 'LAST_RESPONSE_DATE_DESCENDING',
  Manual = 'MANUAL',
  PriorityAscending = 'PRIORITY_ASCENDING',
  PriorityDescending = 'PRIORITY_DESCENDING'
}

export type DashboardTicketState = {
  __typename?: 'DashboardTicketState';
  /** The label to override the state */
  label?: Maybe<Scalars['String']['output']>;
  /** Location index where to store the ticket state */
  locationIndex?: Maybe<Scalars['Float']['output']>;
  ticketState: TicketState;
  /** The id of the state */
  ticketStateId?: Maybe<Scalars['TicketStateUrn']['output']>;
};

export type DashboardTicketStateInput = {
  /** The label to override the state */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Location index where to store the ticket state */
  locationIndex?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the state */
  ticketStateId?: InputMaybe<Scalars['TicketStateUrn']['input']>;
};

/** Should format should the dashboard look like */
export enum DashboardView {
  Compact = 'COMPACT',
  Kanban = 'KANBAN',
  KanbanWrapped = 'KANBAN_WRAPPED',
  Wall = 'WALL'
}

/** Which day of the week */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** To which status bucket should tickets that are waiting deflection be assigned? */
export enum DeflectionTicketStatusAssignment {
  ChatRequested = 'CHAT_REQUESTED',
  DeflectionWaiting = 'DEFLECTION_WAITING'
}

/** The source of the form */
export enum DisplayFormSource {
  Action = 'ACTION',
  Emoji = 'EMOJI',
  EndChat = 'END_CHAT',
  Portal = 'PORTAL',
  Workflow = 'WORKFLOW'
}

export type DisplayText = {
  __typename?: 'DisplayText';
  rawText?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Scalars['Boolean']['output']>;
};

export type DisplayTextInput = {
  rawText?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the type of due date. */
export enum DueDateType {
  SlaFirstResponse = 'SLA_FIRST_RESPONSE',
  SlaRequesterWaitTime = 'SLA_REQUESTER_WAIT_TIME',
  SlaTimeToUpdate = 'SLA_TIME_TO_UPDATE'
}

export type ExternalForm = {
  __typename?: 'ExternalForm';
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Urn']['output']>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  active?: Maybe<Array<Scalars['String']['output']>>;
};

export type Feedback = {
  __typename?: 'Feedback';
  customMessage?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Array<FeedbackResponse>>;
  shouldAllowComments?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<FeedbackType>;
};

export type FeedbackInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<FeedbackResponseInput>>;
  shouldAllowComments?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<FeedbackType>;
};

export type FeedbackResponse = {
  __typename?: 'FeedbackResponse';
  message?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type FeedbackResponseInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

/** Feedback seletor type */
export enum FeedbackType {
  Ces = 'CES',
  Faces = 'FACES',
  None = 'NONE',
  Nps = 'NPS',
  Thumbs = 'THUMBS'
}

export type FieldTypedReplaceableValue = {
  __typename?: 'FieldTypedReplaceableValue';
  replacements?: Maybe<Array<FormFieldReplacement>>;
  value: FieldTypedValueBase;
};

export type FieldTypedReplaceableValueInput = {
  replacements?: InputMaybe<Array<FormFieldReplacementInput>>;
  value: FieldTypedValueBaseInput;
};

export type FieldTypedValue = {
  __typename?: 'FieldTypedValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  displayValue?: Maybe<Scalars['String']['output']>;
  fieldId: Scalars['Urn']['output'];
  number?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  string?: Maybe<Scalars['String']['output']>;
  type: FormFieldType;
};

export type FieldTypedValueBase = {
  __typename?: 'FieldTypedValueBase';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  displayValue?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  string?: Maybe<Scalars['String']['output']>;
  type: FormFieldType;
};

export type FieldTypedValueBaseInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  displayValue?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  string?: InputMaybe<Scalars['String']['input']>;
  type: FormFieldType;
};

export type FieldTypedValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  displayValue?: InputMaybe<Scalars['String']['input']>;
  fieldId: Scalars['Urn']['input'];
  number?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  string?: InputMaybe<Scalars['String']['input']>;
  type: FormFieldType;
};

export type Form = {
  __typename?: 'Form';
  actionSettings?: Maybe<ActionSettings>;
  approvals?: Maybe<Array<Approval>>;
  deflection?: Maybe<FormDeflectionSettings>;
  description?: Maybe<Scalars['String']['output']>;
  exampleInput?: Maybe<FormWebhookExample>;
  externalFormId?: Maybe<Scalars['FormExternalUrn']['output']>;
  fields: Array<FormFieldDescriptor>;
  hasAutomation: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['FormUrn']['output'];
  isCreatePrivate?: Maybe<Scalars['Boolean']['output']>;
  jobFunctions?: Maybe<Array<JobFunction>>;
  name: Scalars['String']['output'];
  shouldCreateOnOnboarding?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<FormType>;
  userGroupIds?: Maybe<Array<Scalars['UserGroupUrn']['output']>>;
  workflow?: Maybe<Workflow>;
  workflowId?: Maybe<Scalars['WorkflowUrn']['output']>;
};

export type FormCloneInput = {
  actionSettings?: InputMaybe<ActionSettingsInput>;
  approvals?: InputMaybe<Array<ApprovalInput>>;
  deflection?: InputMaybe<FormDeflectionSettingsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalFormId?: InputMaybe<Scalars['FormExternalUrn']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  isCreatePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  jobFunctions?: InputMaybe<Array<JobFunction>>;
  name: Scalars['String']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
  shouldCreateOnOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<FormType>;
  userGroupIds?: InputMaybe<Array<Scalars['UserGroupUrn']['input']>>;
};

export type FormDeflectionSettings = {
  __typename?: 'FormDeflectionSettings';
  identity?: Maybe<Scalars['Urn']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type FormDeflectionSettingsInput = {
  identity?: InputMaybe<Scalars['Urn']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormField = {
  __typename?: 'FormField';
  asyncObjectType?: Maybe<AsyncObjectType>;
  defaultValue?: Maybe<FieldTypedValue>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Urn']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isSystemField: Scalars['Boolean']['output'];
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  levels?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<FormFieldOption>>;
  optionsSettings?: Maybe<FormFieldOptionSettings>;
  placeholder?: Maybe<Scalars['String']['output']>;
  type: FormFieldType;
  userGroupIds?: Maybe<Array<Scalars['UserGroupUrn']['output']>>;
  visibility: FormFieldVisibility;
};

export type FormFieldDescriptor = {
  __typename?: 'FormFieldDescriptor';
  agentText?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<FieldTypedReplaceableValue>;
  description?: Maybe<Scalars['String']['output']>;
  fieldId?: Maybe<Scalars['FormFieldUrn']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isRequiredForAgent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  requestorText?: Maybe<Scalars['String']['output']>;
};

export type FormFieldDescriptorInput = {
  agentText?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<FieldTypedReplaceableValueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['FormFieldUrn']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredForAgent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  requestorText?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<FormFieldOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  type: FormFieldType;
  userGroupIds?: InputMaybe<Array<Scalars['UserGroupUrn']['input']>>;
  visibility: FormFieldVisibility;
};

export type FormFieldOption = {
  __typename?: 'FormFieldOption';
  children?: Maybe<Array<FormFieldOption>>;
  description?: Maybe<Scalars['String']['output']>;
  dynamicChoiceContext?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FormFieldOptionInput = {
  children?: InputMaybe<Array<FormFieldOptionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicChoiceContext?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldOptionSettings = {
  __typename?: 'FormFieldOptionSettings';
  dynamicChoiceContext?: Maybe<Scalars['String']['output']>;
  emptyOptionsMessage?: Maybe<Scalars['String']['output']>;
};

export type FormFieldReplacement = {
  __typename?: 'FormFieldReplacement';
  fieldId: Scalars['Urn']['output'];
  groupId: Scalars['Urn']['output'];
  replacement: Scalars['String']['output'];
};

export type FormFieldReplacementInput = {
  fieldId: Scalars['Urn']['input'];
  groupId: Scalars['Urn']['input'];
  replacement: Scalars['String']['input'];
};

export type FormFieldTemplate = {
  __typename?: 'FormFieldTemplate';
  parameters?: Maybe<Array<FormFieldTemplateParameter>>;
  template?: Maybe<Scalars['String']['output']>;
};

export type FormFieldTemplateParameter = {
  __typename?: 'FormFieldTemplateParameter';
  key?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

/** Represents the status of the ticket */
export enum FormFieldType {
  AsyncDropdown = 'ASYNC_DROPDOWN',
  Boolean = 'BOOLEAN',
  Checkboxes = 'CHECKBOXES',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Decimal = 'DECIMAL',
  Dropdown = 'DROPDOWN',
  Json = 'JSON',
  LongText = 'LONG_TEXT',
  MultiLevelDropdown = 'MULTI_LEVEL_DROPDOWN',
  MultiSelectDropdown = 'MULTI_SELECT_DROPDOWN',
  Number = 'NUMBER',
  Password = 'PASSWORD',
  SearchText = 'SEARCH_TEXT',
  Text = 'TEXT',
  Time = 'TIME',
  User = 'USER',
  Users = 'USERS'
}

/** Visibility type for a form field. */
export enum FormFieldVisibility {
  Private = 'PRIVATE',
  Reusable = 'REUSABLE'
}

export type FormInput = {
  actionSettings?: InputMaybe<ActionSettingsInput>;
  approvals?: InputMaybe<Array<ApprovalInput>>;
  deflection?: InputMaybe<FormDeflectionSettingsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalFormId?: InputMaybe<Scalars['FormExternalUrn']['input']>;
  fields: Array<FormFieldDescriptorInput>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  isCreatePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  jobFunctions?: InputMaybe<Array<JobFunction>>;
  name: Scalars['String']['input'];
  shouldCreateOnOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<FormType>;
  userGroupIds?: InputMaybe<Array<Scalars['UserGroupUrn']['input']>>;
  workflowId?: InputMaybe<Scalars['WorkflowUrn']['input']>;
};

/** Type of form */
export enum FormType {
  Action = 'ACTION',
  Default = 'DEFAULT',
  InboundWebhook = 'INBOUND_WEBHOOK',
  Template = 'TEMPLATE'
}

export type FormWebhookExample = {
  __typename?: 'FormWebhookExample';
  body?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['Map']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

/** The type of handle */
export enum HandleType {
  Email = 'EMAIL',
  Github = 'GITHUB',
  Intercom = 'INTERCOM',
  Microsoft = 'MICROSOFT',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  Phone = 'PHONE',
  RocketChat = 'ROCKET_CHAT',
  ScimExternalId = 'SCIM_EXTERNAL_ID',
  Slack = 'SLACK',
  Zendesk = 'ZENDESK'
}

export type HoldInput = {
  /** Any additional notes. */
  note?: InputMaybe<Scalars['String']['input']>;
};

export type HolidayCountry = {
  __typename?: 'HolidayCountry';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HoursOfOperations = {
  __typename?: 'HoursOfOperations';
  dayOfWeek?: Maybe<DayOfWeek>;
  endMinute?: Maybe<Scalars['Float']['output']>;
  startMinute?: Maybe<Scalars['Float']['output']>;
};

export type HoursOfOperationsInput = {
  dayOfWeek?: InputMaybe<DayOfWeek>;
  endMinute?: InputMaybe<Scalars['Float']['input']>;
  startMinute?: InputMaybe<Scalars['Float']['input']>;
};

export type HubData = {
  __typename?: 'HubData';
  isSameAsSource: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type HubSpokeDisable = {
  sourceId?: InputMaybe<Scalars['Urn']['input']>;
};

export type HubSpokeEnable = {
  destinationToken: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['Urn']['input']>;
};

export type HubSpokeStatus = {
  __typename?: 'HubSpokeStatus';
  forwardedFrom: Array<HubSpokeStatusForward>;
  forwardingTo?: Maybe<HubSpokeStatusForward>;
};

export type HubSpokeStatusForward = {
  __typename?: 'HubSpokeStatusForward';
  id: Scalars['Urn']['output'];
  name: Scalars['String']['output'];
};

export type HubSpokeToken = {
  __typename?: 'HubSpokeToken';
  token?: Maybe<Scalars['String']['output']>;
};

/** Identity provider */
export enum IdentityProvider {
  Google = 'GOOGLE',
  Slack = 'SLACK'
}

export type IdentityProviderInput = {
  provider: IdentityProvider;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityProviderOptions = {
  __typename?: 'IdentityProviderOptions';
  url: Scalars['String']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  actionPermissions?: Maybe<Array<IntegrationActionGroupPermission>>;
  actions?: Maybe<Array<IntegrationActionType>>;
  id: Scalars['IntegrationUrn']['output'];
  label: Scalars['String']['output'];
  settings?: Maybe<Array<FieldTypedValue>>;
  type?: Maybe<IntegrationType>;
};

export type IntegrationActionGroupPermission = {
  __typename?: 'IntegrationActionGroupPermission';
  action: IntegrationActionType;
  groupIds: Array<Scalars['UserGroupUrn']['output']>;
};

export type IntegrationActionGroupPermissionInput = {
  action: IntegrationActionType;
  groupIds: Array<Scalars['UserGroupUrn']['input']>;
};

/** The types of actions that this integration can form */
export enum IntegrationActionType {
  AnswerProvider = 'ANSWER_PROVIDER',
  ArticleProvider = 'ARTICLE_PROVIDER',
  CreateTicket = 'CREATE_TICKET',
  Execute = 'EXECUTE',
  UserDataProvider = 'USER_DATA_PROVIDER'
}

export type IntegrationData = {
  __typename?: 'IntegrationData';
  groups: Array<IntegrationDataValueGroup>;
  id: Scalars['Urn']['output'];
  label: Scalars['String']['output'];
  sourceIdentity: Scalars['Urn']['output'];
  type?: Maybe<IntegrationType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type IntegrationDataValue = {
  __typename?: 'IntegrationDataValue';
  isDefaultDisplayed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: IntegrationValueType;
  value?: Maybe<Scalars['String']['output']>;
};

export type IntegrationDataValueGroup = {
  __typename?: 'IntegrationDataValueGroup';
  label: Scalars['String']['output'];
  links?: Maybe<Array<IntegrationDataValueLink>>;
  values: Array<IntegrationDataValue>;
};

export type IntegrationDataValueLink = {
  __typename?: 'IntegrationDataValueLink';
  icon: IntegrationValueLinkIcon;
  label?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type IntegrationSettingsInput = {
  actionPermissions?: InputMaybe<Array<IntegrationActionGroupPermissionInput>>;
  id: Scalars['IntegrationUrn']['input'];
  settings?: InputMaybe<Array<FieldTypedValueInput>>;
};

/** The type of integration */
export enum IntegrationType {
  Approvals = 'APPROVALS',
  Atlassian = 'ATLASSIAN',
  Freshdesk = 'FRESHDESK',
  Github = 'GITHUB',
  GithubApp = 'GITHUB_APP',
  Hubspot = 'HUBSPOT',
  Integromat = 'INTEGROMAT',
  Intercom = 'INTERCOM',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  Okta = 'OKTA',
  OneLogin = 'ONE_LOGIN',
  RocketChat = 'ROCKET_CHAT',
  Salesforce = 'SALESFORCE',
  Service = 'SERVICE',
  ServiceNow = 'SERVICE_NOW',
  Slack = 'SLACK',
  SlackAgent = 'SLACK_AGENT',
  SlackBot = 'SLACK_BOT',
  Workato = 'WORKATO',
  Zapier = 'ZAPIER',
  Zendesk = 'ZENDESK'
}

/** The of icon controlling the integration */
export enum IntegrationValueLinkIcon {
  External = 'EXTERNAL',
  Facebook = 'FACEBOOK',
  Linkedin = 'LINKEDIN',
  Profile = 'PROFILE',
  Twitter = 'TWITTER'
}

/** The type of integration */
export enum IntegrationValueType {
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Email = 'EMAIL',
  Link = 'LINK',
  Phone = 'PHONE',
  Text = 'TEXT',
  Time = 'TIME',
  Timezone = 'TIMEZONE'
}

export type IntegrationView = {
  __typename?: 'IntegrationView';
  fields: Array<FormField>;
  id: Scalars['IntegrationUrn']['output'];
  submit: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type IntergrationFormSubmit = {
  id?: InputMaybe<Scalars['Urn']['input']>;
  values?: InputMaybe<Array<FieldTypedValueInput>>;
};

/** The type of user job function */
export enum JobFunction {
  CustomerSuccess = 'CUSTOMER_SUCCESS',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  Engineering = 'ENGINEERING',
  Finance = 'FINANCE',
  Founder = 'FOUNDER',
  HumanResources = 'HUMAN_RESOURCES',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Legal = 'LEGAL',
  Other = 'OTHER',
  OtherInternal = 'OTHER_INTERNAL',
  Partnerships = 'PARTNERSHIPS',
  Product = 'PRODUCT',
  RevenueOperations = 'REVENUE_OPERATIONS',
  Sales = 'SALES',
  Security = 'SECURITY'
}

export type LogErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['Map']['input']>;
  innerError?: InputMaybe<LogErrorInput>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stack: Scalars['String']['input'];
};

/** Log levels */
export enum LogLevel {
  /** Default log level */
  Debug = 'DEBUG',
  /** An error occured */
  Error = 'ERROR',
  /** A fatal error occured */
  Fatal = 'FATAL',
  /** Something informational */
  Info = 'INFO',
  /** Helpful for tracing */
  Trace = 'TRACE',
  /** Something problematic that is not an error. */
  Warning = 'WARNING'
}

export type LogLineInput = {
  applicationSessionId: Scalars['String']['input'];
  component?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['Map']['input']>;
  error?: InputMaybe<LogErrorInput>;
  level: LogLevel;
  message: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type LoginError = {
  __typename?: 'LoginError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LoginResult = LoginError | Session;

/** The type of login possible for the user. */
export enum LoginType {
  Enabled = 'ENABLED',
  None = 'NONE'
}

export type LogsInput = {
  lines?: InputMaybe<Array<LogLineInput>>;
};

export type MetricsDashboard = {
  __typename?: 'MetricsDashboard';
  creator: User;
  creatorId: Scalars['Urn']['output'];
  id: Scalars['MetricsDashboardUrn']['output'];
  installationId: Scalars['AppInstallUrn']['output'];
  name: Scalars['String']['output'];
  settings: MetricsDashboardSettings;
};

export type MetricsDashboardData = {
  __typename?: 'MetricsDashboardData';
  columns: Array<MetricsDashboardDataColumn>;
  dataSource?: Maybe<MetricsDashboardGraphDataSource>;
  labels: Array<MetricsDashboardDataLabel>;
  rows: Array<MetricsDashboardDataRow>;
};

export type MetricsDashboardDataColumn = {
  __typename?: 'MetricsDashboardDataColumn';
  field: FormField;
  id: Scalars['FormFieldUrn']['output'];
};

export type MetricsDashboardDataLabel = {
  __typename?: 'MetricsDashboardDataLabel';
  fieldId: Scalars['FormFieldUrn']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type MetricsDashboardDataRow = {
  __typename?: 'MetricsDashboardDataRow';
  id: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type MetricsDashboardGraph = {
  __typename?: 'MetricsDashboardGraph';
  dataSource: MetricsDashboardGraphDataSource;
  dimensions?: Maybe<Array<MetricsDashboardGraphDimension>>;
  filters?: Maybe<Array<MetricsDashboardGraphFilter>>;
  height: Scalars['Float']['output'];
  locationX: Scalars['Float']['output'];
  locationY: Scalars['Float']['output'];
  metrics?: Maybe<Array<MetricsDashboardGraphMetric>>;
  sort?: Maybe<Array<MetricsDashboardGraphSort>>;
  title: Scalars['String']['output'];
  type: MetricsDashboardGraphType;
  width: Scalars['Float']['output'];
};

/** Data Source */
export enum MetricsDashboardGraphDataSource {
  Feedback = 'FEEDBACK',
  Sla = 'SLA',
  Tags = 'TAGS',
  Tickets = 'TICKETS'
}

export type MetricsDashboardGraphDimension = {
  __typename?: 'MetricsDashboardGraphDimension';
  fieldId: Scalars['FormFieldUrn']['output'];
  format?: Maybe<MetricsDashboardGraphDimensionFormat>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Dashboard graph dimension format */
export enum MetricsDashboardGraphDimensionFormat {
  Year = 'YEAR',
  YearMonth = 'YEAR_MONTH',
  YearMonthDay = 'YEAR_MONTH_DAY',
  YearMonthDayHour = 'YEAR_MONTH_DAY_HOUR',
  YearMonthDayHourMinute = 'YEAR_MONTH_DAY_HOUR_MINUTE'
}

export type MetricsDashboardGraphFilter = {
  __typename?: 'MetricsDashboardGraphFilter';
  comparer?: Maybe<MetricsDashboardGraphFilterComparer>;
  fieldId: Scalars['FormFieldUrn']['output'];
  value?: Maybe<FieldTypedValueBase>;
};

/** Dashboard graph filter comparsion */
export enum MetricsDashboardGraphFilterComparer {
  BeginsWith = 'BEGINS_WITH',
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  HasAttribute = 'HAS_ATTRIBUTE',
  In = 'IN',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN',
  NoAttribute = 'NO_ATTRIBUTE'
}

export type MetricsDashboardGraphMetric = {
  __typename?: 'MetricsDashboardGraphMetric';
  aggregation: MetricsDashboardGraphTypeAggregation;
  display: MetricsDashboardGraphTypeDisplayType;
  fieldId: Scalars['FormFieldUrn']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type MetricsDashboardGraphSort = {
  __typename?: 'MetricsDashboardGraphSort';
  direction: MetricsDashboardSortDirection;
  fieldId: Scalars['FormFieldUrn']['output'];
};

/** Dashboard graph type */
export enum MetricsDashboardGraphType {
  Count = 'COUNT',
  PieChart = 'PIE_CHART',
  Table = 'TABLE',
  TimeSeries = 'TIME_SERIES'
}

/** Dashboard graph metric aggregation */
export enum MetricsDashboardGraphTypeAggregation {
  Average = 'AVERAGE',
  Count = 'COUNT',
  CountDistinct = 'COUNT_DISTINCT',
  Max = 'MAX',
  Median = 'MEDIAN',
  Min = 'MIN',
  Sum = 'SUM'
}

/** Dashboard graph display type */
export enum MetricsDashboardGraphTypeDisplayType {
  Currency = 'CURRENCY',
  Duration = 'DURATION',
  Float = 'FLOAT',
  Number = 'NUMBER',
  Percentage = 'PERCENTAGE'
}

export type MetricsDashboardSettings = {
  __typename?: 'MetricsDashboardSettings';
  graphs: Array<MetricsDashboardGraph>;
};

/** Dashboard graph sort direction */
export enum MetricsDashboardSortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type MetricsDashboardWithData = {
  __typename?: 'MetricsDashboardWithData';
  dashboard: MetricsDashboard;
  data: Array<MetricsDashboardData>;
};

export type MetricsInput = {
  /** Assignee ids to filter by. */
  assigneeIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  /** Date when to stop filtering. If not specified, goes until today. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Request form ids to filter by. */
  formIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  id?: InputMaybe<Scalars['MetricsDashboardUrn']['input']>;
  /** Priorities to filter by. */
  priorities?: InputMaybe<Array<TicketPriority>>;
  /** Queue ids to filter by. */
  queueIds?: InputMaybe<Array<Scalars['QueueUrn']['input']>>;
  /** Requester ids to filter by. */
  requesterIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  /** Channel or email source Ids */
  sourceIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  startDate: Scalars['DateTime']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Gets action data */
  actionUpdate?: Maybe<Action>;
  /** Adds an email alias and sends a email validation request.. */
  addEmailAlias?: Maybe<OkResult>;
  /** Adds participants to a chat */
  addParticipants?: Maybe<OkResult>;
  /** Associates a domain name with a portal. */
  addPortalDomain: OkResult;
  /** Adds a reaction to a message */
  addReaction?: Maybe<OkResult>;
  /** Marks a set of chats as read. */
  addTicketStateId: OkResult;
  /** Stores if the article was helpful or not.. */
  articleSearchFeedback: OkResult;
  /** Assigns a set of chats */
  assignChats?: Maybe<OkResult>;
  /** Clones an existing form and automation */
  cloneForm: Form;
  /** Adds an email alias and sends a email validation request.. */
  createChannelTag?: Maybe<ChannelTagCreated>;
  /** Adds a ticket message or comment to the given ticket. */
  createTicketMessage: TicketMessage;
  /** Creates a new developer token */
  createToken: TokenResponse;
  /** Creates an upload token. */
  createUploadToken?: Maybe<AttachmentCreated>;
  /** Deletes an article by article id. */
  deleteArticle: OkResult;
  /** Deletes an article by article id. */
  deleteArticleTag: OkResult;
  /** Deletes a channel invite. */
  deleteChannelInvite?: Maybe<OkResult>;
  /** Deletes a single channel tag. */
  deleteChatSettings: OkResult;
  /** Deletes a company by company id. */
  deleteCompany: OkResult;
  /** Stores agent ticket settings. */
  deleteEmailAlias?: Maybe<OkResult>;
  /** Deletes a form. */
  deleteForm: OkResult;
  /** Deletes a form field. */
  deleteFormField: OkResult;
  /** Deletes a message */
  deleteMessage?: Maybe<OkResult>;
  /** Deletes a queue. */
  deleteQueue: OkResult;
  /** Deletes an user by user id. */
  deleteUser: OkResult;
  /** Deletes a user group. */
  deleteUserGroup: OkResult;
  /** Disables Hub+Spoke on a source channel or install */
  disableHubAndSpoke?: Maybe<OkResult>;
  /** Registers type */
  dummyRegisterCondition?: Maybe<OkResult>;
  /** Registers type */
  dummyRegisterCondition2?: Maybe<OkResult>;
  /** Edits a message */
  editMessage?: Maybe<OkResult>;
  /** Enables Hub+Spoke on a source channel or install */
  enableHubAndSpoke?: Maybe<OkResult>;
  /** Ends a set of chats */
  endChats?: Maybe<OkResult>;
  /** Executes an custom ticket action. */
  executeTicketAction: OkResult;
  /** Starts the onboarding script that sets up a bunch of resources. */
  finishOnboarding?: Maybe<OkResult>;
  /** Creates a login token used for migration between domains */
  getMigrationToken: TokenMigrationToken;
  /** Puts chats into hold */
  holdChats?: Maybe<OkResult>;
  /** Ignores a chat */
  ignoreChats?: Maybe<OkResult>;
  /** Saves integration settings. */
  integrationSaveSettings: OkResult;
  /** Submits the integration. */
  integrationSubmit: OkResult;
  /** Removes the current user from participating in a chat. */
  leaveParticipant?: Maybe<OkResult>;
  /** Allows a user to login */
  login: LoginResult;
  /** Allows a user to login with a password reset or new user token. */
  loginWithToken: LoginResult;
  /** Logs the user out and kills their current session. */
  logout: OkResult;
  /** Marks a set of chats as read. */
  markRead: OkResult;
  /** Marks a set of chats as unread. */
  markUnread: OkResult;
  /** Publishes the article and makes it public. */
  publishArticle: OkResult;
  /** Adds a reaction to a message */
  removeReaction?: Maybe<OkResult>;
  /** Reopens the a chat after its been closed. */
  reopenChats?: Maybe<OkResult>;
  /** Runs the integration. */
  runIntegration?: Maybe<IntegrationView>;
  /** Store an article by saving changes to an existing one or by creating a new article. */
  saveArticle: Article;
  /** Store an article by saving changes to an existing one or by creating a new article. */
  saveArticleTag: ArticleTag;
  /** Creates an AI Summary of the conversation */
  saveArtificialIntelligenceSettings?: Maybe<OkResult>;
  /** Creates a new channel invite or saves an existing one. */
  saveChannelInvite?: Maybe<ChannelInvite>;
  /** Saves changes to chat settings. */
  saveChatSettings: OkResult;
  /** Save an organization */
  saveCompany: Company;
  /** Saves the default queue */
  saveDefaultQueue: OkResult;
  /** Saves a custom form */
  saveForm: Form;
  /** Creates a form field. */
  saveFormField: FormField;
  /** Adds an email alias and sends a email validation request.. */
  saveOnboardingProfile?: Maybe<OnboardingProfile>;
  /** Store an portal by saving changes to an existing one or by creating a new portal. */
  savePortal: Portal;
  /** Saves the queue */
  saveQueue: Queue;
  /** Stores agent ticket settings. */
  saveSettings?: Maybe<OkResult>;
  /** Creates a ticket associated with the current user and portal. */
  saveTicket: Ticket;
  /** stores a ticket note */
  saveTicketNote?: Maybe<OkResult>;
  /** Adds a ticket message or comment to the given ticket. */
  saveTicketState: TicketState;
  /** Updates the ticket task status */
  saveTicketStateStatus: OkResult;
  /** Creates a ticket associated with the current user and portal. */
  saveUser: User;
  /** Saves the group */
  saveUserGroup: UserGroup;
  /** Stores settings associated with this user. */
  saveUserSettings: UserSettings;
  /** Returns the latest version of the given workflow. */
  saveWorkflow?: Maybe<Workflow>;
  /** Sends a channel invite to the specified email. */
  sendChannelInvite?: Maybe<OkResult>;
  /** Sends a message */
  sendMessage?: Maybe<TicketMessage>;
  /** Sends a slack connect email to the user on file. This can be only done once per installation. */
  sendSupportSlackConnectChannel?: Maybe<SupportChannel>;
  /** Sets the default article that will be the first one seen */
  setIndexArticle: OkResult;
  /** Sets a role for the set of users. */
  setUsersRole?: Maybe<OkResult>;
  /** Snoozes a chat for a certain amount of time */
  snoozeChats?: Maybe<OkResult>;
  /** Stores the sort order for the chats. */
  sortChats: OkResult;
  /** Sends a message to one or more channels */
  startChat?: Maybe<OkResult>;
  /** Stores a log message */
  storeLogs: OkResult;
  /** Sends a message */
  storeMessageDraft?: Maybe<TicketMessage>;
  /** Gets a token and url for the socket. */
  subscribe: SessionSocketConnection;
  /** Removes chats from hold */
  unholdChats?: Maybe<OkResult>;
  /** Unpublishes an already published article and makes it private. */
  unpublishArticle: OkResult;
  /** Unsnoozes the chat right away. */
  unsnoozeChats?: Maybe<OkResult>;
  /** Creates a ticket associated with the current user and portal. */
  updateDashboard: OkResult;
  /** Signs a webhook url based on the workflow step. */
  workflowServiceCreateWebhook: WorkflowServiceSignedWebhook;
  /** Installs the workflow service. */
  workflowServiceInstall: WorkflowServiceInstallResult;
  /** Removes the workflow service. */
  workflowServiceUninstall: OkResult;
};


export type MutationActionUpdateArgs = {
  input: ActionInput;
};


export type MutationAddEmailAliasArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddParticipantsArgs = {
  participants: Array<ChatAddParticipantInput>;
};


export type MutationAddPortalDomainArgs = {
  hostname: Scalars['String']['input'];
  portalId?: InputMaybe<Scalars['PortalUrn']['input']>;
};


export type MutationAddReactionArgs = {
  reaction: TicketMessageReactionInput;
};


export type MutationAddTicketStateIdArgs = {
  chatIds: Array<Scalars['Urn']['input']>;
  stateId: Scalars['TicketStateUrn']['input'];
};


export type MutationArticleSearchFeedbackArgs = {
  feedback: ArticleFeedbackType;
  portalId?: InputMaybe<Scalars['PortalUrn']['input']>;
};


export type MutationAssignChatsArgs = {
  assignment?: InputMaybe<ChatAssignInput>;
  ids: Array<Scalars['Urn']['input']>;
};


export type MutationCloneFormArgs = {
  id?: InputMaybe<Scalars['FormUrn']['input']>;
  options?: InputMaybe<FormCloneInput>;
};


export type MutationCreateChannelTagArgs = {
  channelTag: ChannelTagCreateInput;
};


export type MutationCreateTicketMessageArgs = {
  ticketId: Scalars['TicketUrn']['input'];
  ticketMessage: TicketMessageInput;
};


export type MutationCreateTokenArgs = {
  token: TokenRequestInput;
};


export type MutationCreateUploadTokenArgs = {
  attachment: AttachmentCreateInput;
};


export type MutationDeleteArticleArgs = {
  id?: InputMaybe<Scalars['ArticleUrn']['input']>;
};


export type MutationDeleteArticleTagArgs = {
  id?: InputMaybe<Scalars['ArticleTagUrn']['input']>;
};


export type MutationDeleteChannelInviteArgs = {
  id: Scalars['ChannelInviteUrn']['input'];
};


export type MutationDeleteChatSettingsArgs = {
  id: Scalars['Urn']['input'];
};


export type MutationDeleteCompanyArgs = {
  id?: InputMaybe<Scalars['CompanyUrn']['input']>;
};


export type MutationDeleteEmailAliasArgs = {
  id: Scalars['ChannelEmailUrn']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['FormUrn']['input'];
};


export type MutationDeleteFormFieldArgs = {
  id: Scalars['FormFieldUrn']['input'];
};


export type MutationDeleteMessageArgs = {
  ticketMessageId: Scalars['TicketMessageUrn']['input'];
};


export type MutationDeleteQueueArgs = {
  id: Scalars['QueueUrn']['input'];
};


export type MutationDeleteUserArgs = {
  id?: InputMaybe<Scalars['UserUrn']['input']>;
};


export type MutationDeleteUserGroupArgs = {
  id: Scalars['UserGroupUrn']['input'];
};


export type MutationDisableHubAndSpokeArgs = {
  settings: HubSpokeDisable;
};


export type MutationDummyRegisterConditionArgs = {
  approvalFormValue: ApprovalFormInput;
  condition: WorkflowCondition;
  conditionValue: WorkflowConditionMapping;
  functionValue: WorkflowFunctionWithParameters;
  stepParameter: WorkflowStepKeyValueParameterInput;
};


export type MutationEditMessageArgs = {
  message: TicketEditMessageInput;
  ticketMessageId: Scalars['TicketMessageUrn']['input'];
};


export type MutationEnableHubAndSpokeArgs = {
  settings: HubSpokeEnable;
};


export type MutationEndChatsArgs = {
  chatEndMessages: Array<ChatEndInput>;
};


export type MutationExecuteTicketActionArgs = {
  action: TicketInput;
  id?: InputMaybe<Scalars['Urn']['input']>;
};


export type MutationHoldChatsArgs = {
  ids: Array<Scalars['Urn']['input']>;
  options: HoldInput;
};


export type MutationIgnoreChatsArgs = {
  ids: Array<Scalars['Urn']['input']>;
};


export type MutationIntegrationSaveSettingsArgs = {
  settings: IntegrationSettingsInput;
};


export type MutationIntegrationSubmitArgs = {
  chatId: Scalars['Urn']['input'];
  form: IntergrationFormSubmit;
  integrationId: Scalars['IntegrationUrn']['input'];
};


export type MutationLeaveParticipantArgs = {
  participant: ChatLeaveParticipantInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationMarkReadArgs = {
  chatIds: Array<Scalars['Urn']['input']>;
};


export type MutationMarkUnreadArgs = {
  chatIds: Array<Scalars['Urn']['input']>;
};


export type MutationPublishArticleArgs = {
  id?: InputMaybe<Scalars['ArticleUrn']['input']>;
  settings?: InputMaybe<ArticlePublishInput>;
};


export type MutationRemoveReactionArgs = {
  reaction: TicketMessageReactionInput;
};


export type MutationReopenChatsArgs = {
  ids: Array<Scalars['Urn']['input']>;
};


export type MutationRunIntegrationArgs = {
  chatId: Scalars['Urn']['input'];
  currentValues?: InputMaybe<Array<FieldTypedValueInput>>;
  formId?: InputMaybe<Scalars['Urn']['input']>;
  integrationId: Scalars['IntegrationUrn']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<DisplayFormSource>;
};


export type MutationSaveArticleArgs = {
  article: ArticleInput;
  id?: InputMaybe<Scalars['ArticleUrn']['input']>;
};


export type MutationSaveArticleTagArgs = {
  articleTag: ArticleTagInput;
  id?: InputMaybe<Scalars['ArticleTagUrn']['input']>;
  parentId?: InputMaybe<Scalars['ArticleTagUrn']['input']>;
};


export type MutationSaveArtificialIntelligenceSettingsArgs = {
  settings: ArtificialIntelligenceSettingsInput;
};


export type MutationSaveChannelInviteArgs = {
  id?: InputMaybe<Scalars['ChannelInviteUrn']['input']>;
  invite: ChannelInviteInput;
};


export type MutationSaveChatSettingsArgs = {
  id: Scalars['Urn']['input'];
  settings: ChatSettingsInput;
};


export type MutationSaveCompanyArgs = {
  company: CompanyInput;
  id?: InputMaybe<Scalars['CompanyUrn']['input']>;
};


export type MutationSaveDefaultQueueArgs = {
  id?: InputMaybe<Scalars['QueueUrn']['input']>;
};


export type MutationSaveFormArgs = {
  form: FormInput;
  id?: InputMaybe<Scalars['FormUrn']['input']>;
};


export type MutationSaveFormFieldArgs = {
  formField: FormFieldInput;
  id?: InputMaybe<Scalars['FormFieldUrn']['input']>;
};


export type MutationSaveOnboardingProfileArgs = {
  profile: OnboardingProfileInput;
};


export type MutationSavePortalArgs = {
  appInstallId?: InputMaybe<Scalars['AppInstallUrn']['input']>;
  companyId?: InputMaybe<Scalars['CompanyUrn']['input']>;
  id?: InputMaybe<Scalars['PortalUrn']['input']>;
  portal: PortalSettingsInput;
};


export type MutationSaveQueueArgs = {
  id?: InputMaybe<Scalars['QueueUrn']['input']>;
  queue: QueueInput;
};


export type MutationSaveSettingsArgs = {
  artificialIntelligence?: InputMaybe<SettingsArtificialIntelligenceInput>;
  channelEmail?: InputMaybe<SettingsChannelEmailInput>;
  channelSlack?: InputMaybe<SettingsChannelSlackInput>;
  channelWebChat?: InputMaybe<SettingsChannelWebChatInput>;
  channels?: InputMaybe<SettingsChannelsInput>;
  customization?: InputMaybe<SettingsCustomizationInput>;
  feedback?: InputMaybe<FeedbackInput>;
  identities?: InputMaybe<Array<Scalars['Urn']['input']>>;
  sla?: InputMaybe<SettingsSlaInput>;
  time?: InputMaybe<SettingsTimeInput>;
};


export type MutationSaveTicketArgs = {
  id?: InputMaybe<Scalars['TicketUrn']['input']>;
  ticket: TicketInput;
};


export type MutationSaveTicketNoteArgs = {
  chatId: Scalars['Urn']['input'];
  message: TicketNoteInput;
};


export type MutationSaveTicketStateArgs = {
  id?: InputMaybe<Scalars['TicketStateUrn']['input']>;
  state: TicketStateInput;
};


export type MutationSaveTicketStateStatusArgs = {
  id: Scalars['TicketTaskUrn']['input'];
  state: TicketTaskState;
};


export type MutationSaveUserArgs = {
  id?: InputMaybe<Scalars['Urn']['input']>;
  user: UserInput;
};


export type MutationSaveUserGroupArgs = {
  id?: InputMaybe<Scalars['UserGroupUrn']['input']>;
  userGroup: UserGroupInput;
};


export type MutationSaveUserSettingsArgs = {
  settings: UserSettingsInput;
};


export type MutationSaveWorkflowArgs = {
  id?: InputMaybe<Scalars['WorkflowUrn']['input']>;
  referenceId?: InputMaybe<Scalars['Urn']['input']>;
  workflow: WorkflowInput;
};


export type MutationSendChannelInviteArgs = {
  invite: SendChannelInviteInput;
};


export type MutationSendMessageArgs = {
  chatId: Scalars['Urn']['input'];
  message: TicketMessageInput;
};


export type MutationSetIndexArticleArgs = {
  id?: InputMaybe<Scalars['ArticleUrn']['input']>;
};


export type MutationSetUsersRoleArgs = {
  ids: Array<Scalars['Urn']['input']>;
  role: UserRole;
};


export type MutationSnoozeChatsArgs = {
  ids: Array<Scalars['Urn']['input']>;
  options: SnoozeInput;
};


export type MutationSortChatsArgs = {
  chats: ChatSortInput;
};


export type MutationStartChatArgs = {
  message: StartChatInput;
};


export type MutationStoreLogsArgs = {
  logs: LogsInput;
};


export type MutationStoreMessageDraftArgs = {
  chatId: Scalars['Urn']['input'];
  message: TicketMessageInput;
};


export type MutationUnholdChatsArgs = {
  ids: Array<Scalars['Urn']['input']>;
  options: HoldInput;
};


export type MutationUnpublishArticleArgs = {
  id?: InputMaybe<Scalars['ArticleUrn']['input']>;
};


export type MutationUnsnoozeChatsArgs = {
  ids: Array<Scalars['Urn']['input']>;
  options: SnoozeInput;
};


export type MutationUpdateDashboardArgs = {
  dashboard: DashboardInput;
  id?: InputMaybe<Scalars['DashboardUrn']['input']>;
};


export type MutationWorkflowServiceCreateWebhookArgs = {
  properties?: InputMaybe<WorkflowServiceWebhookRequest>;
  stepId: Scalars['WorkflowStepUrn']['input'];
};


export type MutationWorkflowServiceInstallArgs = {
  install: WorkflowServiceInstallInput;
};


export type MutationWorkflowServiceUninstallArgs = {
  integrationId: Scalars['IntegrationUrn']['input'];
};

export type OkResult = {
  __typename?: 'OkResult';
  /** Returns if the operation was successful. */
  ok: Scalars['Boolean']['output'];
};

export type OnboardingProfile = {
  __typename?: 'OnboardingProfile';
  applicationIconUrl?: Maybe<Scalars['String']['output']>;
  applicationName?: Maybe<Scalars['String']['output']>;
  channelMode?: Maybe<ChannelMode>;
  homeStepsCompleted?: Maybe<Array<Scalars['String']['output']>>;
  installedWorkflowServiceId?: Maybe<Scalars['WorkflowServiceUrn']['output']>;
  isChannelMenuEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEmojiEnabled?: Maybe<Scalars['Boolean']['output']>;
  isExternalSupport?: Maybe<Scalars['Boolean']['output']>;
  isSelectedFoqalTicketing?: Maybe<Scalars['Boolean']['output']>;
  jobFunction?: Maybe<JobFunction>;
  lastStep?: Maybe<OnboardingStep>;
};

export type OnboardingProfileInput = {
  applicationIconUrl?: InputMaybe<Scalars['String']['input']>;
  applicationName?: InputMaybe<Scalars['String']['input']>;
  channelMode?: InputMaybe<ChannelMode>;
  homeStepsCompleted?: InputMaybe<Array<Scalars['String']['input']>>;
  installedWorkflowServiceId?: InputMaybe<Scalars['WorkflowServiceUrn']['input']>;
  isChannelMenuEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEmojiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectedFoqalTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  jobFunction?: InputMaybe<JobFunction>;
  lastStep?: InputMaybe<OnboardingStep>;
};

/** Step executed by onboarding */
export enum OnboardingStep {
  ContactMode = 'CONTACT_MODE',
  PickRole = 'PICK_ROLE'
}

/** Types of permissions */
export enum Permission {
  Administrator = 'ADMINISTRATOR',
  AdministratorReports = 'ADMINISTRATOR_REPORTS',
  ArticleModify = 'ARTICLE_MODIFY',
  ArticleRead = 'ARTICLE_READ',
  ArticleReadPublic = 'ARTICLE_READ_PUBLIC',
  Campaigns = 'CAMPAIGNS',
  ChatsModify = 'CHATS_MODIFY',
  ChatsModifyAll = 'CHATS_MODIFY_ALL',
  ChatsRead = 'CHATS_READ',
  ChatsReadAll = 'CHATS_READ_ALL',
  FetchEmails = 'FETCH_EMAILS',
  GroupsRead = 'GROUPS_READ',
  GroupsWrite = 'GROUPS_WRITE',
  Login = 'LOGIN',
  QuestionAnswer = 'QUESTION_ANSWER',
  ReadIntegration = 'READ_INTEGRATION',
  RegisterIntegration = 'REGISTER_INTEGRATION',
  Reports = 'REPORTS',
  SendCampaigns = 'SEND_CAMPAIGNS',
  SuperAdmin = 'SUPER_ADMIN',
  TicketsComment = 'TICKETS_COMMENT',
  TicketsModify = 'TICKETS_MODIFY',
  TicketsRead = 'TICKETS_READ',
  TicketsReadAll = 'TICKETS_READ_ALL',
  TicketsReadSelf = 'TICKETS_READ_SELF',
  TicketCreate = 'TICKET_CREATE',
  TicketCreateGuest = 'TICKET_CREATE_GUEST',
  TicketCreatePublic = 'TICKET_CREATE_PUBLIC',
  TicketStateModify = 'TICKET_STATE_MODIFY',
  UsersCreate = 'USERS_CREATE',
  UsersRead = 'USERS_READ',
  UsersWrite = 'USERS_WRITE'
}

/** Type of action that the user is able to perform. */
export enum PermissionAction {
  Execute = 'EXECUTE',
  Modify = 'MODIFY',
  Read = 'READ'
}

export type PingEvent = {
  __typename?: 'PingEvent';
  action: PortalEventType;
};

export type PongEvent = {
  __typename?: 'PongEvent';
  action: PortalEventType;
};

export type Portal = {
  __typename?: 'Portal';
  /** Banner message. */
  banner?: Maybe<PortalBanner>;
  /** Billing information. */
  billing?: Maybe<PortalBilling>;
  /** If a chat token is specified, use the token to configure the web chat. */
  chatToken?: Maybe<Scalars['String']['output']>;
  /** Portal domain names. */
  domains?: Maybe<Array<Scalars['String']['output']>>;
  /** The forms which are allowed to be created by logged in guests. */
  guestFormIds?: Maybe<Array<Scalars['FormUrn']['output']>>;
  /** The guest permissions allowed by this portal settings. */
  guestPermissions: Array<Permission>;
  /** Id of the portal. */
  id: Scalars['PortalUrn']['output'];
  /** The default page that should show when anyone goes to /answers. */
  indexArticleId?: Maybe<Scalars['ArticleUrn']['output']>;
  /** Whether AI module is enabled for this portal */
  isAIEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Should guests coming from a shared be considered guests or public? */
  isSharedChannelGuest?: Maybe<Scalars['Boolean']['output']>;
  /** Your users permissions associated with this portal. */
  permissions: Array<Permission>;
  /** If an index provier was selected. */
  portalIndexProvider?: Maybe<PortalIndexProvider>;
  /** The forms which are allowed to be created by the public. */
  publicFormIds?: Maybe<Array<Scalars['FormUrn']['output']>>;
  /** The public permissions allowed by this portal settings. */
  publicPermissions: Array<Permission>;
  /** Single Sign on Settings */
  singleSignOn?: Maybe<PortalSingleSignOn>;
  /** Title to display for the portal. */
  title?: Maybe<Scalars['String']['output']>;
  /** SCIM settings */
  userProvisioning?: Maybe<PortalUserProvisioning>;
  /** The welcome greeting. */
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type PortalBanner = {
  __typename?: 'PortalBanner';
  /** Banner expiration date. */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Link redirecting to. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The message to display. */
  message?: Maybe<Scalars['String']['output']>;
  /** The type of banner */
  type?: Maybe<PortalBannerType>;
};

/** The type of banner */
export enum PortalBannerType {
  Danger = 'DANGER',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type PortalBilling = {
  __typename?: 'PortalBilling';
  /** Has billing been setup */
  isSetup?: Maybe<Scalars['Boolean']['output']>;
  /** The number of purchased users. */
  purchasedUserCount?: Maybe<Scalars['Float']['output']>;
};

export type PortalBillingProfile = {
  __typename?: 'PortalBillingProfile';
  /** Current users email */
  currentUserEmail?: Maybe<Scalars['String']['output']>;
  /** Stripe Price table id */
  pricingTableId?: Maybe<Scalars['String']['output']>;
  /** Stripe Publishable key */
  publishableKey?: Maybe<Scalars['String']['output']>;
  /** Redirect URL to customer portal if already setup and need to redirect to management page. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** The unique customer session id used to validate requests from Stripe. */
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type PortalChatEvent = {
  __typename?: 'PortalChatEvent';
  action: PortalEventType;
  chat?: Maybe<Chat>;
  chatId: Scalars['Urn']['output'];
};

export type PortalChatResyncEvent = {
  __typename?: 'PortalChatResyncEvent';
  action: PortalEventType;
  chatId: Scalars['Urn']['output'];
};

export type PortalEvent = PingEvent | PongEvent | PortalChatEvent | PortalChatResyncEvent | PortalHoldEvent | PortalMessageEvent | PortalNoteAddedEvent | PortalParticipantEvent | PortalReactionEvent | PortalRegisterEvent | PortalSnoozeEvent | PortalSuccessEvent | PortalUserEvent;

/** The type of event being sent. */
export enum PortalEventType {
  ConversationAssigned = 'CONVERSATION_ASSIGNED',
  ConversationIgnored = 'CONVERSATION_IGNORED',
  ConversationNew = 'CONVERSATION_NEW',
  HoldStarted = 'HOLD_STARTED',
  HoldStopped = 'HOLD_STOPPED',
  MessageDeleted = 'MESSAGE_DELETED',
  MessageEdited = 'MESSAGE_EDITED',
  MessageNew = 'MESSAGE_NEW',
  NoteAdded = 'NOTE_ADDED',
  ParticipantsAdded = 'PARTICIPANTS_ADDED',
  ParticipantsRemoved = 'PARTICIPANTS_REMOVED',
  Ping = 'PING',
  Pong = 'PONG',
  ReactionAdded = 'REACTION_ADDED',
  ReactionRemoved = 'REACTION_REMOVED',
  Register = 'REGISTER',
  Resync = 'RESYNC',
  SnoozeStarted = 'SNOOZE_STARTED',
  SnoozeStopped = 'SNOOZE_STOPPED',
  Success = 'SUCCESS',
  UserConnected = 'USER_CONNECTED',
  UserDisconnected = 'USER_DISCONNECTED',
  UserReconnected = 'USER_RECONNECTED'
}

export type PortalHoldEvent = {
  __typename?: 'PortalHoldEvent';
  action: PortalEventType;
  chatId: Scalars['Urn']['output'];
};

/** Index used for portal */
export enum PortalIndexProvider {
  None = 'NONE',
  OpenAi = 'OPEN_AI'
}

export type PortalMessageAttachment = {
  __typename?: 'PortalMessageAttachment';
  altText: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PortalMessageEvent = {
  __typename?: 'PortalMessageEvent';
  action: PortalEventType;
  articles?: Maybe<Array<TicketMessageArticle>>;
  attachments?: Maybe<Array<PortalMessageAttachment>>;
  chatId: Scalars['Urn']['output'];
  date: Scalars['DateTime']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  message: RichBody;
  messageId: Scalars['Urn']['output'];
  originalBody?: Maybe<RichBody>;
  redactedDate?: Maybe<Scalars['DateTime']['output']>;
  sender?: Maybe<PortalSender>;
  type: TicketMessageType;
};

export type PortalNoteAddedEvent = {
  __typename?: 'PortalNoteAddedEvent';
  action: PortalEventType;
  attachments?: Maybe<Array<PortalMessageAttachment>>;
  chatId: Scalars['Urn']['output'];
  date: Scalars['DateTime']['output'];
  message: RichBody;
  messageId: Scalars['Urn']['output'];
  sender?: Maybe<PortalSender>;
};

export type PortalParticipantEvent = {
  __typename?: 'PortalParticipantEvent';
  action: PortalEventType;
  chat?: Maybe<Chat>;
  chatId: Scalars['Urn']['output'];
  date: Scalars['DateTime']['output'];
  note: RichBody;
};

export type PortalReactionEvent = {
  __typename?: 'PortalReactionEvent';
  action: PortalEventType;
  chatId: Scalars['Urn']['output'];
  messageId: Scalars['Urn']['output'];
  reaction: Scalars['String']['output'];
  sender?: Maybe<PortalSender>;
};

export type PortalRegisterEvent = {
  __typename?: 'PortalRegisterEvent';
  action: PortalEventType;
  sessionToken: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PortalSender = {
  __typename?: 'PortalSender';
  iconUrl: Scalars['String']['output'];
  id: Scalars['Urn']['output'];
  isCurrentUser: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: SenderType;
};

export type PortalSettingsInput = {
  /** The forms which are allowed to be created by logged in guests. */
  guestFormIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  /** Guest user permissions. */
  guestPermissions: Array<Permission>;
  /** The default page that should show when anyone goes to /answers. */
  indexArticleId?: InputMaybe<Scalars['ArticleUrn']['input']>;
  /** Whether AI module is enabled for this portal */
  isAIEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should guests coming from a shared be considered guests or public? */
  isSharedChannelGuest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The welcome greeting. */
  portalIndexProvider?: InputMaybe<PortalIndexProvider>;
  /** The forms which are allowed to be created by the public. */
  publicFormIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  /** Users public permissions. */
  publicPermissions: Array<Permission>;
  /** Single Sign on Settings */
  singleSignOn?: InputMaybe<PortalSingleSignOnInput>;
  /** Title to display for the portal. */
  title: Scalars['String']['input'];
  /** SCIM settings */
  userProvisioning?: InputMaybe<PortalUserProvisioningInput>;
  /** The welcome greeting. */
  welcomeMessage: Scalars['String']['input'];
};

export type PortalSingleSignOn = {
  __typename?: 'PortalSingleSignOn';
  /** IDP metadata */
  identityProviderMetadata?: Maybe<Scalars['String']['output']>;
  /** Whether SSO is enabled */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** IDP Redirect URL */
  loginRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Foqal SP Login Url */
  providerLoginUrl?: Maybe<Scalars['String']['output']>;
};

export type PortalSingleSignOnInput = {
  /** IDP metadata */
  identityProviderMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Whether SSO is enabled */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDP Redirect URL */
  loginRedirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PortalSnoozeEvent = {
  __typename?: 'PortalSnoozeEvent';
  action: PortalEventType;
  chatId: Scalars['Urn']['output'];
};

export type PortalSuccessEvent = {
  __typename?: 'PortalSuccessEvent';
  action: PortalEventType;
  isOk: Scalars['Boolean']['output'];
  responseTo: PortalEventType;
};

export type PortalUserEvent = {
  __typename?: 'PortalUserEvent';
  action: PortalEventType;
  chatId: Scalars['Urn']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['Urn']['output'];
  name: Scalars['String']['output'];
};

export type PortalUserProvisioning = {
  __typename?: 'PortalUserProvisioning';
  /** An user added to this group will be added as an administrator. */
  administratorGroupId?: Maybe<Scalars['UserGroupUrn']['output']>;
  /** Foqal SCIM endpoint */
  providerSCIMUrl?: Maybe<Scalars['String']['output']>;
};

export type PortalUserProvisioningInput = {
  /** An user added to this group will be added as an administrator. */
  administratorGroupId?: InputMaybe<Scalars['UserGroupUrn']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns one article for the given id. */
  article?: Maybe<Article>;
  articleAnswers: ArticleResults;
  articleTags: Array<ArticleTag>;
  articles: ArticleResults;
  /** Runs a prompt and returns the result */
  artificialIntelligencePrompt?: Maybe<ArtificialIntelligencePrompt>;
  /** Creates an AI Summary of the conversation */
  artificialIntelligenceSettings?: Maybe<ArtificialIntelligenceSettings>;
  /** Returns billing profile information. */
  billing?: Maybe<PortalBillingProfile>;
  /** Returns a list of bots part of this workspace. */
  bots?: Maybe<Array<Bot>>;
  /** Gets a shared channel invite. */
  channelInvite?: Maybe<ChannelInvite>;
  /** Gets a list of shared channel invites for the current company */
  channelInvites?: Maybe<Array<ChannelInvite>>;
  /** Returns the given chat. */
  chat?: Maybe<Chat>;
  /** Returns chat settings for one channel. */
  chatSettings?: Maybe<ChatSettings>;
  /** Returns chat settings for many channels. */
  chatSettingsMany?: Maybe<Array<ChatSettings>>;
  /** Returns active chats for this instance.. */
  chats?: Maybe<ChatResults>;
  /** Returns the organizations matching a query or a subset of organizations if a query is not provided. */
  companies: CompanyResults;
  /** Gets a company by id. */
  company: CompanyResults;
  /** Gets a conversation source. */
  conversationSource?: Maybe<ConversationSource>;
  /** Gets a list of conversation sources. */
  conversationSourceUsers?: Maybe<Array<User>>;
  /** Gets a list of conversation sources. */
  conversationSources?: Maybe<Array<ConversationSource>>;
  /** Returns the given ticket message. */
  dashboard?: Maybe<Dashboard>;
  /** Gets the default queue */
  defaultQueue?: Maybe<Queue>;
  /** Returns available external forms */
  externalFormFields?: Maybe<Array<FormField>>;
  /** Returns available external forms */
  externalForms?: Maybe<Array<ExternalForm>>;
  /** Returns a list of active feature flags */
  featureFlags?: Maybe<FeatureFlags>;
  /** Returns the given ticket message. */
  form?: Maybe<Form>;
  /** Returns the given form field. */
  formField?: Maybe<FormField>;
  formFields: Array<FormField>;
  forms: Array<Form>;
  /** Helper method to expose the portal events.. */
  getAllEvents: PortalEvent;
  /** Gets a new Hub token. */
  getHubData?: Maybe<HubData>;
  /** Gets the current state of Hub and Spoke on this workspace. */
  getHubSpokeStatus?: Maybe<HubSpokeStatus>;
  /** Gets all the participants on a chat */
  getParticipants?: Maybe<Array<User>>;
  /** Returns the users that match a specific company and organization */
  guestUsersByCompany?: Maybe<UserResults>;
  /** Gets the list of holiday countries. */
  holidayCountries?: Maybe<Array<HolidayCountry>>;
  /** Gets a new Hub token. */
  hubSpokeToken?: Maybe<HubSpokeToken>;
  /** Gets the user integration. */
  integrationUserData?: Maybe<Array<IntegrationData>>;
  /** Gets the integrations. */
  integrations?: Maybe<Array<Integration>>;
  /** Creates a URL to login using an identity. */
  loginWithIdentityProvider: IdentityProviderOptions;
  /** Returns the metrics dashboard. */
  metricsDashboard?: Maybe<MetricsDashboard>;
  /** Returns the metrics dashboard with the data. */
  metricsDashboardWithData?: Maybe<MetricsDashboardWithData>;
  /** Gets the current onboarding profile */
  onboardingProfile?: Maybe<OnboardingProfile>;
  /** Returns one portal for the given id. */
  portal?: Maybe<Portal>;
  /** Returns a queue. */
  queue?: Maybe<Queue>;
  queues: Array<Queue>;
  /** Gets the current session. */
  session?: Maybe<Session>;
  /** Gets the current session. */
  sessions: Array<Session>;
  /** Gets the current user settings. */
  settings?: Maybe<Settings>;
  /** Creates an AI Summary of the conversation */
  summarizeConversation?: Maybe<ArtificialIntelligenceSummary>;
  /** Gets the support based Slack Connect channel */
  supportSlackConnectChannel?: Maybe<SupportChannel>;
  /** Returns the given ticket. */
  ticket?: Maybe<Ticket>;
  /** Returns the given ticket message. */
  ticketMessage?: Maybe<TicketMessage>;
  ticketMessages: Array<TicketMessage>;
  /** Returns the given ticket message. */
  ticketState?: Maybe<TicketState>;
  ticketStates: Array<TicketState>;
  /** Returns the given ticket task. */
  ticketTask?: Maybe<TicketTask>;
  ticketTasks: Array<TicketTask>;
  tickets: Array<Ticket>;
  updateCategories: Array<ArticleTag>;
  /** Returns one article for the given id. */
  updates?: Maybe<Array<Article>>;
  /** Returns the user for the given id. */
  user?: Maybe<User>;
  /** Returns a user group. */
  userGroup?: Maybe<UserGroup>;
  userGroups: Array<UserGroup>;
  /** Gets all the user handles for a user */
  userHandles?: Maybe<Array<UserHandle>>;
  /** Gets user settings. */
  userSettings: UserSettings;
  /** Returns the users matching a query or a subset of users if a query is not provided. */
  users?: Maybe<Array<User>>;
  /** Returns the given chat. */
  waitForChat?: Maybe<Chat>;
  /** Returns the latest version of the given workflow. */
  workflow?: Maybe<Workflow>;
  /** Gets a third party reference to a workflow. */
  workflowReference?: Maybe<WorkflowReference>;
  /** Returns the given form field. */
  workflowService?: Maybe<WorkflowService>;
  /** Returns the given service action. */
  workflowServiceAction?: Maybe<WorkflowServiceAction>;
  /** Returns the given service action. */
  workflowServiceChoiceValues?: Maybe<WorkflowServiceChoiceOptions>;
  /** Gets an example request based for a webhook. */
  workflowServicePollWebhookExample: WorkflowServiceWebhookPollResponse;
  /** Returns all available system actions. */
  workflowServiceSystemActions?: Maybe<Array<WorkflowServiceAction>>;
  workflowServices: Array<WorkflowService>;
};


export type QueryArticleArgs = {
  id: Scalars['ArticleUrn']['input'];
};


export type QueryArticleAnswersArgs = {
  query: Scalars['String']['input'];
};


export type QueryArticlesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ArticleSearchOptions>;
  query?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ArticleTagUrn']['input']>;
};


export type QueryArtificialIntelligencePromptArgs = {
  options: ArtificialIntelligencePromptInput;
};


export type QueryBotsArgs = {
  id?: InputMaybe<Scalars['Urn']['input']>;
};


export type QueryChannelInviteArgs = {
  id: Scalars['ChannelInviteUrn']['input'];
};


export type QueryChatArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatSettingsArgs = {
  id: Scalars['Urn']['input'];
};


export type QueryChatSettingsManyArgs = {
  filter?: InputMaybe<ChatSettingsFilter>;
};


export type QueryChatsArgs = {
  dashboardId?: InputMaybe<Scalars['DashboardUrn']['input']>;
  filter?: InputMaybe<TicketView>;
  filters?: InputMaybe<SearchFiltersInput>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompaniesArgs = {
  ids?: InputMaybe<Array<Scalars['CompanyUrn']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['CompanyUrn']['input'];
};


export type QueryConversationSourceArgs = {
  id: Scalars['Urn']['input'];
};


export type QueryConversationSourceUsersArgs = {
  chatId?: InputMaybe<Scalars['Urn']['input']>;
  conversationSourceId: Scalars['Urn']['input'];
};


export type QueryConversationSourcesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  shouldIncludeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeTags?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDashboardArgs = {
  id?: InputMaybe<Scalars['TicketStateUrn']['input']>;
};


export type QueryExternalFormFieldsArgs = {
  id: Scalars['FormExternalUrn']['input'];
};


export type QueryExternalFormsArgs = {
  id?: InputMaybe<Scalars['Urn']['input']>;
  value?: InputMaybe<Scalars['FormExternalUrn']['input']>;
};


export type QueryFormArgs = {
  id: Scalars['FormUrn']['input'];
};


export type QueryFormFieldArgs = {
  id: Scalars['FormFieldUrn']['input'];
};


export type QueryFormFieldsArgs = {
  ids?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  shouldIncludePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeSystemFields?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFormsArgs = {
  ids?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  permission?: InputMaybe<PermissionAction>;
  type?: InputMaybe<FormType>;
};


export type QueryGetHubDataArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetParticipantsArgs = {
  chatId: Scalars['Urn']['input'];
};


export type QueryGuestUsersByCompanyArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['CompanyUrn']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryIntegrationUserDataArgs = {
  id: Scalars['Urn']['input'];
};


export type QueryIntegrationsArgs = {
  chatId?: InputMaybe<Scalars['Urn']['input']>;
};


export type QueryLoginWithIdentityProviderArgs = {
  provider: IdentityProviderInput;
};


export type QueryMetricsDashboardArgs = {
  id?: InputMaybe<Scalars['MetricsDashboardUrn']['input']>;
};


export type QueryMetricsDashboardWithDataArgs = {
  input: MetricsInput;
};


export type QueryPortalArgs = {
  id?: InputMaybe<Scalars['PortalUrn']['input']>;
};


export type QueryQueueArgs = {
  id: Scalars['QueueUrn']['input'];
};


export type QueryQueuesArgs = {
  filters?: InputMaybe<QueueFilters>;
  ids?: InputMaybe<Array<Scalars['QueueUrn']['input']>>;
};


export type QuerySessionsArgs = {
  userId?: InputMaybe<Scalars['UserUrn']['input']>;
};


export type QuerySummarizeConversationArgs = {
  chatId: Scalars['Urn']['input'];
};


export type QueryTicketArgs = {
  id: Scalars['String']['input'];
};


export type QueryTicketMessageArgs = {
  id: Scalars['TicketMessageUrn']['input'];
};


export type QueryTicketMessagesArgs = {
  ticketId: Scalars['TicketUrn']['input'];
};


export type QueryTicketStateArgs = {
  id: Scalars['TicketStateUrn']['input'];
};


export type QueryTicketTaskArgs = {
  id: Scalars['TicketTaskUrn']['input'];
};


export type QueryTicketTasksArgs = {
  filters: TicketTaskFilters;
};


export type QueryTicketsArgs = {
  filter?: InputMaybe<TicketView>;
  filters?: InputMaybe<TicketFilters>;
};


export type QueryUserArgs = {
  id: Scalars['Urn']['input'];
};


export type QueryUserGroupArgs = {
  id: Scalars['UserGroupUrn']['input'];
};


export type QueryUserGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['UserGroupUrn']['input']>>;
};


export type QueryUserHandlesArgs = {
  userId?: InputMaybe<Scalars['UserUrn']['input']>;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UsersFilters>;
  ids?: InputMaybe<Array<Scalars['Urn']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryWaitForChatArgs = {
  id: Scalars['Urn']['input'];
  seconds: Scalars['Float']['input'];
};


export type QueryWorkflowArgs = {
  id: Scalars['WorkflowUrn']['input'];
};


export type QueryWorkflowReferenceArgs = {
  referenceId: Scalars['Urn']['input'];
};


export type QueryWorkflowServiceArgs = {
  id: Scalars['Urn']['input'];
};


export type QueryWorkflowServiceActionArgs = {
  id: Scalars['Urn']['input'];
};


export type QueryWorkflowServiceChoiceValuesArgs = {
  filters: WorkflowServiceChoiceFilterInput;
};


export type QueryWorkflowServicePollWebhookExampleArgs = {
  stepId: Scalars['WorkflowStepUrn']['input'];
};


export type QueryWorkflowServiceSystemActionsArgs = {
  type: ActionContextType;
};


export type QueryWorkflowServicesArgs = {
  filters?: InputMaybe<WorkflowServiceFilters>;
  ids?: InputMaybe<Array<Scalars['WorkflowServiceUrn']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type Queue = {
  __typename?: 'Queue';
  channelTags: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailAliasIds: Array<Scalars['ChannelEmailUrn']['output']>;
  id: Scalars['QueueUrn']['output'];
  integrationIds: Array<Scalars['IntegrationUrn']['output']>;
  members: Array<QueueMember>;
  name: Scalars['String']['output'];
  userAssignmentType?: Maybe<AssignmentType>;
};

export type QueueFilters = {
  shouldFilterMyQueues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueueInput = {
  channelTags: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAliasIds: Array<Scalars['ChannelEmailUrn']['input']>;
  integrationIds: Array<Scalars['IntegrationUrn']['input']>;
  members: Array<QueueMemberInput>;
  name: Scalars['String']['input'];
  userAssignmentType?: InputMaybe<AssignmentType>;
};

export type QueueMember = {
  __typename?: 'QueueMember';
  group?: Maybe<UserGroup>;
  memberId?: Maybe<Scalars['Urn']['output']>;
  role: QueueMemberRole;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Urn']['output']>;
};

export type QueueMemberInput = {
  memberId?: InputMaybe<Scalars['Urn']['input']>;
  role: QueueMemberRole;
  userId?: InputMaybe<Scalars['Urn']['input']>;
};

/** The role of the user in the queue */
export enum QueueMemberRole {
  Assignee = 'ASSIGNEE',
  Observer = 'OBSERVER'
}

/** Which field is required */
export enum RequiredField {
  Tags = 'TAGS',
  TicketNotes = 'TICKET_NOTES'
}

export type RichBody = {
  __typename?: 'RichBody';
  html?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  plaintext?: Maybe<Scalars['String']['output']>;
};

export type SearchFiltersInput = {
  assignedAgentId?: InputMaybe<Scalars['Urn']['input']>;
  creatorId?: InputMaybe<Scalars['Urn']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  formIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  priority?: InputMaybe<TicketPriority>;
  queueIds?: InputMaybe<Array<Scalars['QueueUrn']['input']>>;
  requestorId?: InputMaybe<Scalars['Urn']['input']>;
  sourceIds?: InputMaybe<Array<Scalars['Urn']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TicketStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendChannelInviteInput = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  inviteId: Scalars['ChannelInviteUrn']['input'];
  name: Scalars['String']['input'];
};

/** Who to send the message as */
export enum SendFromType {
  /** The message should be sent as the default Agent user */
  Agent = 'AGENT',
  /** The message should be sent as me */
  Me = 'ME'
}

/** The type of sender sending the requets. */
export enum SenderType {
  Agent = 'AGENT',
  Bot = 'BOT',
  System = 'SYSTEM',
  User = 'USER'
}

export type Session = {
  __typename?: 'Session';
  cookies: Scalars['Map']['output'];
  createdAt: Scalars['DateTime']['output'];
  headers: Scalars['Map']['output'];
  id: Scalars['UserSessionUrn']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  permissions: Array<Permission>;
  user: User;
  userId: Scalars['UserUrn']['output'];
};

export type SessionSocketConnection = {
  __typename?: 'SessionSocketConnection';
  sessionToken: Scalars['String']['output'];
  socketUrl: Scalars['String']['output'];
};

export type Settings = {
  __typename?: 'Settings';
  adminIds?: Maybe<Array<Scalars['Urn']['output']>>;
  admins?: Maybe<Array<User>>;
  agents?: Maybe<Array<User>>;
  agentsIds?: Maybe<Array<Scalars['Urn']['output']>>;
  artificialIntelligence?: Maybe<SettingsArtificialIntelligence>;
  channelEmail?: Maybe<SettingsChannelEmail>;
  channelSlack?: Maybe<SettingsChannelSlack>;
  channelWebChat?: Maybe<SettingsChannelWebChat>;
  channels?: Maybe<SettingsChannels>;
  customFields?: Maybe<SettingsCustomFields>;
  customization?: Maybe<SettingsCustomization>;
  feedback?: Maybe<Feedback>;
  identities?: Maybe<Array<Scalars['Urn']['output']>>;
  sla?: Maybe<SettingsSla>;
  time?: Maybe<SettingsTime>;
};

export type SettingsAiDeflection = {
  __typename?: 'SettingsAiDeflection';
  deflectionTicketStatusAssignment?: Maybe<DeflectionTicketStatusAssignment>;
  message?: Maybe<DisplayText>;
};

export type SettingsAiDeflectionInput = {
  deflectionTicketStatusAssignment?: InputMaybe<DeflectionTicketStatusAssignment>;
  message?: InputMaybe<DisplayTextInput>;
};

export type SettingsArtificialIntelligence = {
  __typename?: 'SettingsArtificialIntelligence';
  deflection?: Maybe<SettingsAiDeflection>;
};

export type SettingsArtificialIntelligenceInput = {
  deflection?: InputMaybe<SettingsAiDeflectionInput>;
};

export type SettingsChannelEmail = {
  __typename?: 'SettingsChannelEmail';
  /** The list of email aliases */
  emails: Array<SettingsChannelEmailAlias>;
  /** The email feedback introduction. */
  feedbackIntroduction?: Maybe<Scalars['String']['output']>;
  /** The email footer added to the bottom of each email. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Should feedback also be sent via email. */
  shouldSendFeedback?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsChannelEmailAlias = {
  __typename?: 'SettingsChannelEmailAlias';
  /** The id of the email alias. */
  id: Scalars['ChannelEmailUrn']['output'];
  /** Is this email the default */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The original destination email. */
  originalDestinationEmail?: Maybe<Scalars['String']['output']>;
  /** The date this email was verified */
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SettingsChannelEmailInput = {
  /** The email feedback introduction. */
  feedbackIntroduction?: InputMaybe<Scalars['String']['input']>;
  /** The email footer added to the bottom of each email. */
  footer?: InputMaybe<Scalars['String']['input']>;
  /** Should feedback also be sent via email. */
  shouldSendFeedback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsChannelSlack = {
  __typename?: 'SettingsChannelSlack';
  approvedBotIds?: Maybe<Array<Scalars['UserUrn']['output']>>;
  canFillOutForm?: Maybe<Scalars['Boolean']['output']>;
  channelMode?: Maybe<ChannelMode>;
  emojiActions?: Maybe<Array<ChatSettingsEmojiAction>>;
  formIds?: Maybe<Array<Scalars['FormUrn']['output']>>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  ignoreTicketsFromEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  introduction?: Maybe<DisplayText>;
  messageActionFormIds?: Maybe<Array<Scalars['FormUrn']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  offHoursIntroduction?: Maybe<DisplayText>;
  requestFormText?: Maybe<Scalars['String']['output']>;
  shouldAllowUsersAddParticipants?: Maybe<Scalars['Boolean']['output']>;
  shouldDisplayAgentJoin?: Maybe<Scalars['Boolean']['output']>;
  slaTierId?: Maybe<Scalars['RoutingPolicyUrn']['output']>;
  ticketCreatedTemplate?: Maybe<Scalars['String']['output']>;
};

export type SettingsChannelSlackInput = {
  approvedBotIds?: InputMaybe<Array<Scalars['UserUrn']['input']>>;
  canFillOutForm?: InputMaybe<Scalars['Boolean']['input']>;
  channelMode?: InputMaybe<ChannelMode>;
  emojiActions?: InputMaybe<Array<ChatSettingsEmojiActionInput>>;
  formIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  ignoreTicketsFromEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  introduction?: InputMaybe<DisplayTextInput>;
  messageActionFormIds?: InputMaybe<Array<Scalars['FormUrn']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  offHoursIntroduction?: InputMaybe<DisplayTextInput>;
  requestFormText?: InputMaybe<Scalars['String']['input']>;
  shouldAllowUsersAddParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayAgentJoin?: InputMaybe<Scalars['Boolean']['input']>;
  slaTierId?: InputMaybe<Scalars['RoutingPolicyUrn']['input']>;
  ticketCreatedTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsChannelWebChat = {
  __typename?: 'SettingsChannelWebChat';
  /** The list of hosts from which chat is allowed. */
  allowedHosts?: Maybe<Array<Scalars['String']['output']>>;
  /** The default avatar url. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The default avatar url. */
  chatScript: Scalars['String']['output'];
  /** Is a referrer check required to validate host. */
  isReferrerCheckRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the chat site. This is only visible for configurations and in the app source. */
  name: Scalars['String']['output'];
  /** The default welcome message a user sees when they first open chat. */
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type SettingsChannelWebChatInput = {
  /** The list of hosts from which chat is allowed. */
  allowedHosts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The default avatar url. */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** Is a referrer check required to validate host. */
  isReferrerCheckRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the chat site. This is only visible for configurations and in the app source. */
  name: Scalars['String']['input'];
  /** The default welcome message a user sees when they first open chat. */
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsChannels = {
  __typename?: 'SettingsChannels';
  channelTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SettingsChannelsInput = {
  channelTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SettingsCustomFields = {
  __typename?: 'SettingsCustomFields';
  formIds?: Maybe<Scalars['FormUrn']['output']>;
  messageActionFormIds?: Maybe<Scalars['FormUrn']['output']>;
};

export type SettingsCustomization = {
  __typename?: 'SettingsCustomization';
  allowOverrideTicketsGroups?: Maybe<Array<Scalars['UserGroupUrn']['output']>>;
  requiredCloseFields?: Maybe<Array<RequiredField>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SettingsCustomizationInput = {
  allowOverrideTicketsGroups?: InputMaybe<Array<Scalars['UserGroupUrn']['input']>>;
  requiredCloseFields?: InputMaybe<Array<RequiredField>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SettingsSla = {
  __typename?: 'SettingsSLA';
  defaultSLAPolicyId?: Maybe<Scalars['RoutingPolicyUrn']['output']>;
  defaultSeverityIndex?: Maybe<Scalars['Float']['output']>;
  severityLabels?: Maybe<Array<Scalars['String']['output']>>;
  tiers?: Maybe<Array<SettingsSlaTier>>;
};

export type SettingsSlaInput = {
  defaultSLAPolicyIndex?: InputMaybe<Scalars['Float']['input']>;
  defaultSeverityIndex?: InputMaybe<Scalars['Float']['input']>;
  severityLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  tiers?: InputMaybe<Array<SettingsSlaTierInput>>;
};

export type SettingsSlaTier = {
  __typename?: 'SettingsSLATier';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['RoutingPolicyUrn']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<SettingsSlaTierValue>>;
};

export type SettingsSlaTierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['RoutingPolicyUrn']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<SettingsSlaTierValueInput>>;
};

export type SettingsSlaTierMetricValue = {
  __typename?: 'SettingsSLATierMetricValue';
  metric?: Maybe<SlaMetric>;
  shouldAccountHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SettingsSlaTierMetricValueInput = {
  metric?: InputMaybe<SlaMetric>;
  shouldAccountHoursOfOperation?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type SettingsSlaTierValue = {
  __typename?: 'SettingsSLATierValue';
  policies?: Maybe<Array<SettingsSlaTierMetricValue>>;
};

export type SettingsSlaTierValueInput = {
  policies?: InputMaybe<Array<SettingsSlaTierMetricValueInput>>;
};

export type SettingsTime = {
  __typename?: 'SettingsTime';
  holidayCountryCode?: Maybe<Scalars['String']['output']>;
  hoursOfOperations?: Maybe<Array<HoursOfOperations>>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type SettingsTimeInput = {
  holidayCountryCode?: InputMaybe<Scalars['String']['input']>;
  hoursOfOperations?: InputMaybe<Array<HoursOfOperationsInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** SLA Metric */
export enum SlaMetric {
  RequesterWaitTime = 'REQUESTER_WAIT_TIME',
  TimeToFirstResponse = 'TIME_TO_FIRST_RESPONSE',
  TimeToUpdate = 'TIME_TO_UPDATE'
}

export type SnoozeInput = {
  /** What time should the chat be made visible again. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any additional notes. */
  note?: InputMaybe<Scalars['String']['input']>;
};

export type StartChatInput = {
  /** After firing the message and creating the ticket, schedule an action to also fire. */
  action?: InputMaybe<TicketInput>;
  /** Attachment tokens list. */
  attachmentTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The body of the ticket message. */
  body: Scalars['String']['input'];
  /** If you want to send this message in the future, set a future date. */
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Who to send the  message from. */
  sendFrom: SendFromType;
  /** Who to send the messages to */
  to: Array<Scalars['Urn']['input']>;
};

export type SupportChannel = {
  __typename?: 'SupportChannel';
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  assignedDate?: Maybe<Scalars['DateTime']['output']>;
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['Urn']['output']>;
  chatId?: Maybe<Scalars['Urn']['output']>;
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['Urn']['output'];
  currentUserLastReadDate?: Maybe<Scalars['DateTime']['output']>;
  customContextValues?: Maybe<Array<TicketCustomContextValue>>;
  customFields?: Maybe<Array<CustomField>>;
  description?: Maybe<Scalars['String']['output']>;
  dueDates?: Maybe<Array<TicketDueDate>>;
  firstResponseDate?: Maybe<Scalars['DateTime']['output']>;
  /** Form or request type */
  form?: Maybe<Form>;
  /** Form id. */
  formId?: Maybe<Scalars['Urn']['output']>;
  hasUnreadByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['TicketUrn']['output'];
  lastResponseDate?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<TicketMessage>>;
  modifiedDate: Scalars['DateTime']['output'];
  priority: TicketPriority;
  queue?: Maybe<Queue>;
  queueId?: Maybe<Scalars['QueueUrn']['output']>;
  requestor: User;
  requestorId: Scalars['Urn']['output'];
  /** Ticket state */
  state?: Maybe<TicketState>;
  status: TicketStatus;
  subject?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  /** Ticket tasks */
  tasks?: Maybe<Array<TicketTask>>;
  ticketNumber?: Maybe<Scalars['Float']['output']>;
  ticketStateId: Scalars['TicketStateUrn']['output'];
};

export type TicketCustomContextValue = {
  __typename?: 'TicketCustomContextValue';
  description: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
  displayType: IntegrationValueType;
  id: Scalars['TicketCustomContextUrn']['output'];
  label: Scalars['String']['output'];
  value: FieldTypedValue;
};

export type TicketDueDate = {
  __typename?: 'TicketDueDate';
  comments?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  dueDate: Scalars['DateTime']['output'];
  startedDate?: Maybe<Scalars['DateTime']['output']>;
  type: DueDateType;
};

export type TicketEditMessageInput = {
  /** The body of the ticket message. */
  body?: InputMaybe<Scalars['String']['input']>;
};

export type TicketFilters = {
  /** The id of the user that its assigned to. */
  assigneeId?: InputMaybe<Scalars['Urn']['input']>;
  /** The id of the user that created the ticket. */
  creatorId?: InputMaybe<Scalars['Urn']['input']>;
  /** The end date of the tickets. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of results to return. */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** The start date of the tickets. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The status of the ticket. */
  statuses?: InputMaybe<TicketStatus>;
};

export type TicketInput = {
  /** The updated custom field */
  customField?: InputMaybe<CustomFieldValueInput>;
  /** The custom fields. */
  customFields?: InputMaybe<Array<CustomFieldValueInput>>;
  /** Description of the ticket. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Form id. */
  formId?: InputMaybe<Scalars['FormUrn']['input']>;
  /** Priority of the ticket */
  priority?: InputMaybe<TicketPriority>;
  /** The id of the requestor. */
  requestorId?: InputMaybe<Scalars['Urn']['input']>;
  /** Subject of the ticket. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Ticket tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TicketMessage = {
  __typename?: 'TicketMessage';
  /** The list of attachment articles */
  articles?: Maybe<Array<TicketMessageArticle>>;
  /** The collection of attachments to this message. */
  attachments?: Maybe<Array<TicketMessageAttachment>>;
  /** Ticket message body */
  body: RichBody;
  /** Date the message was sent. */
  createdDate: Scalars['DateTime']['output'];
  /** The user which created the ticket message. */
  creator?: Maybe<User>;
  /** The id user which created the ticket message. */
  creatorId?: Maybe<Scalars['Urn']['output']>;
  /** The id of the ticket message */
  id: Scalars['TicketMessageUrn']['output'];
  /** If the message was deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Original message body if deleted or updated. */
  originalBody?: Maybe<RichBody>;
  /** The collection of people which reacted to this message. */
  reactions?: Maybe<Array<TicketMessageReaction>>;
  /** If message was redacted, when was it redacted. */
  redactedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Ticket message type */
  type: TicketMessageType;
};

export type TicketMessageArticle = {
  __typename?: 'TicketMessageArticle';
  /** The id of the article. */
  id: Scalars['ArticleUrn']['output'];
  /** The id of the portal. */
  portalId: Scalars['PortalUrn']['output'];
  /** The text to preview. */
  previewText: Scalars['String']['output'];
  /** The title of the article. */
  title: Scalars['String']['output'];
};

export type TicketMessageArticleInput = {
  /** The id of the article. */
  id: Scalars['ArticleUrn']['input'];
  /** The id of the portal. */
  portalId: Scalars['PortalUrn']['input'];
  /** The text to preview. */
  previewText: Scalars['String']['input'];
  /** The title of the article. */
  title: Scalars['String']['input'];
};

export type TicketMessageAttachment = {
  __typename?: 'TicketMessageAttachment';
  /** The filename of the attachment. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** The mime type of the attachment. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The url of an imaged to see a preview of the attachment. */
  previewImage?: Maybe<Scalars['String']['output']>;
  /** The title of the attachment. */
  title?: Maybe<Scalars['String']['output']>;
  /** The url used to download the attachment. */
  url: Scalars['String']['output'];
};

export type TicketMessageInput = {
  /** The list of attachment articles */
  articles?: InputMaybe<Array<TicketMessageArticleInput>>;
  /** Attachment tokens list. */
  attachmentTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The body of the ticket message. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** If a draft was used, what is the draft id that was used? */
  draftId?: InputMaybe<Scalars['TicketMessageUrn']['input']>;
  /** The optional date when to send the message. */
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TicketMessageReaction = {
  __typename?: 'TicketMessageReaction';
  /** The user which created the message reaction. */
  creator: User;
  /** The id user which created the message reaction. */
  creatorId: Scalars['Urn']['output'];
  /** Is this reaction created by the current user. */
  isCreatedByCurrentUser: Scalars['Boolean']['output'];
  /** The type of ticket reaction. */
  reaction: Scalars['String']['output'];
};

export type TicketMessageReactionInput = {
  /** The id of the chat. */
  chatId: Scalars['Urn']['input'];
  /** The id of the message. */
  messageId: Scalars['Urn']['input'];
  /** The type of ticket reaction. */
  reaction: Scalars['String']['input'];
};

/** The type of ticket */
export enum TicketMessageType {
  /** Message from the agent */
  AgentMessage = 'AGENT_MESSAGE',
  AuditLog = 'AUDIT_LOG',
  /** Private comment */
  Comment = 'COMMENT',
  Draft = 'DRAFT',
  /** Informational comment */
  Information = 'INFORMATION',
  /** Automatic system message */
  SystemMessage = 'SYSTEM_MESSAGE',
  /** Message triggered by the system and visible to the end user. */
  Triggered = 'TRIGGERED',
  /** Message from the end user */
  UserMessage = 'USER_MESSAGE'
}

export type TicketNoteInput = {
  /** Attachment tokens list. */
  attachmentTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The body of the ticket message. */
  body: Scalars['String']['input'];
  /** The optional date when to send the message. */
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents the priority of the ticket */
export enum TicketPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type TicketState = {
  __typename?: 'TicketState';
  /** The conversation statuses that are automatically associated with this state */
  chatStatuses: Array<ChatStatus>;
  /** The description of the ticket state */
  description: Scalars['String']['output'];
  /** The id of the ticket state */
  id: Scalars['TicketStateUrn']['output'];
  /** The name of the ticket state */
  name: Scalars['String']['output'];
  /** The ticket statuses that are automatically associated with this state */
  ticketStatuses: Array<TicketStatus>;
};

export type TicketStateInput = {
  /** The conversation statuses that are automatically associated with this state */
  chatStatuses: Array<ChatStatus>;
  /** The description of the ticket state */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the ticket state */
  name: Scalars['String']['input'];
  /** The ticket statuses that are automatically associated with this state */
  ticketStatuses: Array<TicketStatus>;
};

/** Represents the status of the ticket */
export enum TicketStatus {
  Closed = 'CLOSED',
  Deflection = 'DEFLECTION',
  Hold = 'HOLD',
  Ignored = 'IGNORED',
  Open = 'OPEN',
  Reopened = 'REOPENED',
  Snooze = 'SNOOZE'
}

export type TicketTask = {
  __typename?: 'TicketTask';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['Urn']['output']>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['TicketTaskUrn']['output'];
  isAssignedToCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  modifiedDate: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: TicketTaskState;
  ticketId: Scalars['TicketUrn']['output'];
};

export type TicketTaskFilters = {
  status: TicketTaskState;
  ticketId: Scalars['TicketUrn']['input'];
};

/** Represents the state of a ticket task */
export enum TicketTaskState {
  Finished = 'FINISHED',
  NotApplicable = 'NOT_APPLICABLE',
  Open = 'OPEN',
  Rejected = 'REJECTED'
}

/** Specifies which results to return */
export enum TicketView {
  /** If allowed, shows all the tickets for the current workspace across all queues. */
  All = 'ALL',
  /** Created tickets */
  CreatedTickets = 'CREATED_TICKETS',
  /** Tickets assigned to users in my queues.  */
  MyQueues = 'MY_QUEUES',
  /** Tickets assigned to me or waiting for help (MY_TICKETS) */
  MyTickets = 'MY_TICKETS'
}

export type TokenMigrationToken = {
  __typename?: 'TokenMigrationToken';
  token: Scalars['String']['output'];
};

export type TokenRequestInput = {
  name: Scalars['String']['input'];
  permissions: Array<Permission>;
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  permissions: Array<Permission>;
  token: Scalars['String']['output'];
};

/** The user object. */
export type User = {
  __typename?: 'User';
  /** The users avatar url. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The users email addresses.
   * @deprecated Use Handles instead
   */
  emailAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** The users first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The group of the user. This is either the company, the department, or something similar */
  group?: Maybe<Scalars['String']['output']>;
  handles?: Maybe<Array<UserHandle>>;
  /** The id of the user. */
  id: Scalars['Urn']['output'];
  /** Returns true if the user has been verified. */
  isVerified?: Maybe<Scalars['String']['output']>;
  /** The users last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  loginType?: Maybe<LoginType>;
  /** The users full name. */
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Company>;
  /** The organization ID the user belongs to. */
  organizationId?: Maybe<Scalars['CompanyUrn']['output']>;
  role: UserRole;
  userGroups: Array<UserGroup>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UserGroupUrn']['output'];
  name: Scalars['String']['output'];
  userIds: Array<Scalars['Urn']['output']>;
  users: Array<User>;
};

export type UserGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userIds: Array<Scalars['Urn']['input']>;
};

/** The user handle. */
export type UserHandle = {
  __typename?: 'UserHandle';
  /** The application handle */
  application?: Maybe<UserHandleApplication>;
  /** The email handle */
  email?: Maybe<UserHandleEmail>;
  /** The id of the user handle. */
  id: Scalars['HandleUrn']['output'];
  /** The type of handle */
  type: HandleType;
};

/** The user application handle. */
export type UserHandleApplication = {
  __typename?: 'UserHandleApplication';
  /** The text which can be updated. */
  applicationName: Scalars['String']['output'];
  /** The text which describes the id. */
  displayText: Scalars['String']['output'];
  /** The text which can be updated. */
  editableText: Scalars['String']['output'];
  /** If the application handle verified. */
  isVerified: Scalars['Boolean']['output'];
};

/** The user email handle. */
export type UserHandleEmail = {
  __typename?: 'UserHandleEmail';
  /** If the email address. */
  email: Scalars['String']['output'];
  /** If the email handle is verified. */
  isVerified: Scalars['Boolean']['output'];
};

export type UserInput = {
  /** Email address of the user. */
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** First name of the user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Specifies if a user is allowed to login the web portal */
  loginType?: InputMaybe<LoginType>;
  /** Organization of the user */
  organizationId?: InputMaybe<Scalars['CompanyUrn']['input']>;
  /** Type of user */
  userType?: InputMaybe<UserType>;
};

export type UserResults = {
  __typename?: 'UserResults';
  count: Scalars['Float']['output'];
  nextPageToken?: Maybe<Scalars['String']['output']>;
  results: Array<User>;
};

/** Represents the role this user has. */
export enum UserRole {
  Administrator = 'ADMINISTRATOR',
  Agent = 'AGENT',
  Guest = 'GUEST'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  /** Should this user get assigned tickets */
  assignmentPreference?: Maybe<AgentAssignmentPreference>;
};

export type UserSettingsInput = {
  /** Should this user get assigned tickets */
  assignmentPreference?: InputMaybe<AgentAssignmentPreference>;
};

/** Represents the type of user. */
export enum UserType {
  Github = 'GITHUB',
  GrandCustomer = 'GRAND_CUSTOMER',
  Intercom = 'INTERCOM',
  MicrosoftGuest = 'MICROSOFT_GUEST',
  MicrosoftUser = 'MICROSOFT_USER',
  RocketChat = 'ROCKET_CHAT',
  Scim = 'SCIM',
  SlackBot = 'SLACK_BOT',
  SlackUser = 'SLACK_USER',
  Token = 'TOKEN',
  User = 'USER',
  Zendesk = 'ZENDESK'
}

/** The filter of roles per user. */
export type UsersFilters = {
  organizationId?: InputMaybe<Scalars['CompanyUrn']['input']>;
  /** The roles to filter */
  roles: Array<UserRole>;
};

export type Workflow = {
  __typename?: 'Workflow';
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['WorkflowUrn']['output'];
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Array<WorkflowStep>>;
  workflowVersionid: Scalars['WorkflowUrn']['output'];
};

export type WorkflowCondition = {
  comparison?: InputMaybe<Comparison>;
  fieldId?: InputMaybe<Scalars['FormFieldUrn']['input']>;
  replacement?: InputMaybe<Array<FormFieldReplacementInput>>;
  stepId?: InputMaybe<Scalars['WorkflowStepUrn']['input']>;
  value?: InputMaybe<FieldTypedValueInput>;
};

export type WorkflowConditionMapping = {
  mapping: Array<WorkflowConditionValue>;
  valueType: FormFieldType;
};

export type WorkflowConditionValue = {
  conditions: Array<WorkflowCondition>;
  value: FieldTypedValueInput;
};

export type WorkflowFunctionWithParameters = {
  function?: InputMaybe<ActionFunction>;
  parameters: Array<Scalars['String']['input']>;
};

export type WorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<WorkflowStepInput>>;
};

export type WorkflowReference = {
  __typename?: 'WorkflowReference';
  referenceId: Scalars['Urn']['output'];
  workflow?: Maybe<Workflow>;
  workflowId?: Maybe<Scalars['WorkflowUrn']['output']>;
};

export type WorkflowService = {
  __typename?: 'WorkflowService';
  actionTypes?: Maybe<Array<IntegrationActionType>>;
  actions?: Maybe<Array<WorkflowServiceAction>>;
  connection: WorkflowServiceConnection;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['WorkflowServiceUrn']['output'];
  installedIntegrationIds: Array<Scalars['IntegrationUrn']['output']>;
  installedIntegrations: Array<Integration>;
  learnMore?: Maybe<WorkflowServiceLearnMore>;
  longDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options: Array<WorkflowServiceOptionGroup>;
  searchHighlight?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type WorkflowServiceAction = {
  __typename?: 'WorkflowServiceAction';
  allowedChildren?: Maybe<Array<WorkflowServiceChildAction>>;
  contextTypes?: Maybe<Array<ActionContextType>>;
  description: Scalars['String']['output'];
  displayTemplate?: Maybe<FormFieldTemplate>;
  id: Scalars['Urn']['output'];
  input?: Maybe<Array<FormField>>;
  integrations?: Maybe<Array<IntegrationData>>;
  name: Scalars['String']['output'];
  output?: Maybe<Array<WorkflowServiceOutputParameter>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type WorkflowServiceChildAction = {
  __typename?: 'WorkflowServiceChildAction';
  allowedActionIds?: Maybe<Array<Scalars['WorkflowServiceActionUrn']['output']>>;
  description: Scalars['String']['output'];
  id: Scalars['WorkflowServiceActionChildUrn']['output'];
  label: Scalars['String']['output'];
  output?: Maybe<Array<WorkflowServiceOutputParameter>>;
};

export type WorkflowServiceChildActionInput = {
  allowedActionIds?: InputMaybe<Array<Scalars['WorkflowServiceActionUrn']['input']>>;
  description: Scalars['String']['input'];
  id: Scalars['WorkflowServiceActionChildUrn']['input'];
  label: Scalars['String']['input'];
  output?: InputMaybe<Array<WorkflowServiceOutputParameterInput>>;
};

export type WorkflowServiceChoiceFilterInput = {
  context: Scalars['String']['input'];
  currentValues: Array<FieldTypedValueInput>;
  integrationId: Scalars['IntegrationUrn']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowServiceChoiceOptions = {
  __typename?: 'WorkflowServiceChoiceOptions';
  options: Array<FormFieldOption>;
};

export type WorkflowServiceConnection = {
  __typename?: 'WorkflowServiceConnection';
  apiKey?: Maybe<WorkflowServiceConnectionApiKey>;
  buttonText?: Maybe<Scalars['String']['output']>;
  manual?: Maybe<WorkflowServiceConnectionManual>;
  name: Scalars['String']['output'];
  oauth?: Maybe<WorkflowServiceConnectionOAuth>;
  url?: Maybe<WorkflowServiceConnectionUrl>;
};

export type WorkflowServiceConnectionApiKey = {
  __typename?: 'WorkflowServiceConnectionApiKey';
  apiKeyFieldName?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Array<FormField>>;
  instructions: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type WorkflowServiceConnectionManual = {
  __typename?: 'WorkflowServiceConnectionManual';
  input?: Maybe<Array<FormField>>;
  instructions: Scalars['String']['output'];
};

export type WorkflowServiceConnectionOAuth = {
  __typename?: 'WorkflowServiceConnectionOAuth';
  input?: Maybe<Array<FormField>>;
  instructions: Scalars['String']['output'];
};

export type WorkflowServiceConnectionUrl = {
  __typename?: 'WorkflowServiceConnectionUrl';
  url: Scalars['String']['output'];
};

export type WorkflowServiceFilters = {
  isOnlyInstalled: Scalars['Boolean']['input'];
  type?: InputMaybe<ActionContextType>;
};

export type WorkflowServiceInstallApiKeyInput = {
  apiKey: Scalars['String']['input'];
  input: Array<FieldTypedValueInput>;
};

export type WorkflowServiceInstallInput = {
  apiKey?: InputMaybe<WorkflowServiceInstallApiKeyInput>;
  id: Scalars['WorkflowServiceUrn']['input'];
  manual?: InputMaybe<WorkflowServiceInstallManualInput>;
  oauth?: InputMaybe<WorkflowServiceInstallOAuthInput>;
};

export type WorkflowServiceInstallManualInput = {
  input: Array<FieldTypedValueInput>;
};

export type WorkflowServiceInstallOAuthInput = {
  input: Array<FieldTypedValueInput>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowServiceInstallResult = {
  __typename?: 'WorkflowServiceInstallResult';
  /** Returns if the operation was successful. */
  ok: Scalars['Boolean']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type WorkflowServiceLearnMore = {
  __typename?: 'WorkflowServiceLearnMore';
  dataProtectionUrl?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  securityCenterUrl?: Maybe<Scalars['String']['output']>;
  supportCenterUrl?: Maybe<Scalars['String']['output']>;
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type WorkflowServiceOption = {
  __typename?: 'WorkflowServiceOption';
  input?: Maybe<FormField>;
  instructions?: Maybe<Scalars['String']['output']>;
};

export type WorkflowServiceOptionGroup = {
  __typename?: 'WorkflowServiceOptionGroup';
  description?: Maybe<Scalars['String']['output']>;
  options: Array<WorkflowServiceOption>;
  title?: Maybe<Scalars['String']['output']>;
};

export type WorkflowServiceOutputParameter = {
  __typename?: 'WorkflowServiceOutputParameter';
  description: Scalars['String']['output'];
  id: Scalars['WorkflowServiceActionOutputUrn']['output'];
  name: Scalars['String']['output'];
  type: FormFieldType;
};

export type WorkflowServiceOutputParameterInput = {
  description: Scalars['String']['input'];
  id: Scalars['WorkflowServiceActionOutputUrn']['input'];
  name: Scalars['String']['input'];
  type: FormFieldType;
};

export type WorkflowServiceSignedWebhook = {
  __typename?: 'WorkflowServiceSignedWebhook';
  url: Scalars['String']['output'];
};

export type WorkflowServiceWebhookPollResponse = {
  __typename?: 'WorkflowServiceWebhookPollResponse';
  formId?: Maybe<Scalars['FormUrn']['output']>;
  isFound: Scalars['Boolean']['output'];
};

export type WorkflowServiceWebhookRequest = {
  formId?: InputMaybe<Scalars['FormUrn']['input']>;
  isDetached: Scalars['Boolean']['input'];
};

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  action?: Maybe<WorkflowServiceAction>;
  actionId: Scalars['Urn']['output'];
  allowedChildren?: Maybe<Array<WorkflowServiceChildAction>>;
  children?: Maybe<Array<WorkflowStepGroup>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['WorkflowStepUrn']['output']>;
  name: Scalars['String']['output'];
  output?: Maybe<Array<WorkflowStepOutputParameter>>;
  parameters?: Maybe<Array<WorkflowStepParameter>>;
  serviceId?: Maybe<Scalars['Urn']['output']>;
};

export type WorkflowStepGroup = {
  __typename?: 'WorkflowStepGroup';
  children?: Maybe<Array<WorkflowStep>>;
  groupId: Scalars['WorkflowServiceActionChildUrn']['output'];
};

export type WorkflowStepGroupInput = {
  children?: InputMaybe<Array<WorkflowStepInput>>;
  groupId: Scalars['WorkflowServiceActionChildUrn']['input'];
};

export type WorkflowStepInput = {
  actionId: Scalars['Urn']['input'];
  allowedChildren?: InputMaybe<Array<WorkflowServiceChildActionInput>>;
  children?: InputMaybe<Array<WorkflowStepGroupInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['WorkflowStepUrn']['input']>;
  name: Scalars['String']['input'];
  output?: InputMaybe<Array<WorkflowStepOutputParameterInput>>;
  parameters?: InputMaybe<Array<WorkflowStepParameterInput>>;
  serviceId?: InputMaybe<Scalars['Urn']['input']>;
};

export type WorkflowStepKeyValueParameterInput = {
  children?: InputMaybe<Array<WorkflowStepKeyValueParameterInput>>;
  key: Scalars['String']['input'];
  replacement?: InputMaybe<Array<FormFieldReplacementInput>>;
  value: FieldTypedValueInput;
};

export type WorkflowStepOutputParameter = {
  __typename?: 'WorkflowStepOutputParameter';
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['WorkflowServiceActionOutputUrn']['output']>;
  name: Scalars['String']['output'];
  type: FormFieldType;
};

export type WorkflowStepOutputParameterInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['WorkflowServiceActionOutputUrn']['input']>;
  name: Scalars['String']['input'];
  type: FormFieldType;
};

export type WorkflowStepParameter = {
  __typename?: 'WorkflowStepParameter';
  replacement?: Maybe<Array<FormFieldReplacement>>;
  value: FieldTypedValue;
};

export type WorkflowStepParameterInput = {
  replacement?: InputMaybe<Array<FormFieldReplacementInput>>;
  value: FieldTypedValueInput;
};

export type SearchArticlesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ArticleSearchOptions>;
}>;


export type SearchArticlesQuery = { __typename?: 'Query', articles: { __typename?: 'ArticleResults', results: Array<{ __typename?: 'Article', id: any, title: string, iconUrl?: string | null, previewText?: string | null, publishedDate?: any | null, portalId: any }> } };

export type GetAiSignalsQueryVariables = Exact<{
  chatId: Scalars['Urn']['input'];
}>;


export type GetAiSignalsQuery = { __typename?: 'Query', summarizeConversation?: { __typename?: 'ArtificialIntelligenceSummary', summary?: string | null, sentiment?: string | null, agentTone?: string | null, expectedSatisfaction?: number | null, recommendation?: string | null } | null };

export type GetAiPromptQueryVariables = Exact<{
  options: ArtificialIntelligencePromptInput;
}>;


export type GetAiPromptQuery = { __typename?: 'Query', artificialIntelligencePrompt?: { __typename?: 'ArtificialIntelligencePrompt', response: string } | null };

export type CloseSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CloseSettingsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', customization?: { __typename?: 'SettingsCustomization', tags?: Array<string> | null, requiredCloseFields?: Array<RequiredField> | null } | null } | null };

export type CloseTicketStateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CloseTicketStateQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', ticket?: { __typename?: 'Ticket', tags: Array<string> } | null } | null };

export type EndChatMutationVariables = Exact<{
  chatEndMessages: Array<ChatEndInput> | ChatEndInput;
}>;


export type EndChatMutation = { __typename?: 'Mutation', endChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type HoldChatsMutationVariables = Exact<{
  options: HoldInput;
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
}>;


export type HoldChatsMutation = { __typename?: 'Mutation', holdChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type IgnoreMutationVariables = Exact<{
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
}>;


export type IgnoreMutation = { __typename?: 'Mutation', ignoreChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type UnignoreMutationVariables = Exact<{
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
}>;


export type UnignoreMutation = { __typename?: 'Mutation', reopenChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type ExecuteTicketActionMutationVariables = Exact<{
  id: Scalars['Urn']['input'];
  action: TicketInput;
}>;


export type ExecuteTicketActionMutation = { __typename?: 'Mutation', executeTicketAction: { __typename?: 'OkResult', ok: boolean } };

export type GetIntegrationsQueryVariables = Exact<{
  chatId?: InputMaybe<Scalars['Urn']['input']>;
  shouldIncludeServices: Scalars['Boolean']['input'];
}>;


export type GetIntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'Integration', id: any, label: string, type?: IntegrationType | null }> | null, forms: Array<{ __typename?: 'Form', id: any, name: string, description?: string | null, actionSettings?: { __typename?: 'ActionSettings', startCondition?: ActionExecuteStartCondition | null } | null }> };

export type RunIntegrationMutationVariables = Exact<{
  chatId: Scalars['Urn']['input'];
  integrationId: Scalars['IntegrationUrn']['input'];
  formId?: InputMaybe<Scalars['Urn']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<DisplayFormSource>;
  currentValues?: InputMaybe<Array<FieldTypedValueInput> | FieldTypedValueInput>;
}>;


export type RunIntegrationMutation = { __typename?: 'Mutation', runIntegration?: { __typename?: 'IntegrationView', id: any, title: string, submit: string, fields: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> } | null };

export type SubmitIntegrationMutationVariables = Exact<{
  chatId: Scalars['Urn']['input'];
  integrationId: Scalars['IntegrationUrn']['input'];
  form: IntergrationFormSubmit;
}>;


export type SubmitIntegrationMutation = { __typename?: 'Mutation', integrationSubmit: { __typename?: 'OkResult', ok: boolean } };

export type GetAllTicketStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTicketStatesQuery = { __typename?: 'Query', dashboard?: { __typename?: 'Dashboard', settings?: { __typename?: 'DashboardSettings', view?: DashboardView | null, groupBy?: DashboardGroupBy | null, sortBy?: DashboardSortBy | null, ticketView?: TicketView | null, lastConversationCount?: number | null } | null, ticketStates: Array<{ __typename?: 'DashboardTicketState', locationIndex?: number | null, ticketStateId?: any | null, label?: string | null }> } | null };

export type MarkReadMutationVariables = Exact<{
  chatIds: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
}>;


export type MarkReadMutation = { __typename?: 'Mutation', markRead: { __typename?: 'OkResult', ok: boolean } };

export type MarkUnreadMutationVariables = Exact<{
  chatIds: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
}>;


export type MarkUnreadMutation = { __typename?: 'Mutation', markUnread: { __typename?: 'OkResult', ok: boolean } };

export type AddParticipantsMutationVariables = Exact<{
  participants: Array<ChatAddParticipantInput> | ChatAddParticipantInput;
}>;


export type AddParticipantsMutation = { __typename?: 'Mutation', addParticipants?: { __typename?: 'OkResult', ok: boolean } | null };

export type LeaveParticipantMutationVariables = Exact<{
  participant: ChatLeaveParticipantInput;
}>;


export type LeaveParticipantMutation = { __typename?: 'Mutation', leaveParticipant?: { __typename?: 'OkResult', ok: boolean } | null };

export type ParticiapntAddSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParticiapntAddSettingsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', agents?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> | null } | null };

export type SearchAgentChatQueryVariables = Exact<{
  filter?: InputMaybe<TicketView>;
  dashboardId?: InputMaybe<Scalars['DashboardUrn']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SearchFiltersInput>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchAgentChatQuery = { __typename?: 'Query', chats?: { __typename?: 'ChatResults', nextPageToken?: string | null, chats: Array<{ __typename?: 'Chat', id: any, ticketNumber?: number | null, subject?: string | null, status: ChatStatus, priority?: TicketPriority | null, lastMessage?: string | null, holdNotes?: string | null, assigneeId?: any | null, creatorId: any, stateId?: any | null, modifiedDate?: any | null, createdDate?: any | null, lastUserMessageDate?: any | null, currentUserLastReadDate?: any | null, isAssignedToCurrentUser?: boolean | null, isCurrentUserParticipating?: boolean | null, assignee?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null } | null, creator: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null }, source?: { __typename?: 'ChatSource', id?: any | null, type?: string | null, text?: string | null, url?: string | null } | null, searchContext?: { __typename?: 'ChatSearchResultContext', score?: number | null, previews?: Array<{ __typename?: 'ChatSearchResultPreviewContext', field?: string | null, previews?: Array<string> | null }> | null } | null }> } | null };

export type AddTicketStateIdMutationVariables = Exact<{
  chatIds: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
  stateId: Scalars['TicketStateUrn']['input'];
}>;


export type AddTicketStateIdMutation = { __typename?: 'Mutation', addTicketStateId: { __typename?: 'OkResult', ok: boolean } };

export type SnoozeMutationVariables = Exact<{
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
  options: SnoozeInput;
}>;


export type SnoozeMutation = { __typename?: 'Mutation', snoozeChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type SendNoteMutationVariables = Exact<{
  chatId: Scalars['Urn']['input'];
  message: TicketNoteInput;
}>;


export type SendNoteMutation = { __typename?: 'Mutation', saveTicketNote?: { __typename?: 'OkResult', ok: boolean } | null };

export type SaveDraftMutationVariables = Exact<{
  chatId: Scalars['Urn']['input'];
  message: TicketMessageInput;
}>;


export type SaveDraftMutation = { __typename?: 'Mutation', storeMessageDraft?: { __typename?: 'TicketMessage', id: any } | null };

export type ReopenChatsMutationVariables = Exact<{
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
}>;


export type ReopenChatsMutation = { __typename?: 'Mutation', reopenChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type TransferSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransferSettingsQuery = { __typename?: 'Query', queues: Array<{ __typename?: 'Queue', id: any, name: string }>, settings?: { __typename?: 'Settings', agents?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> | null } | null };

export type DeleteArticleTagMutationVariables = Exact<{
  id: Scalars['ArticleTagUrn']['input'];
}>;


export type DeleteArticleTagMutation = { __typename?: 'Mutation', deleteArticleTag: { __typename?: 'OkResult', ok: boolean } };

export type GetArticlesByTagQueryVariables = Exact<{
  tagId: Scalars['ArticleTagUrn']['input'];
}>;


export type GetArticlesByTagQuery = { __typename?: 'Query', articles: { __typename?: 'ArticleResults', results: Array<{ __typename?: 'Article', id: any, title: string, iconUrl?: string | null }> } };

export type GetArticleTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArticleTagsQuery = { __typename?: 'Query', articleTags: Array<{ __typename?: 'ArticleTag', id: any, title: string, iconUrl?: string | null, description?: string | null, childIds: Array<any>, indexPageId?: any | null }> };

export type SaveArticleTagMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ArticleTagUrn']['input']>;
  parentId?: InputMaybe<Scalars['ArticleTagUrn']['input']>;
  articleTag: ArticleTagInput;
}>;


export type SaveArticleTagMutation = { __typename?: 'Mutation', saveArticleTag: { __typename?: 'ArticleTag', id: any, title: string, description?: string | null, iconUrl?: string | null, childIds: Array<any>, indexPageId?: any | null } };

export type AssignChatsMutationVariables = Exact<{
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
  assignment: ChatAssignInput;
}>;


export type AssignChatsMutation = { __typename?: 'Mutation', assignChats?: { __typename?: 'OkResult', ok: boolean } | null };

export type AddReactionMutationVariables = Exact<{
  reaction: TicketMessageReactionInput;
}>;


export type AddReactionMutation = { __typename?: 'Mutation', addReaction?: { __typename?: 'OkResult', ok: boolean } | null };

export type DeleteMessageMutationVariables = Exact<{
  ticketMessageId: Scalars['TicketMessageUrn']['input'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage?: { __typename?: 'OkResult', ok: boolean } | null };

export type EditMessageMutationVariables = Exact<{
  ticketMessageId: Scalars['TicketMessageUrn']['input'];
  message: TicketEditMessageInput;
}>;


export type EditMessageMutation = { __typename?: 'Mutation', editMessage?: { __typename?: 'OkResult', ok: boolean } | null };

export type RemoveReactionMutationVariables = Exact<{
  reaction: TicketMessageReactionInput;
}>;


export type RemoveReactionMutation = { __typename?: 'Mutation', removeReaction?: { __typename?: 'OkResult', ok: boolean } | null };

export type CreateUploadTokenMutationVariables = Exact<{
  attachment: AttachmentCreateInput;
}>;


export type CreateUploadTokenMutation = { __typename?: 'Mutation', createUploadToken?: { __typename?: 'AttachmentCreated', url: string, token: string, error?: string | null } | null };

export type GetChatQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetChatQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', id: any, subject?: string | null, status: ChatStatus, priority?: TicketPriority | null, isAssignedToCurrentUser?: boolean | null, canCurrentUserEdit?: boolean | null, currentUserLastReadDate?: any | null, isCurrentUserParticipating?: boolean | null, assigneeId?: any | null, creatorId: any, stateId?: any | null, assignee?: { __typename?: 'User', id: any, name?: string | null, group?: string | null, avatarUrl?: string | null } | null, creator: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null }, source?: { __typename?: 'ChatSource', type?: string | null, text?: string | null, url?: string | null, id?: any | null, isEditable?: boolean | null } | null, ticket?: { __typename?: 'Ticket', id: any, ticketNumber?: number | null, subject?: string | null, description?: string | null, status: TicketStatus, priority: TicketPriority, createdDate: any, closedDate?: any | null, tags: Array<string>, formId?: any | null, requestorId: any, requestor: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null }, tasks?: Array<{ __typename?: 'TicketTask', id: any, status: TicketTaskState, name?: string | null, description?: string | null, dueDate?: any | null, assigneeId?: any | null, assignee?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null } | null }> | null, customFields?: Array<{ __typename?: 'CustomField', formFieldId: any, type?: FormFieldType | null, displayValue?: string | null, value?: { __typename?: 'CustomFieldValue', string?: string | null, boolean?: boolean | null, date?: any | null, options?: Array<string> | null, number?: number | null } | null }> | null, customContextValues?: Array<{ __typename?: 'TicketCustomContextValue', id: any, label: string, description: string, displayType: IntegrationValueType, displayText: string, value: { __typename?: 'FieldTypedValue', string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } }> | null, messages?: Array<{ __typename?: 'TicketMessage', id: any, type: TicketMessageType, createdDate: any, creatorId?: any | null, isDeleted?: boolean | null, redactedDate?: any | null, creator?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null, plaintext?: string | null }, originalBody?: { __typename?: 'RichBody', html?: string | null, plaintext?: string | null } | null, reactions?: Array<{ __typename?: 'TicketMessageReaction', reaction: string, isCreatedByCurrentUser: boolean }> | null, attachments?: Array<{ __typename?: 'TicketMessageAttachment', url: string, title?: string | null, mimeType?: string | null }> | null, articles?: Array<{ __typename?: 'TicketMessageArticle', id: any, title: string, previewText: string }> | null }> | null, dueDates?: Array<{ __typename?: 'TicketDueDate', type: DueDateType, dueDate: any, startedDate?: any | null, completedDate?: any | null, comments?: string | null }> | null } | null } | null };

export type SaveTicketMutationVariables = Exact<{
  id: Scalars['TicketUrn']['input'];
  ticket: TicketInput;
}>;


export type SaveTicketMutation = { __typename?: 'Mutation', saveTicket: { __typename?: 'Ticket', id: any } };

export type SendMessageMutationVariables = Exact<{
  chatId: Scalars['Urn']['input'];
  message: TicketMessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'TicketMessage', id: any, type: TicketMessageType, creatorId?: any | null, createdDate: any, creator?: { __typename?: 'User', name?: string | null, avatarUrl?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null } } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['CompanyUrn']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteCompany: { __typename?: 'OkResult', ok: boolean } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['UserUrn']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'OkResult', ok: boolean } };

export type GetOrganizationsQueryVariables = Exact<{
  companyIds?: InputMaybe<Array<Scalars['CompanyUrn']['input']> | Scalars['CompanyUrn']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyResults', nextPageToken?: string | null, count: number, results: Array<{ __typename?: 'Company', id: any, name: string, domain: string }> } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, group?: string | null, organizationId?: any | null, loginType?: LoginType | null, handles?: Array<{ __typename?: 'UserHandle', id: any, type: HandleType, email?: { __typename?: 'UserHandleEmail', isVerified: boolean, email: string } | null, application?: { __typename?: 'UserHandleApplication', isVerified: boolean, displayText: string, editableText: string, applicationName: string } | null }> | null } | null };

export type GetUsersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['CompanyUrn']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', guestUsersByCompany?: { __typename?: 'UserResults', nextPageToken?: string | null, count: number, results: Array<{ __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, name?: string | null, avatarUrl?: string | null, organizationId?: any | null, emailAddresses?: Array<string> | null, organization?: { __typename?: 'Company', name: string } | null }> } | null };

export type SaveOrganizationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['CompanyUrn']['input']>;
  organization: CompanyInput;
}>;


export type SaveOrganizationMutation = { __typename?: 'Mutation', saveCompany: { __typename?: 'Company', id: any, name: string, domain: string } };

export type SaveUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Urn']['input']>;
  user: UserInput;
}>;


export type SaveUserMutation = { __typename?: 'Mutation', saveUser: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, organizationId?: any | null, emailAddresses?: Array<string> | null, loginType?: LoginType | null } };

export type CreateTokenMutationVariables = Exact<{
  token: TokenRequestInput;
}>;


export type CreateTokenMutation = { __typename?: 'Mutation', createToken: { __typename?: 'TokenResponse', token: string, permissions: Array<Permission> } };

export type CreateChannelTagMutationVariables = Exact<{
  channelTag: ChannelTagCreateInput;
}>;


export type CreateChannelTagMutation = { __typename?: 'Mutation', createChannelTag?: { __typename?: 'ChannelTagCreated', name?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Urn']['input']>;
  user: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', saveUser: { __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null } };

export type GetConversationUsersQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetConversationUsersQuery = { __typename?: 'Query', conversationSourceUsers?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, group?: string | null }> | null };

export type GetMentionUsersQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetMentionUsersQuery = { __typename?: 'Query', conversationSourceUsers?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, group?: string | null }> | null, settings?: { __typename?: 'Settings', agents?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, group?: string | null }> | null } | null };

export type FieldInputsFragment = { __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null };

export type FormFragment = { __typename?: 'Form', id: any, name: string, description?: string | null, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, name?: string | null, description?: string | null, isRequired?: boolean | null, isRequiredForAgent?: boolean | null, placeholder?: string | null, agentText?: string | null, requestorText?: string | null, defaultValue?: { __typename?: 'FieldTypedReplaceableValue', value: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, number?: number | null, options?: Array<string> | null, date?: any | null, boolean?: boolean | null }, replacements?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null } | null }> };

export type GetConditionalFormQueryVariables = Exact<{
  formId: Scalars['FormUrn']['input'];
  shouldValidateAutomations: Scalars['Boolean']['input'];
}>;


export type GetConditionalFormQuery = { __typename?: 'Query', form?: { __typename?: 'Form', hasAutomation?: boolean, id: any, name: string, description?: string | null, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, name?: string | null, description?: string | null, isRequired?: boolean | null, isRequiredForAgent?: boolean | null, placeholder?: string | null, agentText?: string | null, requestorText?: string | null, defaultValue?: { __typename?: 'FieldTypedReplaceableValue', value: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, number?: number | null, options?: Array<string> | null, date?: any | null, boolean?: boolean | null }, replacements?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null } | null }> } | null };

export type GetFormsQueryVariables = Exact<{
  needforms?: Scalars['Boolean']['input'];
}>;


export type GetFormsQuery = { __typename?: 'Query', formFields: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, asyncObjectType?: AsyncObjectType | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null }> | null }> | null }> | null }> | null }> | null }>, forms?: Array<{ __typename?: 'Form', id: any, name: string, description?: string | null, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, name?: string | null, description?: string | null, isRequired?: boolean | null, isRequiredForAgent?: boolean | null, placeholder?: string | null, agentText?: string | null, requestorText?: string | null, defaultValue?: { __typename?: 'FieldTypedReplaceableValue', value: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, number?: number | null, options?: Array<string> | null, date?: any | null, boolean?: boolean | null }, replacements?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null } | null }> }> };

export type OptionFieldsFragment = { __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null }> | null }> | null }> | null }> | null };

export type OptionFieldChildrenFragment = { __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null };

export type GetSupportSlackConnectChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportSlackConnectChannelQuery = { __typename?: 'Query', supportSlackConnectChannel?: { __typename?: 'SupportChannel', name?: string | null, url?: string | null, isAccepted?: boolean | null } | null };

export type SendSupportSlackConnectMutationVariables = Exact<{ [key: string]: never; }>;


export type SendSupportSlackConnectMutation = { __typename?: 'Mutation', sendSupportSlackConnectChannel?: { __typename?: 'SupportChannel', name?: string | null, url?: string | null, isAccepted?: boolean | null } | null };

export type GetIntegrationUserQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetIntegrationUserQuery = { __typename?: 'Query', integrationUserData?: Array<{ __typename?: 'IntegrationData', id: any, sourceIdentity: any, url?: string | null, label: string, type?: IntegrationType | null, groups: Array<{ __typename?: 'IntegrationDataValueGroup', label: string, links?: Array<{ __typename?: 'IntegrationDataValueLink', label?: string | null, url: string, icon: IntegrationValueLinkIcon }> | null, values: Array<{ __typename?: 'IntegrationDataValue', label: string, value?: string | null, text?: string | null, type: IntegrationValueType, isDefaultDisplayed: boolean }> }> }> | null };

export type GetTicketsByCreatorQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetTicketsByCreatorQuery = { __typename?: 'Query', tickets: Array<{ __typename?: 'Ticket', id: any, ticketNumber?: number | null, subject?: string | null, status: TicketStatus, priority: TicketPriority, createdDate: any, chatId?: any | null }> };

export type GetAgentsQueryVariables = Exact<{
  shouldIncludeGroups?: Scalars['Boolean']['input'];
}>;


export type GetAgentsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', agents?: Array<{ __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null }> | null } | null, userGroups?: Array<{ __typename?: 'UserGroup', id: any, name: string, description?: string | null, users: Array<{ __typename?: 'User', name?: string | null, lastName?: string | null, avatarUrl?: string | null }> }> };

export type GetChannelTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChannelTagsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', channels?: { __typename?: 'SettingsChannels', channelTags?: Array<string> | null } | null } | null };

export type GetConversationSourcesQueryVariables = Exact<{
  shouldIncludeTags?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConversationSourcesQuery = { __typename?: 'Query', conversationSources?: Array<{ __typename?: 'ConversationSource', id: any, label: string, type?: ConversationSourceType | null }> | null };

export type GetDynamicOptionsQueryVariables = Exact<{
  filters: WorkflowServiceChoiceFilterInput;
}>;


export type GetDynamicOptionsQuery = { __typename?: 'Query', workflowServiceChoiceValues?: { __typename?: 'WorkflowServiceChoiceOptions', options: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> } | null };

export type GetChannelEmailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChannelEmailsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', channelEmail?: { __typename?: 'SettingsChannelEmail', emails: Array<{ __typename?: 'SettingsChannelEmailAlias', id: any, originalDestinationEmail?: string | null, isDefault?: boolean | null }> } | null } | null };

export type ListExternalFormsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Urn']['input']>;
  value?: InputMaybe<Scalars['FormExternalUrn']['input']>;
}>;


export type ListExternalFormsQuery = { __typename?: 'Query', externalForms?: Array<{ __typename?: 'ExternalForm', id?: any | null, name?: string | null, hasChildren?: boolean | null, isSelected?: boolean | null }> | null };

export type GetHolidayCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHolidayCountriesQuery = { __typename?: 'Query', holidayCountries?: Array<{ __typename?: 'HolidayCountry', name?: string | null, id?: string | null }> | null };

export type GetAllIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllIntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'Integration', id: any, label: string, type?: IntegrationType | null, actions?: Array<IntegrationActionType> | null }> | null };

export type SearchOrganizationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<Scalars['CompanyUrn']['input']> | Scalars['CompanyUrn']['input']>;
  hasIds: Scalars['Boolean']['input'];
}>;


export type SearchOrganizationsQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyResults', results: Array<{ __typename?: 'Company', id: any, name: string, domain: string }> }, companyResults: { __typename?: 'CompanyResults', results: Array<{ __typename?: 'Company', id: any, name: string, domain: string }> } };

export type GetQueueListQueryVariables = Exact<{
  filters?: InputMaybe<QueueFilters>;
}>;


export type GetQueueListQuery = { __typename?: 'Query', queues: Array<{ __typename?: 'Queue', id: any, name: string }> };

export type ListRequestTypesQueryVariables = Exact<{
  type?: InputMaybe<FormType>;
}>;


export type ListRequestTypesQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', id: any, name: string, description?: string | null }> };

export type GetSeverityLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeverityLabelsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', sla?: { __typename?: 'SettingsSLA', severityLabels?: Array<string> | null } | null } | null };

export type GetSlaTiersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSlaTiersQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', sla?: { __typename?: 'SettingsSLA', tiers?: Array<{ __typename?: 'SettingsSLATier', id?: any | null, name?: string | null }> | null } | null } | null };

export type ListSlackBotsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Urn']['input']>;
}>;


export type ListSlackBotsQuery = { __typename?: 'Query', bots?: Array<{ __typename?: 'Bot', id: any, name: string, avatarUrl?: string | null }> | null };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', customization?: { __typename?: 'SettingsCustomization', tags?: Array<string> | null } | null } | null };

export type GetTicketStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTicketStatesQuery = { __typename?: 'Query', ticketStates: Array<{ __typename?: 'TicketState', id: any, name: string }> };

export type ListUserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: any, name: string }> };

export type SearchUsersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<Scalars['Urn']['input']> | Scalars['Urn']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null }> | null };

export type TicketDueDateFragment = { __typename?: 'Ticket', dueDates?: Array<{ __typename?: 'TicketDueDate', type: DueDateType, dueDate: any, startedDate?: any | null, completedDate?: any | null, comments?: string | null }> | null };

export type StartChatMutationVariables = Exact<{
  message: StartChatInput;
}>;


export type StartChatMutation = { __typename?: 'Mutation', startChat?: { __typename?: 'OkResult', ok: boolean } | null };

export type TagsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsSettingsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', customization?: { __typename?: 'SettingsCustomization', tags?: Array<string> | null } | null } | null };

export type SaveTicketStateStatusMutationVariables = Exact<{
  id: Scalars['TicketTaskUrn']['input'];
  state: TicketTaskState;
}>;


export type SaveTicketStateStatusMutation = { __typename?: 'Mutation', saveTicketStateStatus: { __typename?: 'OkResult', ok: boolean } };

export type TicketTaskFragment = { __typename?: 'TicketTask', id: any, status: TicketTaskState, name?: string | null, description?: string | null, dueDate?: any | null, assigneeId?: any | null, assignee?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null } | null };

export type GetParticipantsForChatQueryVariables = Exact<{
  chatId: Scalars['Urn']['input'];
}>;


export type GetParticipantsForChatQuery = { __typename?: 'Query', getParticipants?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> | null };

export type RemoveParticipantMutationVariables = Exact<{
  participant: ChatLeaveParticipantInput;
}>;


export type RemoveParticipantMutation = { __typename?: 'Mutation', leaveParticipant?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetTicketQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTicketQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', id: any, subject?: string | null, description?: string | null, ticketNumber?: number | null, createdDate: any, modifiedDate: any, lastResponseDate?: any | null, currentUserLastReadDate?: any | null, hasUnreadByCurrentUser?: boolean | null, closedDate?: any | null, chatId?: any | null, status: TicketStatus, assigneeId?: any | null, formId?: any | null, assignee?: { __typename?: 'User', name?: string | null, avatarUrl?: string | null } | null, creator: { __typename?: 'User', name?: string | null, avatarUrl?: string | null }, form?: { __typename?: 'Form', name: string, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, name?: string | null }> } | null, customFields?: Array<{ __typename?: 'CustomField', formFieldId: any, displayValue?: string | null, type?: FormFieldType | null, value?: { __typename?: 'CustomFieldValue', string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null }> | null, messages?: Array<{ __typename?: 'TicketMessage', id: any, type: TicketMessageType, createdDate: any, creator?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null }, reactions?: Array<{ __typename?: 'TicketMessageReaction', reaction: string, isCreatedByCurrentUser: boolean }> | null, attachments?: Array<{ __typename?: 'TicketMessageAttachment', url: string, previewImage?: string | null, title?: string | null }> | null }> | null } | null };

export type CreateWebhookUrlMutationVariables = Exact<{
  stepId: Scalars['WorkflowStepUrn']['input'];
  properties?: InputMaybe<WorkflowServiceWebhookRequest>;
}>;


export type CreateWebhookUrlMutation = { __typename?: 'Mutation', workflowServiceCreateWebhook: { __typename?: 'WorkflowServiceSignedWebhook', url: string } };

export type GetActionFieldsQueryVariables = Exact<{
  id: Scalars['FormUrn']['input'];
}>;


export type GetActionFieldsQuery = { __typename?: 'Query', formFields: Array<{ __typename?: 'FormField', id: any, isSystemField: boolean, name: string, placeholder?: string | null, description?: string | null, type: FormFieldType, levels?: Array<string> | null, userGroupIds?: Array<any> | null, visibility: FormFieldVisibility, asyncObjectType?: AsyncObjectType | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null }> | null }> | null }> | null }> | null }> | null }>, form?: { __typename?: 'Form', id: any, name: string, type?: FormType | null, description?: string | null, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, agentText?: string | null, isRequired?: boolean | null, name?: string | null, description?: string | null, placeholder?: string | null, defaultValue?: { __typename?: 'FieldTypedReplaceableValue', value: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, number?: number | null, options?: Array<string> | null, date?: any | null, boolean?: boolean | null }, replacements?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null } | null }> } | null };

export type DummyRegisterConditionMutationVariables = Exact<{
  condition: WorkflowCondition;
  conditionValue: WorkflowConditionMapping;
  functionValue: WorkflowFunctionWithParameters;
  approvalFormValue: ApprovalFormInput;
  stepParameter: WorkflowStepKeyValueParameterInput;
}>;


export type DummyRegisterConditionMutation = { __typename?: 'Mutation', dummyRegisterCondition?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetInstalledWorkflowServiceActionQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetInstalledWorkflowServiceActionQuery = { __typename?: 'Query', workflowServiceAction?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, integrations?: Array<{ __typename?: 'IntegrationData', id: any, label: string }> | null, displayTemplate?: { __typename?: 'FormFieldTemplate', template?: string | null, parameters?: Array<{ __typename?: 'FormFieldTemplateParameter', key?: string | null, path?: string | null }> | null } | null, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, description: string, type: FormFieldType, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, description: string, type: FormFieldType, id: any }> | null }> | null } | null };

export type GetInstalledWorkflowServiceActionsQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetInstalledWorkflowServiceActionsQuery = { __typename?: 'Query', workflowService?: { __typename?: 'WorkflowService', id: any, name: string, iconUrl?: string | null, actions?: Array<{ __typename?: 'WorkflowServiceAction', id: any, name: string, description: string }> | null } | null };

export type GetInstalledWorkflowSystemActionsQueryVariables = Exact<{
  type: ActionContextType;
}>;


export type GetInstalledWorkflowSystemActionsQuery = { __typename?: 'Query', workflowServiceSystemActions?: Array<{ __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, tags?: Array<string> | null }> | null };

export type GetWorkflowByReferenceQueryVariables = Exact<{
  referenceId: Scalars['Urn']['input'];
}>;


export type GetWorkflowByReferenceQuery = { __typename?: 'Query', workflowReference?: { __typename?: 'WorkflowReference', workflowId?: any | null, workflow?: { __typename?: 'Workflow', id: any, name?: string | null, description?: string | null, iconUrl?: string | null, steps?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null } | null } | null };

export type GetInstalledWorkflowServicesQueryVariables = Exact<{
  type: ActionContextType;
}>;


export type GetInstalledWorkflowServicesQuery = { __typename?: 'Query', workflowServices: Array<{ __typename?: 'WorkflowService', id: any, name: string, shortDescription?: string | null, iconUrl?: string | null, searchHighlight?: string | null, actionTypes?: Array<IntegrationActionType> | null, installedIntegrationIds: Array<any> }> };

export type GetWorkflowByIdQueryVariables = Exact<{
  id: Scalars['WorkflowUrn']['input'];
}>;


export type GetWorkflowByIdQuery = { __typename?: 'Query', workflow?: { __typename?: 'Workflow', id: any, name?: string | null, description?: string | null, iconUrl?: string | null, steps?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null } | null };

export type SaveWorkflowMutationVariables = Exact<{
  id?: InputMaybe<Scalars['WorkflowUrn']['input']>;
  referenceId?: InputMaybe<Scalars['Urn']['input']>;
  workflow: WorkflowInput;
}>;


export type SaveWorkflowMutation = { __typename?: 'Mutation', saveWorkflow?: { __typename?: 'Workflow', id: any, name?: string | null, description?: string | null, iconUrl?: string | null, steps?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null } | null };

export type WorkflowServiceActionFragment = { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null };

export type WorkflowStepGroupFragment = { __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null };

export type WorkflowStepFragment = { __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null };

export type WorkflowStepRecurseFragment = { __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null };

export type WorkflowFragment = { __typename?: 'Workflow', id: any, name?: string | null, description?: string | null, iconUrl?: string | null, steps?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null };

export type GetActiveSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSessionsQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: any, permissions: Array<Permission>, user: { __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, userGroups: Array<{ __typename?: 'UserGroup', id: any }> } } | null };

export type CreateTicketMutationVariables = Exact<{
  ticket: TicketInput;
}>;


export type CreateTicketMutation = { __typename?: 'Mutation', saveTicket: { __typename?: 'Ticket', ticketNumber?: number | null } };

export type GetCurrentPortalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentPortalQuery = { __typename?: 'Query', portal?: { __typename?: 'Portal', id: any, title?: string | null, welcomeMessage?: string | null, chatToken?: string | null, permissions: Array<Permission>, indexArticleId?: any | null, isAIEnabled?: boolean | null, banner?: { __typename?: 'PortalBanner', expirationDate?: any | null, message?: string | null, linkUrl?: string | null, type?: PortalBannerType | null } | null, singleSignOn?: { __typename?: 'PortalSingleSignOn', isEnabled?: boolean | null, loginRedirectUrl?: string | null } | null } | null, featureFlags?: { __typename?: 'FeatureFlags', active?: Array<string> | null } | null };

export type StoreLogsMutationVariables = Exact<{
  logs: LogsInput;
}>;


export type StoreLogsMutation = { __typename?: 'Mutation', storeLogs: { __typename?: 'OkResult', ok: boolean } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'OkResult', ok: boolean } };

export type SubscribeToPortalMutationVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToPortalMutation = { __typename?: 'Mutation', subscribe: { __typename?: 'SessionSocketConnection', sessionToken: string, socketUrl: string } };

export type GetUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpdatesQuery = { __typename?: 'Query', updates?: Array<{ __typename?: 'Article', id: any, title: string, iconUrl?: string | null, publishedDate?: any | null, tags: Array<{ __typename?: 'ArticleTag', id: any, title: string, iconUrl?: string | null }>, publishedBy?: { __typename?: 'User', id: any, name?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null } }> | null, updateCategories: Array<{ __typename?: 'ArticleTag', id: any, title: string, description?: string | null, iconUrl?: string | null }> };

export type GetMigrationTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetMigrationTokenMutation = { __typename?: 'Mutation', getMigrationToken: { __typename?: 'TokenMigrationToken', token: string } };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { __typename?: 'Query', session?: { __typename?: 'Session', user: { __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, emailAddresses?: Array<string> | null, userGroups: Array<{ __typename?: 'UserGroup', id: any, name: string }>, handles?: Array<{ __typename?: 'UserHandle', id: any, type: HandleType, application?: { __typename?: 'UserHandleApplication', isVerified: boolean, displayText: string, editableText: string, applicationName: string } | null }> | null } } | null, userSettings: { __typename?: 'UserSettings', assignmentPreference?: AgentAssignmentPreference | null } };

export type SaveUserFirstLastNameMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Urn']['input']>;
  user: UserInput;
}>;


export type SaveUserFirstLastNameMutation = { __typename?: 'Mutation', saveUser: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null } };

export type SaveUserSettingsMutationVariables = Exact<{
  settings: UserSettingsInput;
}>;


export type SaveUserSettingsMutation = { __typename?: 'Mutation', saveUserSettings: { __typename?: 'UserSettings', assignmentPreference?: AgentAssignmentPreference | null } };

export type UserSettingsFragment = { __typename?: 'UserSettings', assignmentPreference?: AgentAssignmentPreference | null };

export type LoginWithTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithTokenMutation = { __typename?: 'Mutation', loginWithToken: { __typename: 'LoginError', message: string } | { __typename: 'Session', id: any, permissions: Array<Permission> } };

export type LoginWithProviderQueryVariables = Exact<{
  provider: IdentityProviderInput;
}>;


export type LoginWithProviderQuery = { __typename?: 'Query', loginWithIdentityProvider: { __typename?: 'IdentityProviderOptions', url: string } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename: 'LoginError', message: string } | { __typename: 'Session', id: any } };

export type ActionUpdateMutationVariables = Exact<{
  input: ActionInput;
}>;


export type ActionUpdateMutation = { __typename?: 'Mutation', actionUpdate?: { __typename?: 'Action', feedback?: { __typename?: 'ActionFeedback', type: FeedbackType, selectedIndex: number, isCommentAllowed: boolean, responseMessage?: string | null } | null, deflection?: { __typename?: 'ActionDeflection', isSuccessful: boolean } | null } | null };

export type SaveSettingsMutationVariables = Exact<{
  feedback?: InputMaybe<FeedbackInput>;
  customization?: InputMaybe<SettingsCustomizationInput>;
  time?: InputMaybe<SettingsTimeInput>;
  channels?: InputMaybe<SettingsChannelsInput>;
  sla?: InputMaybe<SettingsSlaInput>;
  channelSlack?: InputMaybe<SettingsChannelSlackInput>;
  channelEmail?: InputMaybe<SettingsChannelEmailInput>;
  channelWebChat?: InputMaybe<SettingsChannelWebChatInput>;
  artificialIntelligence?: InputMaybe<SettingsArtificialIntelligenceInput>;
  identities?: InputMaybe<Array<Scalars['Urn']['input']> | Scalars['Urn']['input']>;
}>;


export type SaveSettingsMutation = { __typename?: 'Mutation', saveSettings?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetArtificialIntelligenceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArtificialIntelligenceSettingsQuery = { __typename?: 'Query', artificialIntelligenceSettings?: { __typename?: 'ArtificialIntelligenceSettings', isEnabled: boolean } | null };

export type SaveArtificialIntelligenceSettingsMutationVariables = Exact<{
  settings: ArtificialIntelligenceSettingsInput;
}>;


export type SaveArtificialIntelligenceSettingsMutation = { __typename?: 'Mutation', saveArtificialIntelligenceSettings?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetBillingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingQuery = { __typename?: 'Query', billing?: { __typename?: 'PortalBillingProfile', redirectUrl?: string | null, sessionId?: string | null, pricingTableId?: string | null, publishableKey?: string | null, currentUserEmail?: string | null } | null };

export type DeleteChannelInviteMutationVariables = Exact<{
  id: Scalars['ChannelInviteUrn']['input'];
}>;


export type DeleteChannelInviteMutation = { __typename?: 'Mutation', deleteChannelInvite?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetAdminChannelInviteQueryVariables = Exact<{
  id: Scalars['ChannelInviteUrn']['input'];
}>;


export type GetAdminChannelInviteQuery = { __typename?: 'Query', channelInvite?: { __typename?: 'ChannelInvite', id: any, name: string, description?: string | null, channelNameTemplate: string, introductionTemplate?: string | null, settings: { __typename?: 'ChatSettings', identities?: Array<any> | null, identitiesType?: ChatSettingsIdentitiesType | null, formIds?: Array<any> | null, slaTierId?: any | null, welcomeMessage?: { __typename?: 'DisplayText', rawText?: string | null } | null, options?: { __typename?: 'ChatSettingsOptions', slack?: { __typename?: 'ChatSettingsSlack', name?: string | null, tags?: Array<string> | null, routingPolicies?: Array<any> | null, channelMode?: ChannelMode | null, approvedBotIds?: Array<any> | null, ignoreTicketsFromEmailDomains?: Array<string> | null, ticketCreatedTemplate?: string | null, canFillOutForm?: boolean | null, emojiActions?: Array<{ __typename?: 'ChatSettingsEmojiAction', emoji: string, description?: string | null, workflowId?: any | null, allowedExecuteGroups: Array<any> }> | null } | null, email?: { __typename?: 'ChatSettingsChannelEmail', name?: string | null, shouldSendFeedback?: boolean | null, feedbackIntroduction?: string | null } | null, tag?: { __typename?: 'ChatSettingsTag', name?: string | null } | null, channelMenu?: { __typename?: 'ChatSettingsChannelMenu', menuButtonText?: string | null, action: ChannelMenuAction, afterImageUrl?: string | null, menuText?: { __typename?: 'DisplayText', rawText?: string | null } | null, afterText?: { __typename?: 'DisplayText', rawText?: string | null } | null, welcomeMessage?: { __typename?: 'DisplayText', rawText?: string | null } | null } | null, deflection?: { __typename?: 'ChatSettingsDeflection', isEnabled?: boolean | null, identity?: any | null } | null } | null } } | null };

export type GetChannelInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChannelInvitesQuery = { __typename?: 'Query', channelInvites?: Array<{ __typename?: 'ChannelInvite', id: any, name: string, description?: string | null }> | null };

export type SaveChannelInviteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ChannelInviteUrn']['input']>;
  invite: ChannelInviteInput;
}>;


export type SaveChannelInviteMutation = { __typename?: 'Mutation', saveChannelInvite?: { __typename?: 'ChannelInvite', id: any } | null };

export type AddEmailAliasMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AddEmailAliasMutation = { __typename?: 'Mutation', addEmailAlias?: { __typename?: 'OkResult', ok: boolean } | null };

export type DeleteEmailAliasMutationVariables = Exact<{
  id: Scalars['ChannelEmailUrn']['input'];
}>;


export type DeleteEmailAliasMutation = { __typename?: 'Mutation', deleteEmailAlias?: { __typename?: 'OkResult', ok: boolean } | null };

export type DisableHubSpokeMutationVariables = Exact<{
  settings: HubSpokeDisable;
}>;


export type DisableHubSpokeMutation = { __typename?: 'Mutation', disableHubAndSpoke?: { __typename?: 'OkResult', ok: boolean } | null };

export type EnableHubSpokeMutationVariables = Exact<{
  settings: HubSpokeEnable;
}>;


export type EnableHubSpokeMutation = { __typename?: 'Mutation', enableHubAndSpoke?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetHubMetadataQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetHubMetadataQuery = { __typename?: 'Query', getHubData?: { __typename?: 'HubData', name: string, isSameAsSource: boolean } | null };

export type GetHubSpokeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHubSpokeStatusQuery = { __typename?: 'Query', getHubSpokeStatus?: { __typename?: 'HubSpokeStatus', forwardingTo?: { __typename?: 'HubSpokeStatusForward', id: any, name: string } | null, forwardedFrom: Array<{ __typename?: 'HubSpokeStatusForward', id: any, name: string }> } | null };

export type GetHubSpokeTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHubSpokeTokenQuery = { __typename?: 'Query', hubSpokeToken?: { __typename?: 'HubSpokeToken', token?: string | null } | null };

export type DeleteChatSettingsMutationVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type DeleteChatSettingsMutation = { __typename?: 'Mutation', deleteChatSettings: { __typename?: 'OkResult', ok: boolean } };

export type GetSlackChannelSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSlackChannelSettingsQuery = { __typename?: 'Query', chatSettingsMany?: Array<{ __typename?: 'ChatSettings', id: any, options?: { __typename?: 'ChatSettingsOptions', slack?: { __typename?: 'ChatSettingsSlack', name?: string | null, workspaceName?: string | null, tags?: Array<string> | null } | null } | null }> | null, channelTags?: Array<{ __typename?: 'ChatSettings', id: any, options?: { __typename?: 'ChatSettingsOptions', tag?: { __typename?: 'ChatSettingsTag', name?: string | null } | null } | null }> | null };

export type ChatSettingsFragment = { __typename?: 'ChatSettings', identities?: Array<any> | null, identitiesType?: ChatSettingsIdentitiesType | null, formIds?: Array<any> | null, slaTierId?: any | null, welcomeMessage?: { __typename?: 'DisplayText', rawText?: string | null } | null, options?: { __typename?: 'ChatSettingsOptions', slack?: { __typename?: 'ChatSettingsSlack', name?: string | null, tags?: Array<string> | null, routingPolicies?: Array<any> | null, channelMode?: ChannelMode | null, approvedBotIds?: Array<any> | null, ignoreTicketsFromEmailDomains?: Array<string> | null, ticketCreatedTemplate?: string | null, canFillOutForm?: boolean | null, emojiActions?: Array<{ __typename?: 'ChatSettingsEmojiAction', emoji: string, description?: string | null, workflowId?: any | null, allowedExecuteGroups: Array<any> }> | null } | null, email?: { __typename?: 'ChatSettingsChannelEmail', name?: string | null, shouldSendFeedback?: boolean | null, feedbackIntroduction?: string | null } | null, tag?: { __typename?: 'ChatSettingsTag', name?: string | null } | null, channelMenu?: { __typename?: 'ChatSettingsChannelMenu', menuButtonText?: string | null, action: ChannelMenuAction, afterImageUrl?: string | null, menuText?: { __typename?: 'DisplayText', rawText?: string | null } | null, afterText?: { __typename?: 'DisplayText', rawText?: string | null } | null, welcomeMessage?: { __typename?: 'DisplayText', rawText?: string | null } | null } | null, deflection?: { __typename?: 'ChatSettingsDeflection', isEnabled?: boolean | null, identity?: any | null } | null } | null };

export type GetChatSettingsQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetChatSettingsQuery = { __typename?: 'Query', chatSettings?: { __typename?: 'ChatSettings', identities?: Array<any> | null, identitiesType?: ChatSettingsIdentitiesType | null, formIds?: Array<any> | null, slaTierId?: any | null, welcomeMessage?: { __typename?: 'DisplayText', rawText?: string | null } | null, options?: { __typename?: 'ChatSettingsOptions', slack?: { __typename?: 'ChatSettingsSlack', name?: string | null, tags?: Array<string> | null, routingPolicies?: Array<any> | null, channelMode?: ChannelMode | null, approvedBotIds?: Array<any> | null, ignoreTicketsFromEmailDomains?: Array<string> | null, ticketCreatedTemplate?: string | null, canFillOutForm?: boolean | null, emojiActions?: Array<{ __typename?: 'ChatSettingsEmojiAction', emoji: string, description?: string | null, workflowId?: any | null, allowedExecuteGroups: Array<any> }> | null } | null, email?: { __typename?: 'ChatSettingsChannelEmail', name?: string | null, shouldSendFeedback?: boolean | null, feedbackIntroduction?: string | null } | null, tag?: { __typename?: 'ChatSettingsTag', name?: string | null } | null, channelMenu?: { __typename?: 'ChatSettingsChannelMenu', menuButtonText?: string | null, action: ChannelMenuAction, afterImageUrl?: string | null, menuText?: { __typename?: 'DisplayText', rawText?: string | null } | null, afterText?: { __typename?: 'DisplayText', rawText?: string | null } | null, welcomeMessage?: { __typename?: 'DisplayText', rawText?: string | null } | null } | null, deflection?: { __typename?: 'ChatSettingsDeflection', isEnabled?: boolean | null, identity?: any | null } | null } | null } | null };

export type SaveChatSettingsMutationVariables = Exact<{
  settings: ChatSettingsInput;
  id: Scalars['Urn']['input'];
}>;


export type SaveChatSettingsMutation = { __typename?: 'Mutation', saveChatSettings: { __typename?: 'OkResult', ok: boolean } };

export type DeleteFormFieldMutationVariables = Exact<{
  id: Scalars['FormFieldUrn']['input'];
}>;


export type DeleteFormFieldMutation = { __typename?: 'Mutation', deleteFormField: { __typename?: 'OkResult', ok: boolean } };

export type GetFormFieldQueryVariables = Exact<{
  id: Scalars['FormFieldUrn']['input'];
}>;


export type GetFormFieldQuery = { __typename?: 'Query', formField?: { __typename?: 'FormField', id: any, name: string, description?: string | null, placeholder?: string | null, type: FormFieldType, levels?: Array<string> | null, userGroupIds?: Array<any> | null, visibility: FormFieldVisibility, asyncObjectType?: AsyncObjectType | null, isTemplate?: boolean | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null }> | null }> | null }> | null }> | null }> | null } | null };

export type SaveFormFieldMutationVariables = Exact<{
  formField: FormFieldInput;
  id?: InputMaybe<Scalars['FormFieldUrn']['input']>;
}>;


export type SaveFormFieldMutation = { __typename?: 'Mutation', saveFormField: { __typename?: 'FormField', id: any } };

export type SavePortalSettingsMutationVariables = Exact<{
  portal: PortalSettingsInput;
}>;


export type SavePortalSettingsMutation = { __typename?: 'Mutation', savePortal: { __typename?: 'Portal', id: any } };

export type GetPortalSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortalSettingsQuery = { __typename?: 'Query', portal?: { __typename?: 'Portal', id: any, title?: string | null, welcomeMessage?: string | null, chatToken?: string | null, domains?: Array<string> | null, publicPermissions: Array<Permission>, guestPermissions: Array<Permission>, isSharedChannelGuest?: boolean | null, portalIndexProvider?: PortalIndexProvider | null, publicFormIds?: Array<any> | null, guestFormIds?: Array<any> | null, isAIEnabled?: boolean | null, singleSignOn?: { __typename?: 'PortalSingleSignOn', isEnabled?: boolean | null, loginRedirectUrl?: string | null, identityProviderMetadata?: string | null, providerLoginUrl?: string | null } | null, userProvisioning?: { __typename?: 'PortalUserProvisioning', administratorGroupId?: any | null, providerSCIMUrl?: string | null } | null } | null };

export type DeleteQueueMutationVariables = Exact<{
  id: Scalars['QueueUrn']['input'];
}>;


export type DeleteQueueMutation = { __typename?: 'Mutation', deleteQueue: { __typename?: 'OkResult', ok: boolean } };

export type GetQueueQueryVariables = Exact<{
  id: Scalars['QueueUrn']['input'];
}>;


export type GetQueueQuery = { __typename?: 'Query', queue?: { __typename?: 'Queue', id: any, name: string, description?: string | null, channelTags: Array<string>, integrationIds: Array<any>, emailAliasIds: Array<any>, userAssignmentType?: AssignmentType | null, members: Array<{ __typename?: 'QueueMember', role: QueueMemberRole, userId?: any | null, memberId?: any | null, user?: { __typename?: 'User', id: any, name?: string | null, lastName?: string | null, avatarUrl?: string | null } | null, group?: { __typename?: 'UserGroup', id: any, name: string } | null }> } | null };

export type GetQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueuesQuery = { __typename?: 'Query', queues: Array<{ __typename?: 'Queue', id: any, name: string, description?: string | null, userAssignmentType?: AssignmentType | null, members: Array<{ __typename?: 'QueueMember', userId?: any | null, memberId?: any | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, name?: string | null, avatarUrl?: string | null } | null, group?: { __typename?: 'UserGroup', id: any, name: string } | null }> }>, defaultQueue?: { __typename?: 'Queue', id: any, members: Array<{ __typename?: 'QueueMember', userId?: any | null, memberId?: any | null }> } | null };

export type SaveDefaultQueueMutationVariables = Exact<{
  id?: InputMaybe<Scalars['QueueUrn']['input']>;
}>;


export type SaveDefaultQueueMutation = { __typename?: 'Mutation', saveDefaultQueue: { __typename?: 'OkResult', ok: boolean } };

export type SaveQueueMutationVariables = Exact<{
  queue: QueueInput;
  id?: InputMaybe<Scalars['QueueUrn']['input']>;
}>;


export type SaveQueueMutation = { __typename?: 'Mutation', saveQueue: { __typename?: 'Queue', id: any } };

export type CloneFormMutationVariables = Exact<{
  id: Scalars['FormUrn']['input'];
}>;


export type CloneFormMutation = { __typename?: 'Mutation', cloneForm: { __typename?: 'Form', id: any } };

export type DeleteFormMutationVariables = Exact<{
  id: Scalars['FormUrn']['input'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm: { __typename?: 'OkResult', ok: boolean } };

export type GetExternalFormFieldsQueryVariables = Exact<{
  id: Scalars['FormExternalUrn']['input'];
}>;


export type GetExternalFormFieldsQuery = { __typename?: 'Query', externalFormFields?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null };

export type GetFormDataQueryVariables = Exact<{
  shouldIncludeTemplateFields?: Scalars['Boolean']['input'];
}>;


export type GetFormDataQuery = { __typename?: 'Query', formFields: Array<{ __typename?: 'FormField', id: any, isSystemField: boolean, name: string, placeholder?: string | null, description?: string | null, type: FormFieldType, levels?: Array<string> | null, userGroupIds?: Array<any> | null, visibility: FormFieldVisibility, asyncObjectType?: AsyncObjectType | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, value?: string | null, description?: string | null }> | null }> | null }> | null }> | null }> | null }>, integrations?: Array<{ __typename?: 'Integration', id: any, label: string, type?: IntegrationType | null, actions?: Array<IntegrationActionType> | null }> | null };

export type GetFormQueryVariables = Exact<{
  id: Scalars['FormUrn']['input'];
  hasId?: Scalars['Boolean']['input'];
}>;


export type GetFormQuery = { __typename?: 'Query', form?: { __typename?: 'Form', id: any, name: string, type?: FormType | null, description?: string | null, tags?: Array<string> | null, jobFunctions?: Array<JobFunction> | null, iconUrl?: string | null, shouldCreateOnOnboarding?: boolean | null, isCreatePrivate?: boolean | null, userGroupIds?: Array<any> | null, externalFormId?: any | null, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, agentText?: string | null, requestorText?: string | null, isRequired?: boolean | null, isRequiredForAgent?: boolean | null, name?: string | null, description?: string | null, placeholder?: string | null, defaultValue?: { __typename?: 'FieldTypedReplaceableValue', value: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, number?: number | null, options?: Array<string> | null, date?: any | null, boolean?: boolean | null }, replacements?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null } | null }>, deflection?: { __typename?: 'FormDeflectionSettings', isEnabled?: boolean | null, identity?: any | null } | null, approvals?: Array<{ __typename?: 'Approval', type: ApprovalType, integrationId: any }> | null, workflow?: { __typename?: 'Workflow', id: any, name?: string | null, description?: string | null, iconUrl?: string | null, steps?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, children?: Array<{ __typename?: 'WorkflowStepGroup', groupId: any, children?: Array<{ __typename?: 'WorkflowStep', id?: any | null, actionId: any, name: string, description?: string | null, serviceId?: any | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null }> | null, action?: { __typename?: 'WorkflowServiceAction', id: any, name: string, description: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null } | null, output?: Array<{ __typename?: 'WorkflowStepOutputParameter', name: string, type: FormFieldType, description: string, id?: any | null }> | null, parameters?: Array<{ __typename?: 'WorkflowStepParameter', value: { __typename?: 'FieldTypedValue', displayValue?: string | null, fieldId: any, type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }, replacement?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null }> | null, allowedChildren?: Array<{ __typename?: 'WorkflowServiceChildAction', id: any, label: string, description: string, allowedActionIds?: Array<any> | null, output?: Array<{ __typename?: 'WorkflowServiceOutputParameter', name: string, type: FormFieldType, description: string, id: any }> | null }> | null }> | null } | null, actionSettings?: { __typename?: 'ActionSettings', startCondition?: ActionExecuteStartCondition | null } | null, exampleInput?: { __typename?: 'FormWebhookExample', body?: string | null, headers?: any | null, ipAddress?: string | null, method?: string | null } | null } | null };

export type GetWebhookExampleQueryVariables = Exact<{
  stepId: Scalars['WorkflowStepUrn']['input'];
}>;


export type GetWebhookExampleQuery = { __typename?: 'Query', workflowServicePollWebhookExample: { __typename?: 'WorkflowServiceWebhookPollResponse', isFound: boolean, formId?: any | null } };

export type SaveFormMutationVariables = Exact<{
  id?: InputMaybe<Scalars['FormUrn']['input']>;
  form: FormInput;
}>;


export type SaveFormMutation = { __typename?: 'Mutation', saveForm: { __typename?: 'Form', id: any, name: string, description?: string | null, tags?: Array<string> | null, jobFunctions?: Array<JobFunction> | null, iconUrl?: string | null, fields: Array<{ __typename?: 'FormFieldDescriptor', fieldId?: any | null, isRequired?: boolean | null, isRequiredForAgent?: boolean | null, name?: string | null, description?: string | null, agentText?: string | null, requestorText?: string | null, placeholder?: string | null, defaultValue?: { __typename?: 'FieldTypedReplaceableValue', value: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, number?: number | null, options?: Array<string> | null, date?: any | null, boolean?: boolean | null }, replacements?: Array<{ __typename?: 'FormFieldReplacement', groupId: any, fieldId: any, replacement: string }> | null } | null }> } };

export type GetRequestTypesQueryVariables = Exact<{
  type?: InputMaybe<FormType>;
}>;


export type GetRequestTypesQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', id: any, name: string, description?: string | null, userGroupIds?: Array<any> | null }>, templates: Array<{ __typename?: 'Form', id: any, name: string, description?: string | null, iconUrl?: string | null, jobFunctions?: Array<JobFunction> | null, tags?: Array<string> | null }>, formFields: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, userGroupIds?: Array<any> | null }>, userGroups: Array<{ __typename?: 'UserGroup', id: any, name: string }> };

export type GetTicketStateQueryVariables = Exact<{
  id: Scalars['TicketStateUrn']['input'];
}>;


export type GetTicketStateQuery = { __typename?: 'Query', ticketState?: { __typename?: 'TicketState', id: any, name: string, description: string, ticketStatuses: Array<TicketStatus>, chatStatuses: Array<ChatStatus> } | null };

export type GetTicketStatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTicketStatesListQuery = { __typename?: 'Query', ticketStates: Array<{ __typename?: 'TicketState', id: any, name: string, description: string, ticketStatuses: Array<TicketStatus>, chatStatuses: Array<ChatStatus> }> };

export type SaveTicketStateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['TicketStateUrn']['input']>;
  state: TicketStateInput;
}>;


export type SaveTicketStateMutation = { __typename?: 'Mutation', saveTicketState: { __typename?: 'TicketState', id: any, name: string, description: string } };

export type DeleteUserGroupMutationVariables = Exact<{
  id: Scalars['UserGroupUrn']['input'];
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutation', deleteUserGroup: { __typename?: 'OkResult', ok: boolean } };

export type GetUserGroupQueryVariables = Exact<{
  id: Scalars['UserGroupUrn']['input'];
}>;


export type GetUserGroupQuery = { __typename?: 'Query', userGroup?: { __typename?: 'UserGroup', id: any, name: string, description?: string | null, userIds: Array<any>, users: Array<{ __typename?: 'User', name?: string | null, lastName?: string | null, avatarUrl?: string | null }> } | null };

export type GetUserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: any, name: string, description?: string | null, users: Array<{ __typename?: 'User', name?: string | null, lastName?: string | null, avatarUrl?: string | null }> }> };

export type SaveUserGroupMutationVariables = Exact<{
  userGroup: UserGroupInput;
  id?: InputMaybe<Scalars['UserGroupUrn']['input']>;
}>;


export type SaveUserGroupMutation = { __typename?: 'Mutation', saveUserGroup: { __typename?: 'UserGroup', id: any } };

export type GetUserAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAgentsQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, role: UserRole }> | null, portal?: { __typename?: 'Portal', billing?: { __typename?: 'PortalBilling', isSetup?: boolean | null, purchasedUserCount?: number | null } | null } | null };

export type SetUserRoleMutationVariables = Exact<{
  ids: Array<Scalars['Urn']['input']> | Scalars['Urn']['input'];
  role: UserRole;
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUsersRole?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetWorkflowServiceQueryVariables = Exact<{
  id: Scalars['Urn']['input'];
}>;


export type GetWorkflowServiceQuery = { __typename?: 'Query', workflowService?: { __typename?: 'WorkflowService', id: any, name: string, longDescription?: string | null, iconUrl?: string | null, searchHighlight?: string | null, actionTypes?: Array<IntegrationActionType> | null, installedIntegrationIds: Array<any>, actions?: Array<{ __typename?: 'WorkflowServiceAction', name: string, description: string }> | null, installedIntegrations: Array<{ __typename?: 'Integration', id: any, label: string, settings?: Array<{ __typename?: 'FieldTypedValue', fieldId: any, type: FormFieldType, displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null }> | null, actionPermissions?: Array<{ __typename?: 'IntegrationActionGroupPermission', groupIds: Array<any>, action: IntegrationActionType }> | null }>, options: Array<{ __typename?: 'WorkflowServiceOptionGroup', title?: string | null, description?: string | null, options: Array<{ __typename?: 'WorkflowServiceOption', instructions?: string | null, input?: { __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null } | null }> }>, learnMore?: { __typename?: 'WorkflowServiceLearnMore', websiteUrl?: string | null, termsOfServiceUrl?: string | null, privacyPolicyUrl?: string | null, dataProtectionUrl?: string | null, securityCenterUrl?: string | null, supportCenterUrl?: string | null } | null, connection: { __typename?: 'WorkflowServiceConnection', name: string, buttonText?: string | null, apiKey?: { __typename?: 'WorkflowServiceConnectionApiKey', instructions: string, placeholder?: string | null, apiKeyFieldName?: string | null, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null } | null, manual?: { __typename?: 'WorkflowServiceConnectionManual', instructions: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null } | null, oauth?: { __typename?: 'WorkflowServiceConnectionOAuth', instructions: string, input?: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null, type: FormFieldType, levels?: Array<string> | null, placeholder?: string | null, isRequired?: boolean | null, asyncObjectType?: AsyncObjectType | null, optionsSettings?: { __typename?: 'FormFieldOptionSettings', dynamicChoiceContext?: string | null, emptyOptionsMessage?: string | null } | null, defaultValue?: { __typename?: 'FieldTypedValue', displayValue?: string | null, string?: string | null, boolean?: boolean | null, date?: any | null, number?: number | null, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null, children?: Array<{ __typename?: 'FormFieldOption', label: string, description?: string | null, value?: string | null, dynamicChoiceContext?: string | null }> | null }> | null }> | null }> | null } | null, url?: { __typename?: 'WorkflowServiceConnectionUrl', url: string } | null } } | null };

export type GetWorkflowServicesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkflowServicesQuery = { __typename?: 'Query', workflowServices: Array<{ __typename?: 'WorkflowService', id: any, name: string, shortDescription?: string | null, iconUrl?: string | null, searchHighlight?: string | null, actionTypes?: Array<IntegrationActionType> | null, installedIntegrationIds: Array<any> }> };

export type InstallWorkflowServiceMutationVariables = Exact<{
  install: WorkflowServiceInstallInput;
}>;


export type InstallWorkflowServiceMutation = { __typename?: 'Mutation', workflowServiceInstall: { __typename?: 'WorkflowServiceInstallResult', ok: boolean, redirectUrl?: string | null } };

export type SaveIntegrationSettingsMutationVariables = Exact<{
  settings: IntegrationSettingsInput;
}>;


export type SaveIntegrationSettingsMutation = { __typename?: 'Mutation', integrationSaveSettings: { __typename?: 'OkResult', ok: boolean } };

export type UninstallWorkflowServiceMutationVariables = Exact<{
  integrationId: Scalars['IntegrationUrn']['input'];
}>;


export type UninstallWorkflowServiceMutation = { __typename?: 'Mutation', workflowServiceUninstall: { __typename?: 'OkResult', ok: boolean } };

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = { __typename?: 'Query', settings?: { __typename?: 'Settings', identities?: Array<any> | null, agents?: Array<{ __typename?: 'User', id: any, name?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> | null, customization?: { __typename?: 'SettingsCustomization', tags?: Array<string> | null, requiredCloseFields?: Array<RequiredField> | null, allowOverrideTicketsGroups?: Array<any> | null } | null, channelSlack?: { __typename?: 'SettingsChannelSlack', name?: string | null, iconUrl?: string | null, shouldDisplayAgentJoin?: boolean | null, approvedBotIds?: Array<any> | null, channelMode?: ChannelMode | null, ignoreTicketsFromEmailDomains?: Array<string> | null, formIds?: Array<any> | null, messageActionFormIds?: Array<any> | null, requestFormText?: string | null, shouldAllowUsersAddParticipants?: boolean | null, slaTierId?: any | null, ticketCreatedTemplate?: string | null, canFillOutForm?: boolean | null, introduction?: { __typename?: 'DisplayText', rawText?: string | null } | null, offHoursIntroduction?: { __typename?: 'DisplayText', rawText?: string | null } | null, emojiActions?: Array<{ __typename?: 'ChatSettingsEmojiAction', emoji: string, description?: string | null, workflowId?: any | null, allowedExecuteGroups: Array<any> }> | null } | null, channelEmail?: { __typename?: 'SettingsChannelEmail', footer?: string | null, feedbackIntroduction?: string | null, shouldSendFeedback?: boolean | null, emails: Array<{ __typename?: 'SettingsChannelEmailAlias', id: any, originalDestinationEmail?: string | null, isDefault?: boolean | null }> } | null, channelWebChat?: { __typename?: 'SettingsChannelWebChat', allowedHosts?: Array<string> | null, isReferrerCheckRequired?: boolean | null, name: string, welcomeMessage?: string | null, avatarUrl?: string | null, chatScript: string } | null, channels?: { __typename?: 'SettingsChannels', channelTags?: Array<string> | null } | null, feedback?: { __typename?: 'Feedback', type?: FeedbackType | null, customMessage?: string | null, shouldAllowComments?: boolean | null, responses?: Array<{ __typename?: 'FeedbackResponse', value: number, message?: string | null }> | null } | null, time?: { __typename?: 'SettingsTime', timezone?: string | null, holidayCountryCode?: string | null, hoursOfOperations?: Array<{ __typename?: 'HoursOfOperations', startMinute?: number | null, endMinute?: number | null, dayOfWeek?: DayOfWeek | null }> | null } | null, sla?: { __typename?: 'SettingsSLA', severityLabels?: Array<string> | null, defaultSeverityIndex?: number | null, defaultSLAPolicyId?: any | null, tiers?: Array<{ __typename?: 'SettingsSLATier', id?: any | null, name?: string | null, description?: string | null, values?: Array<{ __typename?: 'SettingsSLATierValue', policies?: Array<{ __typename?: 'SettingsSLATierMetricValue', value?: number | null, metric?: SlaMetric | null, shouldAccountHoursOfOperation?: boolean | null }> | null }> | null }> | null } | null, artificialIntelligence?: { __typename?: 'SettingsArtificialIntelligence', deflection?: { __typename?: 'SettingsAiDeflection', deflectionTicketStatusAssignment?: DeflectionTicketStatusAssignment | null, message?: { __typename?: 'DisplayText', rawText?: string | null } | null } | null } | null } | null };

export type ChatViewFragment = { __typename?: 'Chat', id: any, ticketNumber?: number | null, subject?: string | null, status: ChatStatus, priority?: TicketPriority | null, lastMessage?: string | null, holdNotes?: string | null, assigneeId?: any | null, creatorId: any, stateId?: any | null, modifiedDate?: any | null, createdDate?: any | null, lastUserMessageDate?: any | null, currentUserLastReadDate?: any | null, isAssignedToCurrentUser?: boolean | null, canCurrentUserEdit?: boolean | null, isCurrentUserParticipating?: boolean | null, assignee?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null } | null, creator: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null }, source?: { __typename?: 'ChatSource', id?: any | null, type?: string | null, text?: string | null, url?: string | null } | null, ticket?: { __typename?: 'Ticket', id: any, status: TicketStatus, tags: Array<string>, formId?: any | null, queueId?: any | null, queue?: { __typename?: 'Queue', id: any, name: string } | null, dueDates?: Array<{ __typename?: 'TicketDueDate', type: DueDateType, dueDate: any, startedDate?: any | null, completedDate?: any | null, comments?: string | null }> | null } | null };

export type ListAgentChatQueryVariables = Exact<{
  filter?: InputMaybe<TicketView>;
  dashboardId?: InputMaybe<Scalars['DashboardUrn']['input']>;
}>;


export type ListAgentChatQuery = { __typename?: 'Query', chats?: { __typename?: 'ChatResults', chats: Array<{ __typename?: 'Chat', id: any, ticketNumber?: number | null, subject?: string | null, status: ChatStatus, priority?: TicketPriority | null, lastMessage?: string | null, holdNotes?: string | null, assigneeId?: any | null, creatorId: any, stateId?: any | null, modifiedDate?: any | null, createdDate?: any | null, lastUserMessageDate?: any | null, currentUserLastReadDate?: any | null, isAssignedToCurrentUser?: boolean | null, canCurrentUserEdit?: boolean | null, isCurrentUserParticipating?: boolean | null, assignee?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null } | null, creator: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null, group?: string | null }, source?: { __typename?: 'ChatSource', id?: any | null, type?: string | null, text?: string | null, url?: string | null } | null, ticket?: { __typename?: 'Ticket', id: any, status: TicketStatus, tags: Array<string>, formId?: any | null, queueId?: any | null, queue?: { __typename?: 'Queue', id: any, name: string } | null, dueDates?: Array<{ __typename?: 'TicketDueDate', type: DueDateType, dueDate: any, startedDate?: any | null, completedDate?: any | null, comments?: string | null }> | null } | null }> } | null };

export type ListStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListStatesQuery = { __typename?: 'Query', dashboard?: { __typename?: 'Dashboard', id: any, name: string, settings?: { __typename?: 'DashboardSettings', view?: DashboardView | null, groupBy?: DashboardGroupBy | null, sortBy?: DashboardSortBy | null, ticketView?: TicketView | null, lastConversationCount?: number | null } | null, ticketStates: Array<{ __typename?: 'DashboardTicketState', locationIndex?: number | null, ticketStateId?: any | null, label?: string | null, ticketState: { __typename?: 'TicketState', id: any, name: string, description: string, ticketStatuses: Array<TicketStatus>, chatStatuses: Array<ChatStatus> } }> } | null };

export type UpdateDashboardMutationVariables = Exact<{
  dashboard: DashboardInput;
}>;


export type UpdateDashboardMutation = { __typename?: 'Mutation', updateDashboard: { __typename?: 'OkResult', ok: boolean } };

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['ArticleUrn']['input'];
}>;


export type DeleteArticleMutation = { __typename?: 'Mutation', deleteArticle: { __typename?: 'OkResult', ok: boolean } };

export type GetArticleQueryVariables = Exact<{
  id: Scalars['ArticleUrn']['input'];
}>;


export type GetArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: any, title: string, iconUrl?: string | null, modifiedDate: any, publishedDate?: any | null, tags: Array<{ __typename?: 'ArticleTag', id: any, title: string }>, publishedBy?: { __typename?: 'User', id: any, name?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null }, creator?: { __typename?: 'User', name?: string | null, avatarUrl?: string | null } | null } | null };

export type PublishArticleMutationVariables = Exact<{
  id: Scalars['ArticleUrn']['input'];
  settings?: InputMaybe<ArticlePublishInput>;
}>;


export type PublishArticleMutation = { __typename?: 'Mutation', publishArticle: { __typename?: 'OkResult', ok: boolean } };

export type SaveArticleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ArticleUrn']['input']>;
  article: ArticleInput;
}>;


export type SaveArticleMutation = { __typename?: 'Mutation', saveArticle: { __typename?: 'Article', id: any, modifiedDate: any, title: string, iconUrl?: string | null, publishedDate?: any | null, tags: Array<{ __typename?: 'ArticleTag', id: any, title: string, description?: string | null, iconUrl?: string | null }>, publishedBy?: { __typename?: 'User', id: any, name?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null }, creator?: { __typename?: 'User', name?: string | null, avatarUrl?: string | null } | null } };

export type SetIndexArticleMutationVariables = Exact<{
  id: Scalars['ArticleUrn']['input'];
}>;


export type SetIndexArticleMutation = { __typename?: 'Mutation', setIndexArticle: { __typename?: 'OkResult', ok: boolean } };

export type UnpublishArticleMutationVariables = Exact<{
  id: Scalars['ArticleUrn']['input'];
}>;


export type UnpublishArticleMutation = { __typename?: 'Mutation', unpublishArticle: { __typename?: 'OkResult', ok: boolean } };

export type ListArticlesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ListArticlesQuery = { __typename?: 'Query', articles: { __typename?: 'ArticleResults', count: number, nextPageToken?: string | null, answer?: { __typename?: 'ArticleAnswer', body: string } | null, results: Array<{ __typename?: 'Article', id: any, title: string, iconUrl?: string | null, modifiedDate: any, previewText?: string | null, publishedDate?: any | null, publishedBy?: { __typename?: 'User', name?: string | null } | null, body: { __typename?: 'RichBody', html?: string | null, plaintext?: string | null }, creator?: { __typename?: 'User', id: any, name?: string | null, avatarUrl?: string | null } | null }> } };

export type StoreFeedbackMutationVariables = Exact<{
  feedback: ArticleFeedbackType;
}>;


export type StoreFeedbackMutation = { __typename?: 'Mutation', articleSearchFeedback: { __typename?: 'OkResult', ok: boolean } };

export type GetChannelInviteQueryVariables = Exact<{
  id: Scalars['ChannelInviteUrn']['input'];
}>;


export type GetChannelInviteQuery = { __typename?: 'Query', channelInvite?: { __typename?: 'ChannelInvite', name: string } | null };

export type SendChannelInviteMutationVariables = Exact<{
  invite: SendChannelInviteInput;
}>;


export type SendChannelInviteMutation = { __typename?: 'Mutation', sendChannelInvite?: { __typename?: 'OkResult', ok: boolean } | null };

export type FinishOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishOnboardingMutation = { __typename?: 'Mutation', finishOnboarding?: { __typename?: 'OkResult', ok: boolean } | null };

export type GetOnboardingProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardingProfileQuery = { __typename?: 'Query', onboardingProfile?: { __typename?: 'OnboardingProfile', jobFunction?: JobFunction | null, channelMode?: ChannelMode | null, isEmojiEnabled?: boolean | null, isChannelMenuEnabled?: boolean | null, isExternalSupport?: boolean | null, installedWorkflowServiceId?: any | null, isSelectedFoqalTicketing?: boolean | null, applicationIconUrl?: string | null, applicationName?: string | null, homeStepsCompleted?: Array<string> | null } | null };

export type OnboardingProfileFragment = { __typename?: 'OnboardingProfile', jobFunction?: JobFunction | null, channelMode?: ChannelMode | null, isEmojiEnabled?: boolean | null, isChannelMenuEnabled?: boolean | null, isExternalSupport?: boolean | null, installedWorkflowServiceId?: any | null, isSelectedFoqalTicketing?: boolean | null, applicationIconUrl?: string | null, applicationName?: string | null, homeStepsCompleted?: Array<string> | null };

export type SaveOnboardingProfileMutationVariables = Exact<{
  profile: OnboardingProfileInput;
}>;


export type SaveOnboardingProfileMutation = { __typename?: 'Mutation', saveOnboardingProfile?: { __typename?: 'OnboardingProfile', jobFunction?: JobFunction | null, channelMode?: ChannelMode | null, isEmojiEnabled?: boolean | null, isChannelMenuEnabled?: boolean | null, isExternalSupport?: boolean | null, installedWorkflowServiceId?: any | null, isSelectedFoqalTicketing?: boolean | null, applicationIconUrl?: string | null, applicationName?: string | null, homeStepsCompleted?: Array<string> | null } | null };

export type GetReportsDataQueryVariables = Exact<{
  input: MetricsInput;
}>;


export type GetReportsDataQuery = { __typename?: 'Query', metricsDashboardWithData?: { __typename?: 'MetricsDashboardWithData', dashboard: { __typename?: 'MetricsDashboard', id: any, name: string, settings: { __typename?: 'MetricsDashboardSettings', graphs: Array<{ __typename?: 'MetricsDashboardGraph', type: MetricsDashboardGraphType, dataSource: MetricsDashboardGraphDataSource, title: string, locationX: number, locationY: number, width: number, height: number, dimensions?: Array<{ __typename?: 'MetricsDashboardGraphDimension', fieldId: any, label?: string | null, format?: MetricsDashboardGraphDimensionFormat | null }> | null, metrics?: Array<{ __typename?: 'MetricsDashboardGraphMetric', fieldId: any, aggregation: MetricsDashboardGraphTypeAggregation, label?: string | null, display: MetricsDashboardGraphTypeDisplayType }> | null, filters?: Array<{ __typename?: 'MetricsDashboardGraphFilter', fieldId: any, comparer?: MetricsDashboardGraphFilterComparer | null, value?: { __typename?: 'FieldTypedValueBase', type: FormFieldType, string?: string | null, boolean?: boolean | null, date?: any | null, options?: Array<string> | null, number?: number | null } | null }> | null, sort?: Array<{ __typename?: 'MetricsDashboardGraphSort', fieldId: any, direction: MetricsDashboardSortDirection }> | null }> } }, data: Array<{ __typename?: 'MetricsDashboardData', dataSource?: MetricsDashboardGraphDataSource | null, rows: Array<{ __typename?: 'MetricsDashboardDataRow', id: string, values: Array<string | null> }>, columns: Array<{ __typename?: 'MetricsDashboardDataColumn', id: any, field: { __typename?: 'FormField', name: string, type: FormFieldType } }>, labels: Array<{ __typename?: 'MetricsDashboardDataLabel', id: string, label: string }> }> } | null };

export type GetTemplateFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplateFieldsQuery = { __typename?: 'Query', formFields: Array<{ __typename?: 'FormField', id: any, name: string, description?: string | null }> };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', id: any, name: string, description?: string | null, tags?: Array<string> | null, jobFunctions?: Array<JobFunction> | null, iconUrl?: string | null }> };

export type GetTicketsQueryVariables = Exact<{
  filters?: InputMaybe<TicketFilters>;
  filter?: InputMaybe<TicketView>;
}>;


export type GetTicketsQuery = { __typename?: 'Query', tickets: Array<{ __typename?: 'Ticket', id: any, subject?: string | null, description?: string | null, ticketNumber?: number | null, createdDate: any, lastResponseDate?: any | null, hasUnreadByCurrentUser?: boolean | null, currentUserLastReadDate?: any | null, status: TicketStatus, chatId?: any | null, assignee?: { __typename?: 'User', name?: string | null, avatarUrl?: string | null } | null, creator: { __typename?: 'User', name?: string | null, avatarUrl?: string | null }, form?: { __typename?: 'Form', name: string } | null }> };

export const FormFragmentDoc = gql`
    fragment Form on Form {
  id
  name
  description
  fields {
    fieldId
    name
    description
    isRequired
    isRequiredForAgent
    placeholder
    agentText
    requestorText
    defaultValue {
      value {
        type
        string
        number
        options
        date
        boolean
      }
      replacements {
        groupId
        fieldId
        replacement
      }
    }
  }
}
    `;
export const OptionFieldChildrenFragmentDoc = gql`
    fragment OptionFieldChildren on FormFieldOption {
  label
  value
  description
}
    `;
export const OptionFieldsFragmentDoc = gql`
    fragment OptionFields on FormFieldOption {
  ...OptionFieldChildren
  children {
    ...OptionFieldChildren
    children {
      ...OptionFieldChildren
      children {
        ...OptionFieldChildren
        children {
          ...OptionFieldChildren
        }
      }
    }
  }
}
    ${OptionFieldChildrenFragmentDoc}`;
export const TicketTaskFragmentDoc = gql`
    fragment ticketTask on TicketTask {
  id
  status
  name
  description
  dueDate
  assigneeId
  assignee {
    id
    name
    avatarUrl
  }
}
    `;
export const FieldInputsFragmentDoc = gql`
    fragment FieldInputs on FormField {
  id
  name
  description
  type
  levels
  placeholder
  isRequired
  asyncObjectType
  optionsSettings {
    dynamicChoiceContext
    emptyOptionsMessage
  }
  defaultValue {
    displayValue
    string
    boolean
    date
    number
    options
  }
  options {
    label
    description
    value
    dynamicChoiceContext
    children {
      label
      description
      value
      dynamicChoiceContext
      children {
        label
        description
        value
        dynamicChoiceContext
      }
    }
  }
}
    `;
export const WorkflowServiceActionFragmentDoc = gql`
    fragment WorkflowServiceAction on WorkflowServiceAction {
  id
  name
  description
  input {
    ...FieldInputs
  }
  output {
    name
    type
    description
    id
  }
  allowedChildren {
    id
    label
    description
    allowedActionIds
    output {
      name
      type
      description
      id
    }
  }
}
    ${FieldInputsFragmentDoc}`;
export const WorkflowStepFragmentDoc = gql`
    fragment WorkflowStep on WorkflowStep {
  id
  actionId
  name
  description
  serviceId
  actionId
  action {
    ...WorkflowServiceAction
  }
  output {
    name
    type
    description
    id
  }
  parameters {
    value {
      displayValue
      fieldId
      type
      string
      boolean
      date
      number
      options
    }
    replacement {
      groupId
      fieldId
      replacement
    }
  }
  allowedChildren {
    id
    label
    description
    allowedActionIds
    output {
      name
      type
      description
      id
    }
  }
}
    ${WorkflowServiceActionFragmentDoc}`;
export const WorkflowStepGroupFragmentDoc = gql`
    fragment WorkflowStepGroup on WorkflowStepGroup {
  groupId
  children {
    ...WorkflowStep
  }
}
    ${WorkflowStepFragmentDoc}`;
export const WorkflowStepRecurseFragmentDoc = gql`
    fragment WorkflowStepRecurse on WorkflowStep {
  ...WorkflowStep
  children {
    groupId
    children {
      ...WorkflowStep
      children {
        groupId
        children {
          ...WorkflowStep
          children {
            groupId
            children {
              ...WorkflowStep
              children {
                groupId
                children {
                  ...WorkflowStep
                  children {
                    groupId
                    children {
                      ...WorkflowStep
                      children {
                        groupId
                        children {
                          ...WorkflowStep
                          children {
                            groupId
                            children {
                              ...WorkflowStep
                              children {
                                groupId
                                children {
                                  ...WorkflowStep
                                  children {
                                    groupId
                                    children {
                                      ...WorkflowStep
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${WorkflowStepFragmentDoc}`;
export const WorkflowFragmentDoc = gql`
    fragment Workflow on Workflow {
  id
  name
  description
  iconUrl
  steps {
    ...WorkflowStepRecurse
  }
}
    ${WorkflowStepRecurseFragmentDoc}`;
export const UserSettingsFragmentDoc = gql`
    fragment userSettings on UserSettings {
  assignmentPreference
}
    `;
export const ChatSettingsFragmentDoc = gql`
    fragment chatSettings on ChatSettings {
  identities
  identitiesType
  welcomeMessage {
    rawText
  }
  formIds
  slaTierId
  options {
    slack {
      name
      tags
      routingPolicies
      channelMode
      approvedBotIds
      ignoreTicketsFromEmailDomains
      ticketCreatedTemplate
      canFillOutForm
      emojiActions {
        emoji
        description
        workflowId
        allowedExecuteGroups
      }
    }
    email {
      name
      shouldSendFeedback
      feedbackIntroduction
    }
    tag {
      name
    }
    channelMenu {
      menuText {
        rawText
      }
      menuButtonText
      action
      afterText {
        rawText
      }
      afterImageUrl
      welcomeMessage {
        rawText
      }
    }
    deflection {
      isEnabled
      identity
    }
  }
}
    `;
export const TicketDueDateFragmentDoc = gql`
    fragment ticketDueDate on Ticket {
  dueDates {
    type
    dueDate
    startedDate
    completedDate
    comments
  }
}
    `;
export const ChatViewFragmentDoc = gql`
    fragment ChatView on Chat {
  id
  ticketNumber
  subject
  status
  priority
  lastMessage
  holdNotes
  assigneeId
  assignee {
    id
    name
    avatarUrl
    group
  }
  creatorId
  creator {
    id
    name
    avatarUrl
    group
  }
  stateId
  modifiedDate
  createdDate
  lastUserMessageDate
  currentUserLastReadDate
  isAssignedToCurrentUser
  canCurrentUserEdit
  isCurrentUserParticipating
  source {
    id
    type
    text
    url
  }
  ticket {
    id
    status
    tags
    formId
    queueId
    queue {
      id
      name
    }
    ...ticketDueDate
  }
}
    ${TicketDueDateFragmentDoc}`;
export const OnboardingProfileFragmentDoc = gql`
    fragment OnboardingProfile on OnboardingProfile {
  jobFunction
  channelMode
  isEmojiEnabled
  isChannelMenuEnabled
  isExternalSupport
  installedWorkflowServiceId
  isSelectedFoqalTicketing
  applicationIconUrl
  applicationName
  homeStepsCompleted
}
    `;
export const SearchArticlesDocument = gql`
    query SearchArticles($query: String, $options: ArticleSearchOptions) {
  articles(query: $query, options: $options) {
    results {
      id
      title
      iconUrl
      previewText
      publishedDate
      portalId
    }
  }
}
    `;

/**
 * __useSearchArticlesQuery__
 *
 * To run a query within a React component, call `useSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticlesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchArticlesQuery(baseOptions?: Apollo.QueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
      }
export function useSearchArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export type SearchArticlesQueryHookResult = ReturnType<typeof useSearchArticlesQuery>;
export type SearchArticlesLazyQueryHookResult = ReturnType<typeof useSearchArticlesLazyQuery>;
export type SearchArticlesQueryResult = Apollo.QueryResult<SearchArticlesQuery, SearchArticlesQueryVariables>;
export const GetAiSignalsDocument = gql`
    query GetAISignals($chatId: Urn!) {
  summarizeConversation(chatId: $chatId) {
    summary
    sentiment
    agentTone
    expectedSatisfaction
    recommendation
  }
}
    `;

/**
 * __useGetAiSignalsQuery__
 *
 * To run a query within a React component, call `useGetAiSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiSignalsQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetAiSignalsQuery(baseOptions: Apollo.QueryHookOptions<GetAiSignalsQuery, GetAiSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiSignalsQuery, GetAiSignalsQueryVariables>(GetAiSignalsDocument, options);
      }
export function useGetAiSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiSignalsQuery, GetAiSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiSignalsQuery, GetAiSignalsQueryVariables>(GetAiSignalsDocument, options);
        }
export type GetAiSignalsQueryHookResult = ReturnType<typeof useGetAiSignalsQuery>;
export type GetAiSignalsLazyQueryHookResult = ReturnType<typeof useGetAiSignalsLazyQuery>;
export type GetAiSignalsQueryResult = Apollo.QueryResult<GetAiSignalsQuery, GetAiSignalsQueryVariables>;
export const GetAiPromptDocument = gql`
    query GetAIPrompt($options: ArtificialIntelligencePromptInput!) {
  artificialIntelligencePrompt(options: $options) {
    response
  }
}
    `;

/**
 * __useGetAiPromptQuery__
 *
 * To run a query within a React component, call `useGetAiPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetAiPromptQuery(baseOptions: Apollo.QueryHookOptions<GetAiPromptQuery, GetAiPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptQuery, GetAiPromptQueryVariables>(GetAiPromptDocument, options);
      }
export function useGetAiPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptQuery, GetAiPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptQuery, GetAiPromptQueryVariables>(GetAiPromptDocument, options);
        }
export type GetAiPromptQueryHookResult = ReturnType<typeof useGetAiPromptQuery>;
export type GetAiPromptLazyQueryHookResult = ReturnType<typeof useGetAiPromptLazyQuery>;
export type GetAiPromptQueryResult = Apollo.QueryResult<GetAiPromptQuery, GetAiPromptQueryVariables>;
export const CloseSettingsDocument = gql`
    query CloseSettings {
  settings {
    customization {
      tags
      requiredCloseFields
    }
  }
}
    `;

/**
 * __useCloseSettingsQuery__
 *
 * To run a query within a React component, call `useCloseSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloseSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCloseSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CloseSettingsQuery, CloseSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloseSettingsQuery, CloseSettingsQueryVariables>(CloseSettingsDocument, options);
      }
export function useCloseSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloseSettingsQuery, CloseSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloseSettingsQuery, CloseSettingsQueryVariables>(CloseSettingsDocument, options);
        }
export type CloseSettingsQueryHookResult = ReturnType<typeof useCloseSettingsQuery>;
export type CloseSettingsLazyQueryHookResult = ReturnType<typeof useCloseSettingsLazyQuery>;
export type CloseSettingsQueryResult = Apollo.QueryResult<CloseSettingsQuery, CloseSettingsQueryVariables>;
export const CloseTicketStateDocument = gql`
    query CloseTicketState($id: String!) {
  chat(id: $id) {
    ticket {
      tags
    }
  }
}
    `;

/**
 * __useCloseTicketStateQuery__
 *
 * To run a query within a React component, call `useCloseTicketStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloseTicketStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseTicketStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseTicketStateQuery(baseOptions: Apollo.QueryHookOptions<CloseTicketStateQuery, CloseTicketStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloseTicketStateQuery, CloseTicketStateQueryVariables>(CloseTicketStateDocument, options);
      }
export function useCloseTicketStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloseTicketStateQuery, CloseTicketStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloseTicketStateQuery, CloseTicketStateQueryVariables>(CloseTicketStateDocument, options);
        }
export type CloseTicketStateQueryHookResult = ReturnType<typeof useCloseTicketStateQuery>;
export type CloseTicketStateLazyQueryHookResult = ReturnType<typeof useCloseTicketStateLazyQuery>;
export type CloseTicketStateQueryResult = Apollo.QueryResult<CloseTicketStateQuery, CloseTicketStateQueryVariables>;
export const EndChatDocument = gql`
    mutation EndChat($chatEndMessages: [ChatEndInput!]!) {
  endChats(chatEndMessages: $chatEndMessages) {
    ok
  }
}
    `;
export type EndChatMutationFn = Apollo.MutationFunction<EndChatMutation, EndChatMutationVariables>;

/**
 * __useEndChatMutation__
 *
 * To run a mutation, you first call `useEndChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endChatMutation, { data, loading, error }] = useEndChatMutation({
 *   variables: {
 *      chatEndMessages: // value for 'chatEndMessages'
 *   },
 * });
 */
export function useEndChatMutation(baseOptions?: Apollo.MutationHookOptions<EndChatMutation, EndChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndChatMutation, EndChatMutationVariables>(EndChatDocument, options);
      }
export type EndChatMutationHookResult = ReturnType<typeof useEndChatMutation>;
export type EndChatMutationResult = Apollo.MutationResult<EndChatMutation>;
export type EndChatMutationOptions = Apollo.BaseMutationOptions<EndChatMutation, EndChatMutationVariables>;
export const HoldChatsDocument = gql`
    mutation HoldChats($options: HoldInput!, $ids: [Urn!]!) {
  holdChats(options: $options, ids: $ids) {
    ok
  }
}
    `;
export type HoldChatsMutationFn = Apollo.MutationFunction<HoldChatsMutation, HoldChatsMutationVariables>;

/**
 * __useHoldChatsMutation__
 *
 * To run a mutation, you first call `useHoldChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdChatsMutation, { data, loading, error }] = useHoldChatsMutation({
 *   variables: {
 *      options: // value for 'options'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useHoldChatsMutation(baseOptions?: Apollo.MutationHookOptions<HoldChatsMutation, HoldChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HoldChatsMutation, HoldChatsMutationVariables>(HoldChatsDocument, options);
      }
export type HoldChatsMutationHookResult = ReturnType<typeof useHoldChatsMutation>;
export type HoldChatsMutationResult = Apollo.MutationResult<HoldChatsMutation>;
export type HoldChatsMutationOptions = Apollo.BaseMutationOptions<HoldChatsMutation, HoldChatsMutationVariables>;
export const IgnoreDocument = gql`
    mutation Ignore($ids: [Urn!]!) {
  ignoreChats(ids: $ids) {
    ok
  }
}
    `;
export type IgnoreMutationFn = Apollo.MutationFunction<IgnoreMutation, IgnoreMutationVariables>;

/**
 * __useIgnoreMutation__
 *
 * To run a mutation, you first call `useIgnoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreMutation, { data, loading, error }] = useIgnoreMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIgnoreMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreMutation, IgnoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreMutation, IgnoreMutationVariables>(IgnoreDocument, options);
      }
export type IgnoreMutationHookResult = ReturnType<typeof useIgnoreMutation>;
export type IgnoreMutationResult = Apollo.MutationResult<IgnoreMutation>;
export type IgnoreMutationOptions = Apollo.BaseMutationOptions<IgnoreMutation, IgnoreMutationVariables>;
export const UnignoreDocument = gql`
    mutation Unignore($ids: [Urn!]!) {
  reopenChats(ids: $ids) {
    ok
  }
}
    `;
export type UnignoreMutationFn = Apollo.MutationFunction<UnignoreMutation, UnignoreMutationVariables>;

/**
 * __useUnignoreMutation__
 *
 * To run a mutation, you first call `useUnignoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnignoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unignoreMutation, { data, loading, error }] = useUnignoreMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnignoreMutation(baseOptions?: Apollo.MutationHookOptions<UnignoreMutation, UnignoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnignoreMutation, UnignoreMutationVariables>(UnignoreDocument, options);
      }
export type UnignoreMutationHookResult = ReturnType<typeof useUnignoreMutation>;
export type UnignoreMutationResult = Apollo.MutationResult<UnignoreMutation>;
export type UnignoreMutationOptions = Apollo.BaseMutationOptions<UnignoreMutation, UnignoreMutationVariables>;
export const ExecuteTicketActionDocument = gql`
    mutation ExecuteTicketAction($id: Urn!, $action: TicketInput!) {
  executeTicketAction(id: $id, action: $action) {
    ok
  }
}
    `;
export type ExecuteTicketActionMutationFn = Apollo.MutationFunction<ExecuteTicketActionMutation, ExecuteTicketActionMutationVariables>;

/**
 * __useExecuteTicketActionMutation__
 *
 * To run a mutation, you first call `useExecuteTicketActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteTicketActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeTicketActionMutation, { data, loading, error }] = useExecuteTicketActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useExecuteTicketActionMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteTicketActionMutation, ExecuteTicketActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteTicketActionMutation, ExecuteTicketActionMutationVariables>(ExecuteTicketActionDocument, options);
      }
export type ExecuteTicketActionMutationHookResult = ReturnType<typeof useExecuteTicketActionMutation>;
export type ExecuteTicketActionMutationResult = Apollo.MutationResult<ExecuteTicketActionMutation>;
export type ExecuteTicketActionMutationOptions = Apollo.BaseMutationOptions<ExecuteTicketActionMutation, ExecuteTicketActionMutationVariables>;
export const GetIntegrationsDocument = gql`
    query GetIntegrations($chatId: Urn, $shouldIncludeServices: Boolean!) {
  integrations(chatId: $chatId) @include(if: $shouldIncludeServices) {
    id
    label
    type
  }
  forms(type: ACTION, permission: EXECUTE) {
    id
    name
    description
    actionSettings {
      startCondition
    }
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      shouldIncludeServices: // value for 'shouldIncludeServices'
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const RunIntegrationDocument = gql`
    mutation RunIntegration($chatId: Urn!, $integrationId: IntegrationUrn!, $formId: Urn, $search: String, $source: DisplayFormSource, $currentValues: [FieldTypedValueInput!]) {
  runIntegration(
    chatId: $chatId
    integrationId: $integrationId
    formId: $formId
    search: $search
    source: $source
    currentValues: $currentValues
  ) {
    id
    title
    submit
    fields {
      ...FieldInputs
    }
  }
}
    ${FieldInputsFragmentDoc}`;
export type RunIntegrationMutationFn = Apollo.MutationFunction<RunIntegrationMutation, RunIntegrationMutationVariables>;

/**
 * __useRunIntegrationMutation__
 *
 * To run a mutation, you first call `useRunIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runIntegrationMutation, { data, loading, error }] = useRunIntegrationMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      integrationId: // value for 'integrationId'
 *      formId: // value for 'formId'
 *      search: // value for 'search'
 *      source: // value for 'source'
 *      currentValues: // value for 'currentValues'
 *   },
 * });
 */
export function useRunIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RunIntegrationMutation, RunIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunIntegrationMutation, RunIntegrationMutationVariables>(RunIntegrationDocument, options);
      }
export type RunIntegrationMutationHookResult = ReturnType<typeof useRunIntegrationMutation>;
export type RunIntegrationMutationResult = Apollo.MutationResult<RunIntegrationMutation>;
export type RunIntegrationMutationOptions = Apollo.BaseMutationOptions<RunIntegrationMutation, RunIntegrationMutationVariables>;
export const SubmitIntegrationDocument = gql`
    mutation SubmitIntegration($chatId: Urn!, $integrationId: IntegrationUrn!, $form: IntergrationFormSubmit!) {
  integrationSubmit(chatId: $chatId, integrationId: $integrationId, form: $form) {
    ok
  }
}
    `;
export type SubmitIntegrationMutationFn = Apollo.MutationFunction<SubmitIntegrationMutation, SubmitIntegrationMutationVariables>;

/**
 * __useSubmitIntegrationMutation__
 *
 * To run a mutation, you first call `useSubmitIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitIntegrationMutation, { data, loading, error }] = useSubmitIntegrationMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      integrationId: // value for 'integrationId'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useSubmitIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitIntegrationMutation, SubmitIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitIntegrationMutation, SubmitIntegrationMutationVariables>(SubmitIntegrationDocument, options);
      }
export type SubmitIntegrationMutationHookResult = ReturnType<typeof useSubmitIntegrationMutation>;
export type SubmitIntegrationMutationResult = Apollo.MutationResult<SubmitIntegrationMutation>;
export type SubmitIntegrationMutationOptions = Apollo.BaseMutationOptions<SubmitIntegrationMutation, SubmitIntegrationMutationVariables>;
export const GetAllTicketStatesDocument = gql`
    query GetAllTicketStates {
  dashboard {
    settings {
      view
      groupBy
      sortBy
      ticketView
      lastConversationCount
    }
    ticketStates {
      locationIndex
      ticketStateId
      label
    }
  }
}
    `;

/**
 * __useGetAllTicketStatesQuery__
 *
 * To run a query within a React component, call `useGetAllTicketStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTicketStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTicketStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTicketStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTicketStatesQuery, GetAllTicketStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTicketStatesQuery, GetAllTicketStatesQueryVariables>(GetAllTicketStatesDocument, options);
      }
export function useGetAllTicketStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTicketStatesQuery, GetAllTicketStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTicketStatesQuery, GetAllTicketStatesQueryVariables>(GetAllTicketStatesDocument, options);
        }
export type GetAllTicketStatesQueryHookResult = ReturnType<typeof useGetAllTicketStatesQuery>;
export type GetAllTicketStatesLazyQueryHookResult = ReturnType<typeof useGetAllTicketStatesLazyQuery>;
export type GetAllTicketStatesQueryResult = Apollo.QueryResult<GetAllTicketStatesQuery, GetAllTicketStatesQueryVariables>;
export const MarkReadDocument = gql`
    mutation MarkRead($chatIds: [Urn!]!) {
  markRead(chatIds: $chatIds) {
    ok
  }
}
    `;
export type MarkReadMutationFn = Apollo.MutationFunction<MarkReadMutation, MarkReadMutationVariables>;

/**
 * __useMarkReadMutation__
 *
 * To run a mutation, you first call `useMarkReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReadMutation, { data, loading, error }] = useMarkReadMutation({
 *   variables: {
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useMarkReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkReadMutation, MarkReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkReadMutation, MarkReadMutationVariables>(MarkReadDocument, options);
      }
export type MarkReadMutationHookResult = ReturnType<typeof useMarkReadMutation>;
export type MarkReadMutationResult = Apollo.MutationResult<MarkReadMutation>;
export type MarkReadMutationOptions = Apollo.BaseMutationOptions<MarkReadMutation, MarkReadMutationVariables>;
export const MarkUnreadDocument = gql`
    mutation MarkUnread($chatIds: [Urn!]!) {
  markUnread(chatIds: $chatIds) {
    ok
  }
}
    `;
export type MarkUnreadMutationFn = Apollo.MutationFunction<MarkUnreadMutation, MarkUnreadMutationVariables>;

/**
 * __useMarkUnreadMutation__
 *
 * To run a mutation, you first call `useMarkUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUnreadMutation, { data, loading, error }] = useMarkUnreadMutation({
 *   variables: {
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useMarkUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkUnreadMutation, MarkUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUnreadMutation, MarkUnreadMutationVariables>(MarkUnreadDocument, options);
      }
export type MarkUnreadMutationHookResult = ReturnType<typeof useMarkUnreadMutation>;
export type MarkUnreadMutationResult = Apollo.MutationResult<MarkUnreadMutation>;
export type MarkUnreadMutationOptions = Apollo.BaseMutationOptions<MarkUnreadMutation, MarkUnreadMutationVariables>;
export const AddParticipantsDocument = gql`
    mutation AddParticipants($participants: [ChatAddParticipantInput!]!) {
  addParticipants(participants: $participants) {
    ok
  }
}
    `;
export type AddParticipantsMutationFn = Apollo.MutationFunction<AddParticipantsMutation, AddParticipantsMutationVariables>;

/**
 * __useAddParticipantsMutation__
 *
 * To run a mutation, you first call `useAddParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addParticipantsMutation, { data, loading, error }] = useAddParticipantsMutation({
 *   variables: {
 *      participants: // value for 'participants'
 *   },
 * });
 */
export function useAddParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<AddParticipantsMutation, AddParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddParticipantsMutation, AddParticipantsMutationVariables>(AddParticipantsDocument, options);
      }
export type AddParticipantsMutationHookResult = ReturnType<typeof useAddParticipantsMutation>;
export type AddParticipantsMutationResult = Apollo.MutationResult<AddParticipantsMutation>;
export type AddParticipantsMutationOptions = Apollo.BaseMutationOptions<AddParticipantsMutation, AddParticipantsMutationVariables>;
export const LeaveParticipantDocument = gql`
    mutation LeaveParticipant($participant: ChatLeaveParticipantInput!) {
  leaveParticipant(participant: $participant) {
    ok
  }
}
    `;
export type LeaveParticipantMutationFn = Apollo.MutationFunction<LeaveParticipantMutation, LeaveParticipantMutationVariables>;

/**
 * __useLeaveParticipantMutation__
 *
 * To run a mutation, you first call `useLeaveParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveParticipantMutation, { data, loading, error }] = useLeaveParticipantMutation({
 *   variables: {
 *      participant: // value for 'participant'
 *   },
 * });
 */
export function useLeaveParticipantMutation(baseOptions?: Apollo.MutationHookOptions<LeaveParticipantMutation, LeaveParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveParticipantMutation, LeaveParticipantMutationVariables>(LeaveParticipantDocument, options);
      }
export type LeaveParticipantMutationHookResult = ReturnType<typeof useLeaveParticipantMutation>;
export type LeaveParticipantMutationResult = Apollo.MutationResult<LeaveParticipantMutation>;
export type LeaveParticipantMutationOptions = Apollo.BaseMutationOptions<LeaveParticipantMutation, LeaveParticipantMutationVariables>;
export const ParticiapntAddSettingsDocument = gql`
    query ParticiapntAddSettings {
  settings {
    agents {
      id
      name
      firstName
      lastName
      avatarUrl
    }
  }
}
    `;

/**
 * __useParticiapntAddSettingsQuery__
 *
 * To run a query within a React component, call `useParticiapntAddSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticiapntAddSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticiapntAddSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useParticiapntAddSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ParticiapntAddSettingsQuery, ParticiapntAddSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticiapntAddSettingsQuery, ParticiapntAddSettingsQueryVariables>(ParticiapntAddSettingsDocument, options);
      }
export function useParticiapntAddSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticiapntAddSettingsQuery, ParticiapntAddSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticiapntAddSettingsQuery, ParticiapntAddSettingsQueryVariables>(ParticiapntAddSettingsDocument, options);
        }
export type ParticiapntAddSettingsQueryHookResult = ReturnType<typeof useParticiapntAddSettingsQuery>;
export type ParticiapntAddSettingsLazyQueryHookResult = ReturnType<typeof useParticiapntAddSettingsLazyQuery>;
export type ParticiapntAddSettingsQueryResult = Apollo.QueryResult<ParticiapntAddSettingsQuery, ParticiapntAddSettingsQueryVariables>;
export const SearchAgentChatDocument = gql`
    query SearchAgentChat($filter: TicketView, $dashboardId: DashboardUrn, $query: String, $filters: SearchFiltersInput, $nextPageToken: String) {
  chats(
    filter: $filter
    dashboardId: $dashboardId
    query: $query
    filters: $filters
    nextPageToken: $nextPageToken
  ) {
    chats {
      id
      ticketNumber
      subject
      status
      priority
      lastMessage
      holdNotes
      assigneeId
      assignee {
        id
        name
        avatarUrl
        group
      }
      creatorId
      creator {
        id
        name
        avatarUrl
        group
      }
      stateId
      modifiedDate
      createdDate
      lastUserMessageDate
      currentUserLastReadDate
      isAssignedToCurrentUser
      isCurrentUserParticipating
      source {
        id
        type
        text
        url
      }
      searchContext {
        score
        previews {
          field
          previews
        }
      }
    }
    nextPageToken
  }
}
    `;

/**
 * __useSearchAgentChatQuery__
 *
 * To run a query within a React component, call `useSearchAgentChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAgentChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAgentChatQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      dashboardId: // value for 'dashboardId'
 *      query: // value for 'query'
 *      filters: // value for 'filters'
 *      nextPageToken: // value for 'nextPageToken'
 *   },
 * });
 */
export function useSearchAgentChatQuery(baseOptions?: Apollo.QueryHookOptions<SearchAgentChatQuery, SearchAgentChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAgentChatQuery, SearchAgentChatQueryVariables>(SearchAgentChatDocument, options);
      }
export function useSearchAgentChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAgentChatQuery, SearchAgentChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAgentChatQuery, SearchAgentChatQueryVariables>(SearchAgentChatDocument, options);
        }
export type SearchAgentChatQueryHookResult = ReturnType<typeof useSearchAgentChatQuery>;
export type SearchAgentChatLazyQueryHookResult = ReturnType<typeof useSearchAgentChatLazyQuery>;
export type SearchAgentChatQueryResult = Apollo.QueryResult<SearchAgentChatQuery, SearchAgentChatQueryVariables>;
export const AddTicketStateIdDocument = gql`
    mutation AddTicketStateId($chatIds: [Urn!]!, $stateId: TicketStateUrn!) {
  addTicketStateId(chatIds: $chatIds, stateId: $stateId) {
    ok
  }
}
    `;
export type AddTicketStateIdMutationFn = Apollo.MutationFunction<AddTicketStateIdMutation, AddTicketStateIdMutationVariables>;

/**
 * __useAddTicketStateIdMutation__
 *
 * To run a mutation, you first call `useAddTicketStateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTicketStateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTicketStateIdMutation, { data, loading, error }] = useAddTicketStateIdMutation({
 *   variables: {
 *      chatIds: // value for 'chatIds'
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useAddTicketStateIdMutation(baseOptions?: Apollo.MutationHookOptions<AddTicketStateIdMutation, AddTicketStateIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTicketStateIdMutation, AddTicketStateIdMutationVariables>(AddTicketStateIdDocument, options);
      }
export type AddTicketStateIdMutationHookResult = ReturnType<typeof useAddTicketStateIdMutation>;
export type AddTicketStateIdMutationResult = Apollo.MutationResult<AddTicketStateIdMutation>;
export type AddTicketStateIdMutationOptions = Apollo.BaseMutationOptions<AddTicketStateIdMutation, AddTicketStateIdMutationVariables>;
export const SnoozeDocument = gql`
    mutation Snooze($ids: [Urn!]!, $options: SnoozeInput!) {
  snoozeChats(ids: $ids, options: $options) {
    ok
  }
}
    `;
export type SnoozeMutationFn = Apollo.MutationFunction<SnoozeMutation, SnoozeMutationVariables>;

/**
 * __useSnoozeMutation__
 *
 * To run a mutation, you first call `useSnoozeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeMutation, { data, loading, error }] = useSnoozeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSnoozeMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeMutation, SnoozeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeMutation, SnoozeMutationVariables>(SnoozeDocument, options);
      }
export type SnoozeMutationHookResult = ReturnType<typeof useSnoozeMutation>;
export type SnoozeMutationResult = Apollo.MutationResult<SnoozeMutation>;
export type SnoozeMutationOptions = Apollo.BaseMutationOptions<SnoozeMutation, SnoozeMutationVariables>;
export const SendNoteDocument = gql`
    mutation sendNote($chatId: Urn!, $message: TicketNoteInput!) {
  saveTicketNote(chatId: $chatId, message: $message) {
    ok
  }
}
    `;
export type SendNoteMutationFn = Apollo.MutationFunction<SendNoteMutation, SendNoteMutationVariables>;

/**
 * __useSendNoteMutation__
 *
 * To run a mutation, you first call `useSendNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNoteMutation, { data, loading, error }] = useSendNoteMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendNoteMutation(baseOptions?: Apollo.MutationHookOptions<SendNoteMutation, SendNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNoteMutation, SendNoteMutationVariables>(SendNoteDocument, options);
      }
export type SendNoteMutationHookResult = ReturnType<typeof useSendNoteMutation>;
export type SendNoteMutationResult = Apollo.MutationResult<SendNoteMutation>;
export type SendNoteMutationOptions = Apollo.BaseMutationOptions<SendNoteMutation, SendNoteMutationVariables>;
export const SaveDraftDocument = gql`
    mutation SaveDraft($chatId: Urn!, $message: TicketMessageInput!) {
  storeMessageDraft(chatId: $chatId, message: $message) {
    id
  }
}
    `;
export type SaveDraftMutationFn = Apollo.MutationFunction<SaveDraftMutation, SaveDraftMutationVariables>;

/**
 * __useSaveDraftMutation__
 *
 * To run a mutation, you first call `useSaveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftMutation, { data, loading, error }] = useSaveDraftMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSaveDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveDraftMutation, SaveDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDraftMutation, SaveDraftMutationVariables>(SaveDraftDocument, options);
      }
export type SaveDraftMutationHookResult = ReturnType<typeof useSaveDraftMutation>;
export type SaveDraftMutationResult = Apollo.MutationResult<SaveDraftMutation>;
export type SaveDraftMutationOptions = Apollo.BaseMutationOptions<SaveDraftMutation, SaveDraftMutationVariables>;
export const ReopenChatsDocument = gql`
    mutation ReopenChats($ids: [Urn!]!) {
  reopenChats(ids: $ids) {
    ok
  }
}
    `;
export type ReopenChatsMutationFn = Apollo.MutationFunction<ReopenChatsMutation, ReopenChatsMutationVariables>;

/**
 * __useReopenChatsMutation__
 *
 * To run a mutation, you first call `useReopenChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenChatsMutation, { data, loading, error }] = useReopenChatsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReopenChatsMutation(baseOptions?: Apollo.MutationHookOptions<ReopenChatsMutation, ReopenChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenChatsMutation, ReopenChatsMutationVariables>(ReopenChatsDocument, options);
      }
export type ReopenChatsMutationHookResult = ReturnType<typeof useReopenChatsMutation>;
export type ReopenChatsMutationResult = Apollo.MutationResult<ReopenChatsMutation>;
export type ReopenChatsMutationOptions = Apollo.BaseMutationOptions<ReopenChatsMutation, ReopenChatsMutationVariables>;
export const TransferSettingsDocument = gql`
    query TransferSettings {
  queues {
    id
    name
  }
  settings {
    agents {
      id
      name
      firstName
      lastName
      avatarUrl
    }
  }
}
    `;

/**
 * __useTransferSettingsQuery__
 *
 * To run a query within a React component, call `useTransferSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransferSettingsQuery(baseOptions?: Apollo.QueryHookOptions<TransferSettingsQuery, TransferSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferSettingsQuery, TransferSettingsQueryVariables>(TransferSettingsDocument, options);
      }
export function useTransferSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferSettingsQuery, TransferSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferSettingsQuery, TransferSettingsQueryVariables>(TransferSettingsDocument, options);
        }
export type TransferSettingsQueryHookResult = ReturnType<typeof useTransferSettingsQuery>;
export type TransferSettingsLazyQueryHookResult = ReturnType<typeof useTransferSettingsLazyQuery>;
export type TransferSettingsQueryResult = Apollo.QueryResult<TransferSettingsQuery, TransferSettingsQueryVariables>;
export const DeleteArticleTagDocument = gql`
    mutation DeleteArticleTag($id: ArticleTagUrn!) {
  deleteArticleTag(id: $id) {
    ok
  }
}
    `;
export type DeleteArticleTagMutationFn = Apollo.MutationFunction<DeleteArticleTagMutation, DeleteArticleTagMutationVariables>;

/**
 * __useDeleteArticleTagMutation__
 *
 * To run a mutation, you first call `useDeleteArticleTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleTagMutation, { data, loading, error }] = useDeleteArticleTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticleTagMutation, DeleteArticleTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticleTagMutation, DeleteArticleTagMutationVariables>(DeleteArticleTagDocument, options);
      }
export type DeleteArticleTagMutationHookResult = ReturnType<typeof useDeleteArticleTagMutation>;
export type DeleteArticleTagMutationResult = Apollo.MutationResult<DeleteArticleTagMutation>;
export type DeleteArticleTagMutationOptions = Apollo.BaseMutationOptions<DeleteArticleTagMutation, DeleteArticleTagMutationVariables>;
export const GetArticlesByTagDocument = gql`
    query GetArticlesByTag($tagId: ArticleTagUrn!) {
  articles(tagId: $tagId) {
    results {
      id
      title
      iconUrl
    }
  }
}
    `;

/**
 * __useGetArticlesByTagQuery__
 *
 * To run a query within a React component, call `useGetArticlesByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesByTagQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useGetArticlesByTagQuery(baseOptions: Apollo.QueryHookOptions<GetArticlesByTagQuery, GetArticlesByTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesByTagQuery, GetArticlesByTagQueryVariables>(GetArticlesByTagDocument, options);
      }
export function useGetArticlesByTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesByTagQuery, GetArticlesByTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesByTagQuery, GetArticlesByTagQueryVariables>(GetArticlesByTagDocument, options);
        }
export type GetArticlesByTagQueryHookResult = ReturnType<typeof useGetArticlesByTagQuery>;
export type GetArticlesByTagLazyQueryHookResult = ReturnType<typeof useGetArticlesByTagLazyQuery>;
export type GetArticlesByTagQueryResult = Apollo.QueryResult<GetArticlesByTagQuery, GetArticlesByTagQueryVariables>;
export const GetArticleTagsDocument = gql`
    query GetArticleTags {
  articleTags {
    id
    title
    iconUrl
    description
    childIds
    indexPageId
  }
}
    `;

/**
 * __useGetArticleTagsQuery__
 *
 * To run a query within a React component, call `useGetArticleTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArticleTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleTagsQuery, GetArticleTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleTagsQuery, GetArticleTagsQueryVariables>(GetArticleTagsDocument, options);
      }
export function useGetArticleTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleTagsQuery, GetArticleTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleTagsQuery, GetArticleTagsQueryVariables>(GetArticleTagsDocument, options);
        }
export type GetArticleTagsQueryHookResult = ReturnType<typeof useGetArticleTagsQuery>;
export type GetArticleTagsLazyQueryHookResult = ReturnType<typeof useGetArticleTagsLazyQuery>;
export type GetArticleTagsQueryResult = Apollo.QueryResult<GetArticleTagsQuery, GetArticleTagsQueryVariables>;
export const SaveArticleTagDocument = gql`
    mutation SaveArticleTag($id: ArticleTagUrn, $parentId: ArticleTagUrn, $articleTag: ArticleTagInput!) {
  saveArticleTag(id: $id, parentId: $parentId, articleTag: $articleTag) {
    id
    title
    description
    iconUrl
    childIds
    indexPageId
  }
}
    `;
export type SaveArticleTagMutationFn = Apollo.MutationFunction<SaveArticleTagMutation, SaveArticleTagMutationVariables>;

/**
 * __useSaveArticleTagMutation__
 *
 * To run a mutation, you first call `useSaveArticleTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveArticleTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveArticleTagMutation, { data, loading, error }] = useSaveArticleTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      parentId: // value for 'parentId'
 *      articleTag: // value for 'articleTag'
 *   },
 * });
 */
export function useSaveArticleTagMutation(baseOptions?: Apollo.MutationHookOptions<SaveArticleTagMutation, SaveArticleTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveArticleTagMutation, SaveArticleTagMutationVariables>(SaveArticleTagDocument, options);
      }
export type SaveArticleTagMutationHookResult = ReturnType<typeof useSaveArticleTagMutation>;
export type SaveArticleTagMutationResult = Apollo.MutationResult<SaveArticleTagMutation>;
export type SaveArticleTagMutationOptions = Apollo.BaseMutationOptions<SaveArticleTagMutation, SaveArticleTagMutationVariables>;
export const AssignChatsDocument = gql`
    mutation AssignChats($ids: [Urn!]!, $assignment: ChatAssignInput!) {
  assignChats(ids: $ids, assignment: $assignment) {
    ok
  }
}
    `;
export type AssignChatsMutationFn = Apollo.MutationFunction<AssignChatsMutation, AssignChatsMutationVariables>;

/**
 * __useAssignChatsMutation__
 *
 * To run a mutation, you first call `useAssignChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignChatsMutation, { data, loading, error }] = useAssignChatsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useAssignChatsMutation(baseOptions?: Apollo.MutationHookOptions<AssignChatsMutation, AssignChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignChatsMutation, AssignChatsMutationVariables>(AssignChatsDocument, options);
      }
export type AssignChatsMutationHookResult = ReturnType<typeof useAssignChatsMutation>;
export type AssignChatsMutationResult = Apollo.MutationResult<AssignChatsMutation>;
export type AssignChatsMutationOptions = Apollo.BaseMutationOptions<AssignChatsMutation, AssignChatsMutationVariables>;
export const AddReactionDocument = gql`
    mutation AddReaction($reaction: TicketMessageReactionInput!) {
  addReaction(reaction: $reaction) {
    ok
  }
}
    `;
export type AddReactionMutationFn = Apollo.MutationFunction<AddReactionMutation, AddReactionMutationVariables>;

/**
 * __useAddReactionMutation__
 *
 * To run a mutation, you first call `useAddReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionMutation, { data, loading, error }] = useAddReactionMutation({
 *   variables: {
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useAddReactionMutation(baseOptions?: Apollo.MutationHookOptions<AddReactionMutation, AddReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReactionMutation, AddReactionMutationVariables>(AddReactionDocument, options);
      }
export type AddReactionMutationHookResult = ReturnType<typeof useAddReactionMutation>;
export type AddReactionMutationResult = Apollo.MutationResult<AddReactionMutation>;
export type AddReactionMutationOptions = Apollo.BaseMutationOptions<AddReactionMutation, AddReactionMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($ticketMessageId: TicketMessageUrn!) {
  deleteMessage(ticketMessageId: $ticketMessageId) {
    ok
  }
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      ticketMessageId: // value for 'ticketMessageId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const EditMessageDocument = gql`
    mutation EditMessage($ticketMessageId: TicketMessageUrn!, $message: TicketEditMessageInput!) {
  editMessage(ticketMessageId: $ticketMessageId, message: $message) {
    ok
  }
}
    `;
export type EditMessageMutationFn = Apollo.MutationFunction<EditMessageMutation, EditMessageMutationVariables>;

/**
 * __useEditMessageMutation__
 *
 * To run a mutation, you first call `useEditMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMessageMutation, { data, loading, error }] = useEditMessageMutation({
 *   variables: {
 *      ticketMessageId: // value for 'ticketMessageId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useEditMessageMutation(baseOptions?: Apollo.MutationHookOptions<EditMessageMutation, EditMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMessageMutation, EditMessageMutationVariables>(EditMessageDocument, options);
      }
export type EditMessageMutationHookResult = ReturnType<typeof useEditMessageMutation>;
export type EditMessageMutationResult = Apollo.MutationResult<EditMessageMutation>;
export type EditMessageMutationOptions = Apollo.BaseMutationOptions<EditMessageMutation, EditMessageMutationVariables>;
export const RemoveReactionDocument = gql`
    mutation RemoveReaction($reaction: TicketMessageReactionInput!) {
  removeReaction(reaction: $reaction) {
    ok
  }
}
    `;
export type RemoveReactionMutationFn = Apollo.MutationFunction<RemoveReactionMutation, RemoveReactionMutationVariables>;

/**
 * __useRemoveReactionMutation__
 *
 * To run a mutation, you first call `useRemoveReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionMutation, { data, loading, error }] = useRemoveReactionMutation({
 *   variables: {
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useRemoveReactionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReactionMutation, RemoveReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReactionMutation, RemoveReactionMutationVariables>(RemoveReactionDocument, options);
      }
export type RemoveReactionMutationHookResult = ReturnType<typeof useRemoveReactionMutation>;
export type RemoveReactionMutationResult = Apollo.MutationResult<RemoveReactionMutation>;
export type RemoveReactionMutationOptions = Apollo.BaseMutationOptions<RemoveReactionMutation, RemoveReactionMutationVariables>;
export const CreateUploadTokenDocument = gql`
    mutation createUploadToken($attachment: AttachmentCreateInput!) {
  createUploadToken(attachment: $attachment) {
    url
    token
    error
  }
}
    `;
export type CreateUploadTokenMutationFn = Apollo.MutationFunction<CreateUploadTokenMutation, CreateUploadTokenMutationVariables>;

/**
 * __useCreateUploadTokenMutation__
 *
 * To run a mutation, you first call `useCreateUploadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadTokenMutation, { data, loading, error }] = useCreateUploadTokenMutation({
 *   variables: {
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useCreateUploadTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadTokenMutation, CreateUploadTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadTokenMutation, CreateUploadTokenMutationVariables>(CreateUploadTokenDocument, options);
      }
export type CreateUploadTokenMutationHookResult = ReturnType<typeof useCreateUploadTokenMutation>;
export type CreateUploadTokenMutationResult = Apollo.MutationResult<CreateUploadTokenMutation>;
export type CreateUploadTokenMutationOptions = Apollo.BaseMutationOptions<CreateUploadTokenMutation, CreateUploadTokenMutationVariables>;
export const GetChatDocument = gql`
    query GetChat($id: String!) {
  chat(id: $id) {
    id
    subject
    status
    priority
    isAssignedToCurrentUser
    canCurrentUserEdit
    currentUserLastReadDate
    isCurrentUserParticipating
    assigneeId
    assignee {
      id
      name
      group
      avatarUrl
    }
    creatorId
    creator {
      id
      name
      avatarUrl
      group
    }
    stateId
    source {
      type
      text
      url
      id
      isEditable
    }
    ticket {
      id
      ticketNumber
      subject
      description
      status
      priority
      createdDate
      closedDate
      tags
      formId
      requestorId
      requestor {
        id
        name
        avatarUrl
        group
      }
      tasks {
        ...ticketTask
      }
      customFields {
        formFieldId
        value {
          string
          boolean
          date
          options
          number
        }
        type
        displayValue
      }
      customContextValues {
        id
        label
        description
        displayType
        displayText
        value {
          string
          boolean
          date
          number
          options
        }
      }
      ...ticketDueDate
      messages {
        id
        type
        createdDate
        creatorId
        creator {
          id
          name
          avatarUrl
        }
        body {
          html
          plaintext
        }
        originalBody {
          html
          plaintext
        }
        isDeleted
        redactedDate
        reactions {
          reaction
          isCreatedByCurrentUser
        }
        attachments {
          url
          title
          mimeType
        }
        articles {
          id
          title
          previewText
        }
      }
    }
  }
}
    ${TicketTaskFragmentDoc}
${TicketDueDateFragmentDoc}`;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQuery, GetChatQueryVariables>;
export const SaveTicketDocument = gql`
    mutation SaveTicket($id: TicketUrn!, $ticket: TicketInput!) {
  saveTicket(id: $id, ticket: $ticket) {
    id
  }
}
    `;
export type SaveTicketMutationFn = Apollo.MutationFunction<SaveTicketMutation, SaveTicketMutationVariables>;

/**
 * __useSaveTicketMutation__
 *
 * To run a mutation, you first call `useSaveTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTicketMutation, { data, loading, error }] = useSaveTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useSaveTicketMutation(baseOptions?: Apollo.MutationHookOptions<SaveTicketMutation, SaveTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTicketMutation, SaveTicketMutationVariables>(SaveTicketDocument, options);
      }
export type SaveTicketMutationHookResult = ReturnType<typeof useSaveTicketMutation>;
export type SaveTicketMutationResult = Apollo.MutationResult<SaveTicketMutation>;
export type SaveTicketMutationOptions = Apollo.BaseMutationOptions<SaveTicketMutation, SaveTicketMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($chatId: Urn!, $message: TicketMessageInput!) {
  sendMessage(chatId: $chatId, message: $message) {
    id
    type
    creatorId
    createdDate
    creator {
      name
      avatarUrl
    }
    body {
      html
    }
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: CompanyUrn!) {
  deleteCompany(id: $id) {
    ok
  }
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: UserUrn!) {
  deleteUser(id: $id) {
    ok
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($companyIds: [CompanyUrn!], $limit: Float, $start: Float, $query: String, $nextPageToken: String) {
  companies(
    ids: $companyIds
    limit: $limit
    start: $start
    query: $query
    nextPageToken: $nextPageToken
  ) {
    nextPageToken
    count
    results {
      id
      name
      domain
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      query: // value for 'query'
 *      nextPageToken: // value for 'nextPageToken'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: Urn!) {
  user(id: $id) {
    id
    name
    firstName
    lastName
    avatarUrl
    group
    organizationId
    loginType
    handles {
      id
      type
      email {
        isVerified
        email
      }
      application {
        isVerified
        displayText
        editableText
        applicationName
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($companyId: CompanyUrn, $query: String, $nextPageToken: String, $start: Float, $limit: Float) {
  guestUsersByCompany(
    organizationId: $companyId
    query: $query
    nextPageToken: $nextPageToken
    start: $start
    limit: $limit
  ) {
    results {
      id
      firstName
      lastName
      name
      avatarUrl
      organization {
        name
      }
      organizationId
      emailAddresses
    }
    nextPageToken
    count
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      query: // value for 'query'
 *      nextPageToken: // value for 'nextPageToken'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const SaveOrganizationDocument = gql`
    mutation SaveOrganization($id: CompanyUrn, $organization: CompanyInput!) {
  saveCompany(id: $id, company: $organization) {
    id
    name
    domain
  }
}
    `;
export type SaveOrganizationMutationFn = Apollo.MutationFunction<SaveOrganizationMutation, SaveOrganizationMutationVariables>;

/**
 * __useSaveOrganizationMutation__
 *
 * To run a mutation, you first call `useSaveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganizationMutation, { data, loading, error }] = useSaveOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useSaveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrganizationMutation, SaveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrganizationMutation, SaveOrganizationMutationVariables>(SaveOrganizationDocument, options);
      }
export type SaveOrganizationMutationHookResult = ReturnType<typeof useSaveOrganizationMutation>;
export type SaveOrganizationMutationResult = Apollo.MutationResult<SaveOrganizationMutation>;
export type SaveOrganizationMutationOptions = Apollo.BaseMutationOptions<SaveOrganizationMutation, SaveOrganizationMutationVariables>;
export const SaveUserDocument = gql`
    mutation SaveUser($id: Urn, $user: UserInput!) {
  saveUser(id: $id, user: $user) {
    id
    firstName
    lastName
    organizationId
    emailAddresses
    loginType
  }
}
    `;
export type SaveUserMutationFn = Apollo.MutationFunction<SaveUserMutation, SaveUserMutationVariables>;

/**
 * __useSaveUserMutation__
 *
 * To run a mutation, you first call `useSaveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserMutation, { data, loading, error }] = useSaveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useSaveUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserMutation, SaveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserMutation, SaveUserMutationVariables>(SaveUserDocument, options);
      }
export type SaveUserMutationHookResult = ReturnType<typeof useSaveUserMutation>;
export type SaveUserMutationResult = Apollo.MutationResult<SaveUserMutation>;
export type SaveUserMutationOptions = Apollo.BaseMutationOptions<SaveUserMutation, SaveUserMutationVariables>;
export const CreateTokenDocument = gql`
    mutation CreateToken($token: TokenRequestInput!) {
  createToken(token: $token) {
    token
    permissions
  }
}
    `;
export type CreateTokenMutationFn = Apollo.MutationFunction<CreateTokenMutation, CreateTokenMutationVariables>;

/**
 * __useCreateTokenMutation__
 *
 * To run a mutation, you first call `useCreateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTokenMutation, { data, loading, error }] = useCreateTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateTokenMutation, CreateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTokenMutation, CreateTokenMutationVariables>(CreateTokenDocument, options);
      }
export type CreateTokenMutationHookResult = ReturnType<typeof useCreateTokenMutation>;
export type CreateTokenMutationResult = Apollo.MutationResult<CreateTokenMutation>;
export type CreateTokenMutationOptions = Apollo.BaseMutationOptions<CreateTokenMutation, CreateTokenMutationVariables>;
export const CreateChannelTagDocument = gql`
    mutation CreateChannelTag($channelTag: ChannelTagCreateInput!) {
  createChannelTag(channelTag: $channelTag) {
    name
  }
}
    `;
export type CreateChannelTagMutationFn = Apollo.MutationFunction<CreateChannelTagMutation, CreateChannelTagMutationVariables>;

/**
 * __useCreateChannelTagMutation__
 *
 * To run a mutation, you first call `useCreateChannelTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelTagMutation, { data, loading, error }] = useCreateChannelTagMutation({
 *   variables: {
 *      channelTag: // value for 'channelTag'
 *   },
 * });
 */
export function useCreateChannelTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelTagMutation, CreateChannelTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelTagMutation, CreateChannelTagMutationVariables>(CreateChannelTagDocument, options);
      }
export type CreateChannelTagMutationHookResult = ReturnType<typeof useCreateChannelTagMutation>;
export type CreateChannelTagMutationResult = Apollo.MutationResult<CreateChannelTagMutation>;
export type CreateChannelTagMutationOptions = Apollo.BaseMutationOptions<CreateChannelTagMutation, CreateChannelTagMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($id: Urn, $user: UserInput!) {
  saveUser(id: $id, user: $user) {
    id
    name
    firstName
    lastName
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetConversationUsersDocument = gql`
    query GetConversationUsers($id: Urn!) {
  conversationSourceUsers(conversationSourceId: $id) {
    id
    name
    firstName
    lastName
    avatarUrl
    group
  }
}
    `;

/**
 * __useGetConversationUsersQuery__
 *
 * To run a query within a React component, call `useGetConversationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetConversationUsersQuery, GetConversationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationUsersQuery, GetConversationUsersQueryVariables>(GetConversationUsersDocument, options);
      }
export function useGetConversationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationUsersQuery, GetConversationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationUsersQuery, GetConversationUsersQueryVariables>(GetConversationUsersDocument, options);
        }
export type GetConversationUsersQueryHookResult = ReturnType<typeof useGetConversationUsersQuery>;
export type GetConversationUsersLazyQueryHookResult = ReturnType<typeof useGetConversationUsersLazyQuery>;
export type GetConversationUsersQueryResult = Apollo.QueryResult<GetConversationUsersQuery, GetConversationUsersQueryVariables>;
export const GetMentionUsersDocument = gql`
    query GetMentionUsers($id: Urn!) {
  conversationSourceUsers(conversationSourceId: $id) {
    id
    name
    firstName
    lastName
    avatarUrl
    group
  }
  settings {
    agents {
      id
      name
      firstName
      lastName
      avatarUrl
      group
    }
  }
}
    `;

/**
 * __useGetMentionUsersQuery__
 *
 * To run a query within a React component, call `useGetMentionUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMentionUsersQuery(baseOptions: Apollo.QueryHookOptions<GetMentionUsersQuery, GetMentionUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentionUsersQuery, GetMentionUsersQueryVariables>(GetMentionUsersDocument, options);
      }
export function useGetMentionUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentionUsersQuery, GetMentionUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentionUsersQuery, GetMentionUsersQueryVariables>(GetMentionUsersDocument, options);
        }
export type GetMentionUsersQueryHookResult = ReturnType<typeof useGetMentionUsersQuery>;
export type GetMentionUsersLazyQueryHookResult = ReturnType<typeof useGetMentionUsersLazyQuery>;
export type GetMentionUsersQueryResult = Apollo.QueryResult<GetMentionUsersQuery, GetMentionUsersQueryVariables>;
export const GetConditionalFormDocument = gql`
    query GetConditionalForm($formId: FormUrn!, $shouldValidateAutomations: Boolean!) {
  form(id: $formId) {
    hasAutomation @include(if: $shouldValidateAutomations)
    ...Form
  }
}
    ${FormFragmentDoc}`;

/**
 * __useGetConditionalFormQuery__
 *
 * To run a query within a React component, call `useGetConditionalFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConditionalFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConditionalFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      shouldValidateAutomations: // value for 'shouldValidateAutomations'
 *   },
 * });
 */
export function useGetConditionalFormQuery(baseOptions: Apollo.QueryHookOptions<GetConditionalFormQuery, GetConditionalFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConditionalFormQuery, GetConditionalFormQueryVariables>(GetConditionalFormDocument, options);
      }
export function useGetConditionalFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConditionalFormQuery, GetConditionalFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConditionalFormQuery, GetConditionalFormQueryVariables>(GetConditionalFormDocument, options);
        }
export type GetConditionalFormQueryHookResult = ReturnType<typeof useGetConditionalFormQuery>;
export type GetConditionalFormLazyQueryHookResult = ReturnType<typeof useGetConditionalFormLazyQuery>;
export type GetConditionalFormQueryResult = Apollo.QueryResult<GetConditionalFormQuery, GetConditionalFormQueryVariables>;
export const GetFormsDocument = gql`
    query GetForms($needforms: Boolean! = false) {
  formFields(shouldIncludeSystemFields: true, shouldIncludePrivate: true) {
    id
    name
    description
    type
    levels
    options {
      ...OptionFields
    }
    asyncObjectType
  }
  forms @include(if: $needforms) {
    ...Form
  }
}
    ${OptionFieldsFragmentDoc}
${FormFragmentDoc}`;

/**
 * __useGetFormsQuery__
 *
 * To run a query within a React component, call `useGetFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsQuery({
 *   variables: {
 *      needforms: // value for 'needforms'
 *   },
 * });
 */
export function useGetFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
      }
export function useGetFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
        }
export type GetFormsQueryHookResult = ReturnType<typeof useGetFormsQuery>;
export type GetFormsLazyQueryHookResult = ReturnType<typeof useGetFormsLazyQuery>;
export type GetFormsQueryResult = Apollo.QueryResult<GetFormsQuery, GetFormsQueryVariables>;
export const GetSupportSlackConnectChannelDocument = gql`
    query GetSupportSlackConnectChannel {
  supportSlackConnectChannel {
    name
    url
    isAccepted
  }
}
    `;

/**
 * __useGetSupportSlackConnectChannelQuery__
 *
 * To run a query within a React component, call `useGetSupportSlackConnectChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportSlackConnectChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportSlackConnectChannelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportSlackConnectChannelQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportSlackConnectChannelQuery, GetSupportSlackConnectChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportSlackConnectChannelQuery, GetSupportSlackConnectChannelQueryVariables>(GetSupportSlackConnectChannelDocument, options);
      }
export function useGetSupportSlackConnectChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportSlackConnectChannelQuery, GetSupportSlackConnectChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportSlackConnectChannelQuery, GetSupportSlackConnectChannelQueryVariables>(GetSupportSlackConnectChannelDocument, options);
        }
export type GetSupportSlackConnectChannelQueryHookResult = ReturnType<typeof useGetSupportSlackConnectChannelQuery>;
export type GetSupportSlackConnectChannelLazyQueryHookResult = ReturnType<typeof useGetSupportSlackConnectChannelLazyQuery>;
export type GetSupportSlackConnectChannelQueryResult = Apollo.QueryResult<GetSupportSlackConnectChannelQuery, GetSupportSlackConnectChannelQueryVariables>;
export const SendSupportSlackConnectDocument = gql`
    mutation SendSupportSlackConnect {
  sendSupportSlackConnectChannel {
    name
    url
    isAccepted
  }
}
    `;
export type SendSupportSlackConnectMutationFn = Apollo.MutationFunction<SendSupportSlackConnectMutation, SendSupportSlackConnectMutationVariables>;

/**
 * __useSendSupportSlackConnectMutation__
 *
 * To run a mutation, you first call `useSendSupportSlackConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportSlackConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportSlackConnectMutation, { data, loading, error }] = useSendSupportSlackConnectMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendSupportSlackConnectMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportSlackConnectMutation, SendSupportSlackConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportSlackConnectMutation, SendSupportSlackConnectMutationVariables>(SendSupportSlackConnectDocument, options);
      }
export type SendSupportSlackConnectMutationHookResult = ReturnType<typeof useSendSupportSlackConnectMutation>;
export type SendSupportSlackConnectMutationResult = Apollo.MutationResult<SendSupportSlackConnectMutation>;
export type SendSupportSlackConnectMutationOptions = Apollo.BaseMutationOptions<SendSupportSlackConnectMutation, SendSupportSlackConnectMutationVariables>;
export const GetIntegrationUserDocument = gql`
    query GetIntegrationUser($id: Urn!) {
  integrationUserData(id: $id) {
    id
    sourceIdentity
    url
    label
    type
    groups {
      label
      links {
        label
        url
        icon
      }
      values {
        label
        value
        text
        type
        isDefaultDisplayed
      }
    }
  }
}
    `;

/**
 * __useGetIntegrationUserQuery__
 *
 * To run a query within a React component, call `useGetIntegrationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationUserQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationUserQuery, GetIntegrationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationUserQuery, GetIntegrationUserQueryVariables>(GetIntegrationUserDocument, options);
      }
export function useGetIntegrationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationUserQuery, GetIntegrationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationUserQuery, GetIntegrationUserQueryVariables>(GetIntegrationUserDocument, options);
        }
export type GetIntegrationUserQueryHookResult = ReturnType<typeof useGetIntegrationUserQuery>;
export type GetIntegrationUserLazyQueryHookResult = ReturnType<typeof useGetIntegrationUserLazyQuery>;
export type GetIntegrationUserQueryResult = Apollo.QueryResult<GetIntegrationUserQuery, GetIntegrationUserQueryVariables>;
export const GetTicketsByCreatorDocument = gql`
    query GetTicketsByCreator($id: Urn!) {
  tickets(filters: {creatorId: $id, limit: 40}) {
    id
    ticketNumber
    subject
    status
    priority
    createdDate
    chatId
  }
}
    `;

/**
 * __useGetTicketsByCreatorQuery__
 *
 * To run a query within a React component, call `useGetTicketsByCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsByCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsByCreatorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTicketsByCreatorQuery(baseOptions: Apollo.QueryHookOptions<GetTicketsByCreatorQuery, GetTicketsByCreatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketsByCreatorQuery, GetTicketsByCreatorQueryVariables>(GetTicketsByCreatorDocument, options);
      }
export function useGetTicketsByCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketsByCreatorQuery, GetTicketsByCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketsByCreatorQuery, GetTicketsByCreatorQueryVariables>(GetTicketsByCreatorDocument, options);
        }
export type GetTicketsByCreatorQueryHookResult = ReturnType<typeof useGetTicketsByCreatorQuery>;
export type GetTicketsByCreatorLazyQueryHookResult = ReturnType<typeof useGetTicketsByCreatorLazyQuery>;
export type GetTicketsByCreatorQueryResult = Apollo.QueryResult<GetTicketsByCreatorQuery, GetTicketsByCreatorQueryVariables>;
export const GetAgentsDocument = gql`
    query GetAgents($shouldIncludeGroups: Boolean! = false) {
  settings {
    agents {
      id
      name
      avatarUrl
    }
  }
  userGroups @include(if: $shouldIncludeGroups) {
    id
    name
    description
    users {
      name
      lastName
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsQuery({
 *   variables: {
 *      shouldIncludeGroups: // value for 'shouldIncludeGroups'
 *   },
 * });
 */
export function useGetAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
      }
export function useGetAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
        }
export type GetAgentsQueryHookResult = ReturnType<typeof useGetAgentsQuery>;
export type GetAgentsLazyQueryHookResult = ReturnType<typeof useGetAgentsLazyQuery>;
export type GetAgentsQueryResult = Apollo.QueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export const GetChannelTagsDocument = gql`
    query GetChannelTags {
  settings {
    channels {
      channelTags
    }
  }
}
    `;

/**
 * __useGetChannelTagsQuery__
 *
 * To run a query within a React component, call `useGetChannelTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelTagsQuery, GetChannelTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelTagsQuery, GetChannelTagsQueryVariables>(GetChannelTagsDocument, options);
      }
export function useGetChannelTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelTagsQuery, GetChannelTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelTagsQuery, GetChannelTagsQueryVariables>(GetChannelTagsDocument, options);
        }
export type GetChannelTagsQueryHookResult = ReturnType<typeof useGetChannelTagsQuery>;
export type GetChannelTagsLazyQueryHookResult = ReturnType<typeof useGetChannelTagsLazyQuery>;
export type GetChannelTagsQueryResult = Apollo.QueryResult<GetChannelTagsQuery, GetChannelTagsQueryVariables>;
export const GetConversationSourcesDocument = gql`
    query GetConversationSources($shouldIncludeTags: Boolean, $shouldIncludeEmail: Boolean) {
  conversationSources(
    shouldIncludeTags: $shouldIncludeTags
    shouldIncludeEmail: $shouldIncludeEmail
  ) {
    id
    label
    type
  }
}
    `;

/**
 * __useGetConversationSourcesQuery__
 *
 * To run a query within a React component, call `useGetConversationSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationSourcesQuery({
 *   variables: {
 *      shouldIncludeTags: // value for 'shouldIncludeTags'
 *      shouldIncludeEmail: // value for 'shouldIncludeEmail'
 *   },
 * });
 */
export function useGetConversationSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationSourcesQuery, GetConversationSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationSourcesQuery, GetConversationSourcesQueryVariables>(GetConversationSourcesDocument, options);
      }
export function useGetConversationSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationSourcesQuery, GetConversationSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationSourcesQuery, GetConversationSourcesQueryVariables>(GetConversationSourcesDocument, options);
        }
export type GetConversationSourcesQueryHookResult = ReturnType<typeof useGetConversationSourcesQuery>;
export type GetConversationSourcesLazyQueryHookResult = ReturnType<typeof useGetConversationSourcesLazyQuery>;
export type GetConversationSourcesQueryResult = Apollo.QueryResult<GetConversationSourcesQuery, GetConversationSourcesQueryVariables>;
export const GetDynamicOptionsDocument = gql`
    query GetDynamicOptions($filters: WorkflowServiceChoiceFilterInput!) {
  workflowServiceChoiceValues(filters: $filters) {
    options {
      label
      description
      value
      dynamicChoiceContext
      children {
        label
        description
        value
        dynamicChoiceContext
        children {
          label
          description
          value
          dynamicChoiceContext
        }
      }
    }
  }
}
    `;

/**
 * __useGetDynamicOptionsQuery__
 *
 * To run a query within a React component, call `useGetDynamicOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDynamicOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetDynamicOptionsQuery, GetDynamicOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDynamicOptionsQuery, GetDynamicOptionsQueryVariables>(GetDynamicOptionsDocument, options);
      }
export function useGetDynamicOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDynamicOptionsQuery, GetDynamicOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDynamicOptionsQuery, GetDynamicOptionsQueryVariables>(GetDynamicOptionsDocument, options);
        }
export type GetDynamicOptionsQueryHookResult = ReturnType<typeof useGetDynamicOptionsQuery>;
export type GetDynamicOptionsLazyQueryHookResult = ReturnType<typeof useGetDynamicOptionsLazyQuery>;
export type GetDynamicOptionsQueryResult = Apollo.QueryResult<GetDynamicOptionsQuery, GetDynamicOptionsQueryVariables>;
export const GetChannelEmailsDocument = gql`
    query GetChannelEmails {
  settings {
    channelEmail {
      emails {
        id
        originalDestinationEmail
        isDefault
      }
    }
  }
}
    `;

/**
 * __useGetChannelEmailsQuery__
 *
 * To run a query within a React component, call `useGetChannelEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelEmailsQuery, GetChannelEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelEmailsQuery, GetChannelEmailsQueryVariables>(GetChannelEmailsDocument, options);
      }
export function useGetChannelEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelEmailsQuery, GetChannelEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelEmailsQuery, GetChannelEmailsQueryVariables>(GetChannelEmailsDocument, options);
        }
export type GetChannelEmailsQueryHookResult = ReturnType<typeof useGetChannelEmailsQuery>;
export type GetChannelEmailsLazyQueryHookResult = ReturnType<typeof useGetChannelEmailsLazyQuery>;
export type GetChannelEmailsQueryResult = Apollo.QueryResult<GetChannelEmailsQuery, GetChannelEmailsQueryVariables>;
export const ListExternalFormsDocument = gql`
    query ListExternalForms($id: Urn, $value: FormExternalUrn) {
  externalForms(id: $id, value: $value) {
    id
    name
    hasChildren
    isSelected
  }
}
    `;

/**
 * __useListExternalFormsQuery__
 *
 * To run a query within a React component, call `useListExternalFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExternalFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExternalFormsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useListExternalFormsQuery(baseOptions?: Apollo.QueryHookOptions<ListExternalFormsQuery, ListExternalFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExternalFormsQuery, ListExternalFormsQueryVariables>(ListExternalFormsDocument, options);
      }
export function useListExternalFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExternalFormsQuery, ListExternalFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExternalFormsQuery, ListExternalFormsQueryVariables>(ListExternalFormsDocument, options);
        }
export type ListExternalFormsQueryHookResult = ReturnType<typeof useListExternalFormsQuery>;
export type ListExternalFormsLazyQueryHookResult = ReturnType<typeof useListExternalFormsLazyQuery>;
export type ListExternalFormsQueryResult = Apollo.QueryResult<ListExternalFormsQuery, ListExternalFormsQueryVariables>;
export const GetHolidayCountriesDocument = gql`
    query GetHolidayCountries {
  holidayCountries {
    name
    id
  }
}
    `;

/**
 * __useGetHolidayCountriesQuery__
 *
 * To run a query within a React component, call `useGetHolidayCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidayCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidayCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHolidayCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetHolidayCountriesQuery, GetHolidayCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidayCountriesQuery, GetHolidayCountriesQueryVariables>(GetHolidayCountriesDocument, options);
      }
export function useGetHolidayCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidayCountriesQuery, GetHolidayCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidayCountriesQuery, GetHolidayCountriesQueryVariables>(GetHolidayCountriesDocument, options);
        }
export type GetHolidayCountriesQueryHookResult = ReturnType<typeof useGetHolidayCountriesQuery>;
export type GetHolidayCountriesLazyQueryHookResult = ReturnType<typeof useGetHolidayCountriesLazyQuery>;
export type GetHolidayCountriesQueryResult = Apollo.QueryResult<GetHolidayCountriesQuery, GetHolidayCountriesQueryVariables>;
export const GetAllIntegrationsDocument = gql`
    query GetAllIntegrations {
  integrations {
    id
    label
    type
    actions
  }
}
    `;

/**
 * __useGetAllIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetAllIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllIntegrationsQuery, GetAllIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIntegrationsQuery, GetAllIntegrationsQueryVariables>(GetAllIntegrationsDocument, options);
      }
export function useGetAllIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIntegrationsQuery, GetAllIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIntegrationsQuery, GetAllIntegrationsQueryVariables>(GetAllIntegrationsDocument, options);
        }
export type GetAllIntegrationsQueryHookResult = ReturnType<typeof useGetAllIntegrationsQuery>;
export type GetAllIntegrationsLazyQueryHookResult = ReturnType<typeof useGetAllIntegrationsLazyQuery>;
export type GetAllIntegrationsQueryResult = Apollo.QueryResult<GetAllIntegrationsQuery, GetAllIntegrationsQueryVariables>;
export const SearchOrganizationsDocument = gql`
    query SearchOrganizations($query: String, $limit: Float, $start: Float, $ids: [CompanyUrn!], $hasIds: Boolean!) {
  companies(query: $query, limit: $limit, start: $start) {
    results {
      id
      name
      domain
    }
  }
  companyResults: companies(ids: $ids) @include(if: $hasIds) {
    results {
      id
      name
      domain
    }
  }
}
    `;

/**
 * __useSearchOrganizationsQuery__
 *
 * To run a query within a React component, call `useSearchOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrganizationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      ids: // value for 'ids'
 *      hasIds: // value for 'hasIds'
 *   },
 * });
 */
export function useSearchOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>(SearchOrganizationsDocument, options);
      }
export function useSearchOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>(SearchOrganizationsDocument, options);
        }
export type SearchOrganizationsQueryHookResult = ReturnType<typeof useSearchOrganizationsQuery>;
export type SearchOrganizationsLazyQueryHookResult = ReturnType<typeof useSearchOrganizationsLazyQuery>;
export type SearchOrganizationsQueryResult = Apollo.QueryResult<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>;
export const GetQueueListDocument = gql`
    query GetQueueList($filters: QueueFilters) {
  queues(filters: $filters) {
    id
    name
  }
}
    `;

/**
 * __useGetQueueListQuery__
 *
 * To run a query within a React component, call `useGetQueueListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetQueueListQuery(baseOptions?: Apollo.QueryHookOptions<GetQueueListQuery, GetQueueListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueListQuery, GetQueueListQueryVariables>(GetQueueListDocument, options);
      }
export function useGetQueueListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueListQuery, GetQueueListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueListQuery, GetQueueListQueryVariables>(GetQueueListDocument, options);
        }
export type GetQueueListQueryHookResult = ReturnType<typeof useGetQueueListQuery>;
export type GetQueueListLazyQueryHookResult = ReturnType<typeof useGetQueueListLazyQuery>;
export type GetQueueListQueryResult = Apollo.QueryResult<GetQueueListQuery, GetQueueListQueryVariables>;
export const ListRequestTypesDocument = gql`
    query ListRequestTypes($type: FormType = DEFAULT) {
  forms(type: $type) {
    id
    name
    description
  }
}
    `;

/**
 * __useListRequestTypesQuery__
 *
 * To run a query within a React component, call `useListRequestTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRequestTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRequestTypesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useListRequestTypesQuery(baseOptions?: Apollo.QueryHookOptions<ListRequestTypesQuery, ListRequestTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRequestTypesQuery, ListRequestTypesQueryVariables>(ListRequestTypesDocument, options);
      }
export function useListRequestTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRequestTypesQuery, ListRequestTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRequestTypesQuery, ListRequestTypesQueryVariables>(ListRequestTypesDocument, options);
        }
export type ListRequestTypesQueryHookResult = ReturnType<typeof useListRequestTypesQuery>;
export type ListRequestTypesLazyQueryHookResult = ReturnType<typeof useListRequestTypesLazyQuery>;
export type ListRequestTypesQueryResult = Apollo.QueryResult<ListRequestTypesQuery, ListRequestTypesQueryVariables>;
export const GetSeverityLabelsDocument = gql`
    query GetSeverityLabels {
  settings {
    sla {
      severityLabels
    }
  }
}
    `;

/**
 * __useGetSeverityLabelsQuery__
 *
 * To run a query within a React component, call `useGetSeverityLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeverityLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeverityLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeverityLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeverityLabelsQuery, GetSeverityLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeverityLabelsQuery, GetSeverityLabelsQueryVariables>(GetSeverityLabelsDocument, options);
      }
export function useGetSeverityLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeverityLabelsQuery, GetSeverityLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeverityLabelsQuery, GetSeverityLabelsQueryVariables>(GetSeverityLabelsDocument, options);
        }
export type GetSeverityLabelsQueryHookResult = ReturnType<typeof useGetSeverityLabelsQuery>;
export type GetSeverityLabelsLazyQueryHookResult = ReturnType<typeof useGetSeverityLabelsLazyQuery>;
export type GetSeverityLabelsQueryResult = Apollo.QueryResult<GetSeverityLabelsQuery, GetSeverityLabelsQueryVariables>;
export const GetSlaTiersDocument = gql`
    query GetSLATiers {
  settings {
    sla {
      tiers {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSlaTiersQuery__
 *
 * To run a query within a React component, call `useGetSlaTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlaTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlaTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSlaTiersQuery(baseOptions?: Apollo.QueryHookOptions<GetSlaTiersQuery, GetSlaTiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlaTiersQuery, GetSlaTiersQueryVariables>(GetSlaTiersDocument, options);
      }
export function useGetSlaTiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlaTiersQuery, GetSlaTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlaTiersQuery, GetSlaTiersQueryVariables>(GetSlaTiersDocument, options);
        }
export type GetSlaTiersQueryHookResult = ReturnType<typeof useGetSlaTiersQuery>;
export type GetSlaTiersLazyQueryHookResult = ReturnType<typeof useGetSlaTiersLazyQuery>;
export type GetSlaTiersQueryResult = Apollo.QueryResult<GetSlaTiersQuery, GetSlaTiersQueryVariables>;
export const ListSlackBotsDocument = gql`
    query ListSlackBots($id: Urn) {
  bots(id: $id) {
    id
    name
    avatarUrl
  }
}
    `;

/**
 * __useListSlackBotsQuery__
 *
 * To run a query within a React component, call `useListSlackBotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSlackBotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSlackBotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListSlackBotsQuery(baseOptions?: Apollo.QueryHookOptions<ListSlackBotsQuery, ListSlackBotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSlackBotsQuery, ListSlackBotsQueryVariables>(ListSlackBotsDocument, options);
      }
export function useListSlackBotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSlackBotsQuery, ListSlackBotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSlackBotsQuery, ListSlackBotsQueryVariables>(ListSlackBotsDocument, options);
        }
export type ListSlackBotsQueryHookResult = ReturnType<typeof useListSlackBotsQuery>;
export type ListSlackBotsLazyQueryHookResult = ReturnType<typeof useListSlackBotsLazyQuery>;
export type ListSlackBotsQueryResult = Apollo.QueryResult<ListSlackBotsQuery, ListSlackBotsQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  settings {
    customization {
      tags
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetTicketStatesDocument = gql`
    query GetTicketStates {
  ticketStates {
    id
    name
  }
}
    `;

/**
 * __useGetTicketStatesQuery__
 *
 * To run a query within a React component, call `useGetTicketStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTicketStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTicketStatesQuery, GetTicketStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketStatesQuery, GetTicketStatesQueryVariables>(GetTicketStatesDocument, options);
      }
export function useGetTicketStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketStatesQuery, GetTicketStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketStatesQuery, GetTicketStatesQueryVariables>(GetTicketStatesDocument, options);
        }
export type GetTicketStatesQueryHookResult = ReturnType<typeof useGetTicketStatesQuery>;
export type GetTicketStatesLazyQueryHookResult = ReturnType<typeof useGetTicketStatesLazyQuery>;
export type GetTicketStatesQueryResult = Apollo.QueryResult<GetTicketStatesQuery, GetTicketStatesQueryVariables>;
export const ListUserGroupsDocument = gql`
    query ListUserGroups {
  userGroups {
    id
    name
  }
}
    `;

/**
 * __useListUserGroupsQuery__
 *
 * To run a query within a React component, call `useListUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ListUserGroupsQuery, ListUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserGroupsQuery, ListUserGroupsQueryVariables>(ListUserGroupsDocument, options);
      }
export function useListUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserGroupsQuery, ListUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserGroupsQuery, ListUserGroupsQueryVariables>(ListUserGroupsDocument, options);
        }
export type ListUserGroupsQueryHookResult = ReturnType<typeof useListUserGroupsQuery>;
export type ListUserGroupsLazyQueryHookResult = ReturnType<typeof useListUserGroupsLazyQuery>;
export type ListUserGroupsQueryResult = Apollo.QueryResult<ListUserGroupsQuery, ListUserGroupsQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($query: String, $limit: Float, $start: Float, $ids: [Urn!]) {
  users(query: $query, limit: $limit, start: $start, ids: $ids) {
    id
    name
    avatarUrl
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const StartChatDocument = gql`
    mutation StartChat($message: StartChatInput!) {
  startChat(message: $message) {
    ok
  }
}
    `;
export type StartChatMutationFn = Apollo.MutationFunction<StartChatMutation, StartChatMutationVariables>;

/**
 * __useStartChatMutation__
 *
 * To run a mutation, you first call `useStartChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startChatMutation, { data, loading, error }] = useStartChatMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useStartChatMutation(baseOptions?: Apollo.MutationHookOptions<StartChatMutation, StartChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartChatMutation, StartChatMutationVariables>(StartChatDocument, options);
      }
export type StartChatMutationHookResult = ReturnType<typeof useStartChatMutation>;
export type StartChatMutationResult = Apollo.MutationResult<StartChatMutation>;
export type StartChatMutationOptions = Apollo.BaseMutationOptions<StartChatMutation, StartChatMutationVariables>;
export const TagsSettingsDocument = gql`
    query TagsSettings {
  settings {
    customization {
      tags
    }
  }
}
    `;

/**
 * __useTagsSettingsQuery__
 *
 * To run a query within a React component, call `useTagsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<TagsSettingsQuery, TagsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsSettingsQuery, TagsSettingsQueryVariables>(TagsSettingsDocument, options);
      }
export function useTagsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsSettingsQuery, TagsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsSettingsQuery, TagsSettingsQueryVariables>(TagsSettingsDocument, options);
        }
export type TagsSettingsQueryHookResult = ReturnType<typeof useTagsSettingsQuery>;
export type TagsSettingsLazyQueryHookResult = ReturnType<typeof useTagsSettingsLazyQuery>;
export type TagsSettingsQueryResult = Apollo.QueryResult<TagsSettingsQuery, TagsSettingsQueryVariables>;
export const SaveTicketStateStatusDocument = gql`
    mutation SaveTicketStateStatus($id: TicketTaskUrn!, $state: TicketTaskState!) {
  saveTicketStateStatus(id: $id, state: $state) {
    ok
  }
}
    `;
export type SaveTicketStateStatusMutationFn = Apollo.MutationFunction<SaveTicketStateStatusMutation, SaveTicketStateStatusMutationVariables>;

/**
 * __useSaveTicketStateStatusMutation__
 *
 * To run a mutation, you first call `useSaveTicketStateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTicketStateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTicketStateStatusMutation, { data, loading, error }] = useSaveTicketStateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSaveTicketStateStatusMutation(baseOptions?: Apollo.MutationHookOptions<SaveTicketStateStatusMutation, SaveTicketStateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTicketStateStatusMutation, SaveTicketStateStatusMutationVariables>(SaveTicketStateStatusDocument, options);
      }
export type SaveTicketStateStatusMutationHookResult = ReturnType<typeof useSaveTicketStateStatusMutation>;
export type SaveTicketStateStatusMutationResult = Apollo.MutationResult<SaveTicketStateStatusMutation>;
export type SaveTicketStateStatusMutationOptions = Apollo.BaseMutationOptions<SaveTicketStateStatusMutation, SaveTicketStateStatusMutationVariables>;
export const GetParticipantsForChatDocument = gql`
    query GetParticipantsForChat($chatId: Urn!) {
  getParticipants(chatId: $chatId) {
    id
    name
    firstName
    lastName
    avatarUrl
  }
}
    `;

/**
 * __useGetParticipantsForChatQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetParticipantsForChatQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForChatQuery, GetParticipantsForChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForChatQuery, GetParticipantsForChatQueryVariables>(GetParticipantsForChatDocument, options);
      }
export function useGetParticipantsForChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForChatQuery, GetParticipantsForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForChatQuery, GetParticipantsForChatQueryVariables>(GetParticipantsForChatDocument, options);
        }
export type GetParticipantsForChatQueryHookResult = ReturnType<typeof useGetParticipantsForChatQuery>;
export type GetParticipantsForChatLazyQueryHookResult = ReturnType<typeof useGetParticipantsForChatLazyQuery>;
export type GetParticipantsForChatQueryResult = Apollo.QueryResult<GetParticipantsForChatQuery, GetParticipantsForChatQueryVariables>;
export const RemoveParticipantDocument = gql`
    mutation RemoveParticipant($participant: ChatLeaveParticipantInput!) {
  leaveParticipant(participant: $participant) {
    ok
  }
}
    `;
export type RemoveParticipantMutationFn = Apollo.MutationFunction<RemoveParticipantMutation, RemoveParticipantMutationVariables>;

/**
 * __useRemoveParticipantMutation__
 *
 * To run a mutation, you first call `useRemoveParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeParticipantMutation, { data, loading, error }] = useRemoveParticipantMutation({
 *   variables: {
 *      participant: // value for 'participant'
 *   },
 * });
 */
export function useRemoveParticipantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveParticipantMutation, RemoveParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveParticipantMutation, RemoveParticipantMutationVariables>(RemoveParticipantDocument, options);
      }
export type RemoveParticipantMutationHookResult = ReturnType<typeof useRemoveParticipantMutation>;
export type RemoveParticipantMutationResult = Apollo.MutationResult<RemoveParticipantMutation>;
export type RemoveParticipantMutationOptions = Apollo.BaseMutationOptions<RemoveParticipantMutation, RemoveParticipantMutationVariables>;
export const GetTicketDocument = gql`
    query GetTicket($id: String!) {
  ticket(id: $id) {
    id
    subject
    description
    ticketNumber
    createdDate
    modifiedDate
    lastResponseDate
    currentUserLastReadDate
    hasUnreadByCurrentUser
    closedDate
    chatId
    status
    assigneeId
    assignee {
      name
      avatarUrl
    }
    creator {
      name
      avatarUrl
    }
    formId
    form {
      name
      fields {
        fieldId
        name
      }
    }
    customFields {
      formFieldId
      displayValue
      type
      value {
        string
        boolean
        date
        number
        options
      }
    }
    messages {
      id
      type
      createdDate
      creator {
        id
        name
        avatarUrl
      }
      body {
        html
      }
      reactions {
        reaction
        isCreatedByCurrentUser
      }
      attachments {
        url
        previewImage
        title
      }
    }
  }
}
    `;

/**
 * __useGetTicketQuery__
 *
 * To run a query within a React component, call `useGetTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTicketQuery(baseOptions: Apollo.QueryHookOptions<GetTicketQuery, GetTicketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketQuery, GetTicketQueryVariables>(GetTicketDocument, options);
      }
export function useGetTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketQuery, GetTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketQuery, GetTicketQueryVariables>(GetTicketDocument, options);
        }
export type GetTicketQueryHookResult = ReturnType<typeof useGetTicketQuery>;
export type GetTicketLazyQueryHookResult = ReturnType<typeof useGetTicketLazyQuery>;
export type GetTicketQueryResult = Apollo.QueryResult<GetTicketQuery, GetTicketQueryVariables>;
export const CreateWebhookUrlDocument = gql`
    mutation CreateWebhookUrl($stepId: WorkflowStepUrn!, $properties: WorkflowServiceWebhookRequest) {
  workflowServiceCreateWebhook(stepId: $stepId, properties: $properties) {
    url
  }
}
    `;
export type CreateWebhookUrlMutationFn = Apollo.MutationFunction<CreateWebhookUrlMutation, CreateWebhookUrlMutationVariables>;

/**
 * __useCreateWebhookUrlMutation__
 *
 * To run a mutation, you first call `useCreateWebhookUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookUrlMutation, { data, loading, error }] = useCreateWebhookUrlMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function useCreateWebhookUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookUrlMutation, CreateWebhookUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookUrlMutation, CreateWebhookUrlMutationVariables>(CreateWebhookUrlDocument, options);
      }
export type CreateWebhookUrlMutationHookResult = ReturnType<typeof useCreateWebhookUrlMutation>;
export type CreateWebhookUrlMutationResult = Apollo.MutationResult<CreateWebhookUrlMutation>;
export type CreateWebhookUrlMutationOptions = Apollo.BaseMutationOptions<CreateWebhookUrlMutation, CreateWebhookUrlMutationVariables>;
export const GetActionFieldsDocument = gql`
    query GetActionFields($id: FormUrn!) {
  formFields(
    shouldIncludeSystemFields: true
    shouldIncludePrivate: true
    shouldIncludeTemplateFields: false
  ) {
    id
    isSystemField
    options {
      ...OptionFields
    }
    name
    placeholder
    description
    type
    levels
    userGroupIds
    visibility
    asyncObjectType
  }
  form(id: $id) {
    id
    name
    type
    description
    fields {
      fieldId
      agentText
      isRequired
      name
      description
      placeholder
      defaultValue {
        value {
          type
          string
          number
          options
          date
          boolean
        }
        replacements {
          groupId
          fieldId
          replacement
        }
      }
    }
  }
}
    ${OptionFieldsFragmentDoc}`;

/**
 * __useGetActionFieldsQuery__
 *
 * To run a query within a React component, call `useGetActionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetActionFieldsQuery, GetActionFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionFieldsQuery, GetActionFieldsQueryVariables>(GetActionFieldsDocument, options);
      }
export function useGetActionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionFieldsQuery, GetActionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionFieldsQuery, GetActionFieldsQueryVariables>(GetActionFieldsDocument, options);
        }
export type GetActionFieldsQueryHookResult = ReturnType<typeof useGetActionFieldsQuery>;
export type GetActionFieldsLazyQueryHookResult = ReturnType<typeof useGetActionFieldsLazyQuery>;
export type GetActionFieldsQueryResult = Apollo.QueryResult<GetActionFieldsQuery, GetActionFieldsQueryVariables>;
export const DummyRegisterConditionDocument = gql`
    mutation DummyRegisterCondition($condition: WorkflowCondition!, $conditionValue: WorkflowConditionMapping!, $functionValue: WorkflowFunctionWithParameters!, $approvalFormValue: ApprovalFormInput!, $stepParameter: WorkflowStepKeyValueParameterInput!) {
  dummyRegisterCondition(
    condition: $condition
    conditionValue: $conditionValue
    functionValue: $functionValue
    approvalFormValue: $approvalFormValue
    stepParameter: $stepParameter
  ) {
    ok
  }
}
    `;
export type DummyRegisterConditionMutationFn = Apollo.MutationFunction<DummyRegisterConditionMutation, DummyRegisterConditionMutationVariables>;

/**
 * __useDummyRegisterConditionMutation__
 *
 * To run a mutation, you first call `useDummyRegisterConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDummyRegisterConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dummyRegisterConditionMutation, { data, loading, error }] = useDummyRegisterConditionMutation({
 *   variables: {
 *      condition: // value for 'condition'
 *      conditionValue: // value for 'conditionValue'
 *      functionValue: // value for 'functionValue'
 *      approvalFormValue: // value for 'approvalFormValue'
 *      stepParameter: // value for 'stepParameter'
 *   },
 * });
 */
export function useDummyRegisterConditionMutation(baseOptions?: Apollo.MutationHookOptions<DummyRegisterConditionMutation, DummyRegisterConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DummyRegisterConditionMutation, DummyRegisterConditionMutationVariables>(DummyRegisterConditionDocument, options);
      }
export type DummyRegisterConditionMutationHookResult = ReturnType<typeof useDummyRegisterConditionMutation>;
export type DummyRegisterConditionMutationResult = Apollo.MutationResult<DummyRegisterConditionMutation>;
export type DummyRegisterConditionMutationOptions = Apollo.BaseMutationOptions<DummyRegisterConditionMutation, DummyRegisterConditionMutationVariables>;
export const GetInstalledWorkflowServiceActionDocument = gql`
    query GetInstalledWorkflowServiceAction($id: Urn!) {
  workflowServiceAction(id: $id) {
    id
    name
    description
    integrations {
      id
      label
    }
    displayTemplate {
      template
      parameters {
        key
        path
      }
    }
    input {
      ...FieldInputs
    }
    output {
      name
      description
      type
      id
    }
    allowedChildren {
      id
      label
      description
      allowedActionIds
      output {
        name
        description
        type
        id
      }
    }
  }
}
    ${FieldInputsFragmentDoc}`;

/**
 * __useGetInstalledWorkflowServiceActionQuery__
 *
 * To run a query within a React component, call `useGetInstalledWorkflowServiceActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledWorkflowServiceActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledWorkflowServiceActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstalledWorkflowServiceActionQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledWorkflowServiceActionQuery, GetInstalledWorkflowServiceActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledWorkflowServiceActionQuery, GetInstalledWorkflowServiceActionQueryVariables>(GetInstalledWorkflowServiceActionDocument, options);
      }
export function useGetInstalledWorkflowServiceActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledWorkflowServiceActionQuery, GetInstalledWorkflowServiceActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledWorkflowServiceActionQuery, GetInstalledWorkflowServiceActionQueryVariables>(GetInstalledWorkflowServiceActionDocument, options);
        }
export type GetInstalledWorkflowServiceActionQueryHookResult = ReturnType<typeof useGetInstalledWorkflowServiceActionQuery>;
export type GetInstalledWorkflowServiceActionLazyQueryHookResult = ReturnType<typeof useGetInstalledWorkflowServiceActionLazyQuery>;
export type GetInstalledWorkflowServiceActionQueryResult = Apollo.QueryResult<GetInstalledWorkflowServiceActionQuery, GetInstalledWorkflowServiceActionQueryVariables>;
export const GetInstalledWorkflowServiceActionsDocument = gql`
    query GetInstalledWorkflowServiceActions($id: Urn!) {
  workflowService(id: $id) {
    id
    name
    iconUrl
    actions {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useGetInstalledWorkflowServiceActionsQuery__
 *
 * To run a query within a React component, call `useGetInstalledWorkflowServiceActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledWorkflowServiceActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledWorkflowServiceActionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstalledWorkflowServiceActionsQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledWorkflowServiceActionsQuery, GetInstalledWorkflowServiceActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledWorkflowServiceActionsQuery, GetInstalledWorkflowServiceActionsQueryVariables>(GetInstalledWorkflowServiceActionsDocument, options);
      }
export function useGetInstalledWorkflowServiceActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledWorkflowServiceActionsQuery, GetInstalledWorkflowServiceActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledWorkflowServiceActionsQuery, GetInstalledWorkflowServiceActionsQueryVariables>(GetInstalledWorkflowServiceActionsDocument, options);
        }
export type GetInstalledWorkflowServiceActionsQueryHookResult = ReturnType<typeof useGetInstalledWorkflowServiceActionsQuery>;
export type GetInstalledWorkflowServiceActionsLazyQueryHookResult = ReturnType<typeof useGetInstalledWorkflowServiceActionsLazyQuery>;
export type GetInstalledWorkflowServiceActionsQueryResult = Apollo.QueryResult<GetInstalledWorkflowServiceActionsQuery, GetInstalledWorkflowServiceActionsQueryVariables>;
export const GetInstalledWorkflowSystemActionsDocument = gql`
    query GetInstalledWorkflowSystemActions($type: ActionContextType!) {
  workflowServiceSystemActions(type: $type) {
    id
    name
    description
    tags
  }
}
    `;

/**
 * __useGetInstalledWorkflowSystemActionsQuery__
 *
 * To run a query within a React component, call `useGetInstalledWorkflowSystemActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledWorkflowSystemActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledWorkflowSystemActionsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetInstalledWorkflowSystemActionsQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledWorkflowSystemActionsQuery, GetInstalledWorkflowSystemActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledWorkflowSystemActionsQuery, GetInstalledWorkflowSystemActionsQueryVariables>(GetInstalledWorkflowSystemActionsDocument, options);
      }
export function useGetInstalledWorkflowSystemActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledWorkflowSystemActionsQuery, GetInstalledWorkflowSystemActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledWorkflowSystemActionsQuery, GetInstalledWorkflowSystemActionsQueryVariables>(GetInstalledWorkflowSystemActionsDocument, options);
        }
export type GetInstalledWorkflowSystemActionsQueryHookResult = ReturnType<typeof useGetInstalledWorkflowSystemActionsQuery>;
export type GetInstalledWorkflowSystemActionsLazyQueryHookResult = ReturnType<typeof useGetInstalledWorkflowSystemActionsLazyQuery>;
export type GetInstalledWorkflowSystemActionsQueryResult = Apollo.QueryResult<GetInstalledWorkflowSystemActionsQuery, GetInstalledWorkflowSystemActionsQueryVariables>;
export const GetWorkflowByReferenceDocument = gql`
    query GetWorkflowByReference($referenceId: Urn!) {
  workflowReference(referenceId: $referenceId) {
    workflowId
    workflow {
      ...Workflow
    }
  }
}
    ${WorkflowFragmentDoc}`;

/**
 * __useGetWorkflowByReferenceQuery__
 *
 * To run a query within a React component, call `useGetWorkflowByReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowByReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowByReferenceQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useGetWorkflowByReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowByReferenceQuery, GetWorkflowByReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowByReferenceQuery, GetWorkflowByReferenceQueryVariables>(GetWorkflowByReferenceDocument, options);
      }
export function useGetWorkflowByReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowByReferenceQuery, GetWorkflowByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowByReferenceQuery, GetWorkflowByReferenceQueryVariables>(GetWorkflowByReferenceDocument, options);
        }
export type GetWorkflowByReferenceQueryHookResult = ReturnType<typeof useGetWorkflowByReferenceQuery>;
export type GetWorkflowByReferenceLazyQueryHookResult = ReturnType<typeof useGetWorkflowByReferenceLazyQuery>;
export type GetWorkflowByReferenceQueryResult = Apollo.QueryResult<GetWorkflowByReferenceQuery, GetWorkflowByReferenceQueryVariables>;
export const GetInstalledWorkflowServicesDocument = gql`
    query GetInstalledWorkflowServices($type: ActionContextType!) {
  workflowServices(filters: {isOnlyInstalled: true, type: $type}) {
    id
    name
    shortDescription
    iconUrl
    searchHighlight
    actionTypes
    installedIntegrationIds
  }
}
    `;

/**
 * __useGetInstalledWorkflowServicesQuery__
 *
 * To run a query within a React component, call `useGetInstalledWorkflowServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledWorkflowServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledWorkflowServicesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetInstalledWorkflowServicesQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledWorkflowServicesQuery, GetInstalledWorkflowServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledWorkflowServicesQuery, GetInstalledWorkflowServicesQueryVariables>(GetInstalledWorkflowServicesDocument, options);
      }
export function useGetInstalledWorkflowServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledWorkflowServicesQuery, GetInstalledWorkflowServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledWorkflowServicesQuery, GetInstalledWorkflowServicesQueryVariables>(GetInstalledWorkflowServicesDocument, options);
        }
export type GetInstalledWorkflowServicesQueryHookResult = ReturnType<typeof useGetInstalledWorkflowServicesQuery>;
export type GetInstalledWorkflowServicesLazyQueryHookResult = ReturnType<typeof useGetInstalledWorkflowServicesLazyQuery>;
export type GetInstalledWorkflowServicesQueryResult = Apollo.QueryResult<GetInstalledWorkflowServicesQuery, GetInstalledWorkflowServicesQueryVariables>;
export const GetWorkflowByIdDocument = gql`
    query GetWorkflowById($id: WorkflowUrn!) {
  workflow(id: $id) {
    ...Workflow
  }
}
    ${WorkflowFragmentDoc}`;

/**
 * __useGetWorkflowByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkflowByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowByIdQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowByIdQuery, GetWorkflowByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowByIdQuery, GetWorkflowByIdQueryVariables>(GetWorkflowByIdDocument, options);
      }
export function useGetWorkflowByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowByIdQuery, GetWorkflowByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowByIdQuery, GetWorkflowByIdQueryVariables>(GetWorkflowByIdDocument, options);
        }
export type GetWorkflowByIdQueryHookResult = ReturnType<typeof useGetWorkflowByIdQuery>;
export type GetWorkflowByIdLazyQueryHookResult = ReturnType<typeof useGetWorkflowByIdLazyQuery>;
export type GetWorkflowByIdQueryResult = Apollo.QueryResult<GetWorkflowByIdQuery, GetWorkflowByIdQueryVariables>;
export const SaveWorkflowDocument = gql`
    mutation SaveWorkflow($id: WorkflowUrn, $referenceId: Urn, $workflow: WorkflowInput!) {
  saveWorkflow(id: $id, workflow: $workflow, referenceId: $referenceId) {
    ...Workflow
  }
}
    ${WorkflowFragmentDoc}`;
export type SaveWorkflowMutationFn = Apollo.MutationFunction<SaveWorkflowMutation, SaveWorkflowMutationVariables>;

/**
 * __useSaveWorkflowMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowMutation, { data, loading, error }] = useSaveWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      referenceId: // value for 'referenceId'
 *      workflow: // value for 'workflow'
 *   },
 * });
 */
export function useSaveWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<SaveWorkflowMutation, SaveWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWorkflowMutation, SaveWorkflowMutationVariables>(SaveWorkflowDocument, options);
      }
export type SaveWorkflowMutationHookResult = ReturnType<typeof useSaveWorkflowMutation>;
export type SaveWorkflowMutationResult = Apollo.MutationResult<SaveWorkflowMutation>;
export type SaveWorkflowMutationOptions = Apollo.BaseMutationOptions<SaveWorkflowMutation, SaveWorkflowMutationVariables>;
export const GetActiveSessionsDocument = gql`
    query GetActiveSessions {
  session {
    user {
      id
      name
      firstName
      lastName
      avatarUrl
      userGroups {
        id
      }
    }
    id
    permissions
  }
}
    `;

/**
 * __useGetActiveSessionsQuery__
 *
 * To run a query within a React component, call `useGetActiveSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveSessionsQuery, GetActiveSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveSessionsQuery, GetActiveSessionsQueryVariables>(GetActiveSessionsDocument, options);
      }
export function useGetActiveSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveSessionsQuery, GetActiveSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveSessionsQuery, GetActiveSessionsQueryVariables>(GetActiveSessionsDocument, options);
        }
export type GetActiveSessionsQueryHookResult = ReturnType<typeof useGetActiveSessionsQuery>;
export type GetActiveSessionsLazyQueryHookResult = ReturnType<typeof useGetActiveSessionsLazyQuery>;
export type GetActiveSessionsQueryResult = Apollo.QueryResult<GetActiveSessionsQuery, GetActiveSessionsQueryVariables>;
export const CreateTicketDocument = gql`
    mutation CreateTicket($ticket: TicketInput!) {
  saveTicket(ticket: $ticket) {
    ticketNumber
  }
}
    `;
export type CreateTicketMutationFn = Apollo.MutationFunction<CreateTicketMutation, CreateTicketMutationVariables>;

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useCreateTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTicketMutation, CreateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTicketMutation, CreateTicketMutationVariables>(CreateTicketDocument, options);
      }
export type CreateTicketMutationHookResult = ReturnType<typeof useCreateTicketMutation>;
export type CreateTicketMutationResult = Apollo.MutationResult<CreateTicketMutation>;
export type CreateTicketMutationOptions = Apollo.BaseMutationOptions<CreateTicketMutation, CreateTicketMutationVariables>;
export const GetCurrentPortalDocument = gql`
    query GetCurrentPortal {
  portal {
    id
    title
    welcomeMessage
    chatToken
    permissions
    indexArticleId
    isAIEnabled
    banner {
      expirationDate
      message
      linkUrl
      type
    }
    singleSignOn {
      isEnabled
      loginRedirectUrl
    }
  }
  featureFlags {
    active
  }
}
    `;

/**
 * __useGetCurrentPortalQuery__
 *
 * To run a query within a React component, call `useGetCurrentPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentPortalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentPortalQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentPortalQuery, GetCurrentPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentPortalQuery, GetCurrentPortalQueryVariables>(GetCurrentPortalDocument, options);
      }
export function useGetCurrentPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentPortalQuery, GetCurrentPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentPortalQuery, GetCurrentPortalQueryVariables>(GetCurrentPortalDocument, options);
        }
export type GetCurrentPortalQueryHookResult = ReturnType<typeof useGetCurrentPortalQuery>;
export type GetCurrentPortalLazyQueryHookResult = ReturnType<typeof useGetCurrentPortalLazyQuery>;
export type GetCurrentPortalQueryResult = Apollo.QueryResult<GetCurrentPortalQuery, GetCurrentPortalQueryVariables>;
export const StoreLogsDocument = gql`
    mutation StoreLogs($logs: LogsInput!) {
  storeLogs(logs: $logs) {
    ok
  }
}
    `;
export type StoreLogsMutationFn = Apollo.MutationFunction<StoreLogsMutation, StoreLogsMutationVariables>;

/**
 * __useStoreLogsMutation__
 *
 * To run a mutation, you first call `useStoreLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeLogsMutation, { data, loading, error }] = useStoreLogsMutation({
 *   variables: {
 *      logs: // value for 'logs'
 *   },
 * });
 */
export function useStoreLogsMutation(baseOptions?: Apollo.MutationHookOptions<StoreLogsMutation, StoreLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreLogsMutation, StoreLogsMutationVariables>(StoreLogsDocument, options);
      }
export type StoreLogsMutationHookResult = ReturnType<typeof useStoreLogsMutation>;
export type StoreLogsMutationResult = Apollo.MutationResult<StoreLogsMutation>;
export type StoreLogsMutationOptions = Apollo.BaseMutationOptions<StoreLogsMutation, StoreLogsMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    ok
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const SubscribeToPortalDocument = gql`
    mutation SubscribeToPortal {
  subscribe {
    sessionToken
    socketUrl
  }
}
    `;
export type SubscribeToPortalMutationFn = Apollo.MutationFunction<SubscribeToPortalMutation, SubscribeToPortalMutationVariables>;

/**
 * __useSubscribeToPortalMutation__
 *
 * To run a mutation, you first call `useSubscribeToPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToPortalMutation, { data, loading, error }] = useSubscribeToPortalMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToPortalMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToPortalMutation, SubscribeToPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToPortalMutation, SubscribeToPortalMutationVariables>(SubscribeToPortalDocument, options);
      }
export type SubscribeToPortalMutationHookResult = ReturnType<typeof useSubscribeToPortalMutation>;
export type SubscribeToPortalMutationResult = Apollo.MutationResult<SubscribeToPortalMutation>;
export type SubscribeToPortalMutationOptions = Apollo.BaseMutationOptions<SubscribeToPortalMutation, SubscribeToPortalMutationVariables>;
export const GetUpdatesDocument = gql`
    query GetUpdates {
  updates {
    id
    title
    iconUrl
    publishedDate
    tags {
      id
      title
      iconUrl
    }
    publishedBy {
      id
      name
    }
    body {
      html
    }
  }
  updateCategories {
    id
    title
    description
    iconUrl
  }
}
    `;

/**
 * __useGetUpdatesQuery__
 *
 * To run a query within a React component, call `useGetUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<GetUpdatesQuery, GetUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpdatesQuery, GetUpdatesQueryVariables>(GetUpdatesDocument, options);
      }
export function useGetUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpdatesQuery, GetUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpdatesQuery, GetUpdatesQueryVariables>(GetUpdatesDocument, options);
        }
export type GetUpdatesQueryHookResult = ReturnType<typeof useGetUpdatesQuery>;
export type GetUpdatesLazyQueryHookResult = ReturnType<typeof useGetUpdatesLazyQuery>;
export type GetUpdatesQueryResult = Apollo.QueryResult<GetUpdatesQuery, GetUpdatesQueryVariables>;
export const GetMigrationTokenDocument = gql`
    mutation getMigrationToken {
  getMigrationToken {
    token
  }
}
    `;
export type GetMigrationTokenMutationFn = Apollo.MutationFunction<GetMigrationTokenMutation, GetMigrationTokenMutationVariables>;

/**
 * __useGetMigrationTokenMutation__
 *
 * To run a mutation, you first call `useGetMigrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMigrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMigrationTokenMutation, { data, loading, error }] = useGetMigrationTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetMigrationTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetMigrationTokenMutation, GetMigrationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetMigrationTokenMutation, GetMigrationTokenMutationVariables>(GetMigrationTokenDocument, options);
      }
export type GetMigrationTokenMutationHookResult = ReturnType<typeof useGetMigrationTokenMutation>;
export type GetMigrationTokenMutationResult = Apollo.MutationResult<GetMigrationTokenMutation>;
export type GetMigrationTokenMutationOptions = Apollo.BaseMutationOptions<GetMigrationTokenMutation, GetMigrationTokenMutationVariables>;
export const GetAccountDocument = gql`
    query GetAccount {
  session {
    user {
      id
      name
      firstName
      lastName
      avatarUrl
      emailAddresses
      userGroups {
        id
        name
      }
      handles {
        id
        type
        application {
          isVerified
          displayText
          editableText
          applicationName
        }
      }
    }
  }
  userSettings {
    ...userSettings
  }
}
    ${UserSettingsFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const SaveUserFirstLastNameDocument = gql`
    mutation SaveUserFirstLastName($id: Urn, $user: UserInput!) {
  saveUser(id: $id, user: $user) {
    id
    firstName
    lastName
  }
}
    `;
export type SaveUserFirstLastNameMutationFn = Apollo.MutationFunction<SaveUserFirstLastNameMutation, SaveUserFirstLastNameMutationVariables>;

/**
 * __useSaveUserFirstLastNameMutation__
 *
 * To run a mutation, you first call `useSaveUserFirstLastNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserFirstLastNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserFirstLastNameMutation, { data, loading, error }] = useSaveUserFirstLastNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useSaveUserFirstLastNameMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserFirstLastNameMutation, SaveUserFirstLastNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserFirstLastNameMutation, SaveUserFirstLastNameMutationVariables>(SaveUserFirstLastNameDocument, options);
      }
export type SaveUserFirstLastNameMutationHookResult = ReturnType<typeof useSaveUserFirstLastNameMutation>;
export type SaveUserFirstLastNameMutationResult = Apollo.MutationResult<SaveUserFirstLastNameMutation>;
export type SaveUserFirstLastNameMutationOptions = Apollo.BaseMutationOptions<SaveUserFirstLastNameMutation, SaveUserFirstLastNameMutationVariables>;
export const SaveUserSettingsDocument = gql`
    mutation SaveUserSettings($settings: UserSettingsInput!) {
  saveUserSettings(settings: $settings) {
    ...userSettings
  }
}
    ${UserSettingsFragmentDoc}`;
export type SaveUserSettingsMutationFn = Apollo.MutationFunction<SaveUserSettingsMutation, SaveUserSettingsMutationVariables>;

/**
 * __useSaveUserSettingsMutation__
 *
 * To run a mutation, you first call `useSaveUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserSettingsMutation, { data, loading, error }] = useSaveUserSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserSettingsMutation, SaveUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserSettingsMutation, SaveUserSettingsMutationVariables>(SaveUserSettingsDocument, options);
      }
export type SaveUserSettingsMutationHookResult = ReturnType<typeof useSaveUserSettingsMutation>;
export type SaveUserSettingsMutationResult = Apollo.MutationResult<SaveUserSettingsMutation>;
export type SaveUserSettingsMutationOptions = Apollo.BaseMutationOptions<SaveUserSettingsMutation, SaveUserSettingsMutationVariables>;
export const LoginWithTokenDocument = gql`
    mutation LoginWithToken($token: String!) {
  loginWithToken(token: $token) {
    __typename
    ... on Session {
      id
      permissions
    }
    ... on LoginError {
      message
    }
  }
}
    `;
export type LoginWithTokenMutationFn = Apollo.MutationFunction<LoginWithTokenMutation, LoginWithTokenMutationVariables>;

/**
 * __useLoginWithTokenMutation__
 *
 * To run a mutation, you first call `useLoginWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithTokenMutation, { data, loading, error }] = useLoginWithTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithTokenMutation, LoginWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithTokenMutation, LoginWithTokenMutationVariables>(LoginWithTokenDocument, options);
      }
export type LoginWithTokenMutationHookResult = ReturnType<typeof useLoginWithTokenMutation>;
export type LoginWithTokenMutationResult = Apollo.MutationResult<LoginWithTokenMutation>;
export type LoginWithTokenMutationOptions = Apollo.BaseMutationOptions<LoginWithTokenMutation, LoginWithTokenMutationVariables>;
export const LoginWithProviderDocument = gql`
    query LoginWithProvider($provider: IdentityProviderInput!) {
  loginWithIdentityProvider(provider: $provider) {
    url
  }
}
    `;

/**
 * __useLoginWithProviderQuery__
 *
 * To run a query within a React component, call `useLoginWithProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginWithProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginWithProviderQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useLoginWithProviderQuery(baseOptions: Apollo.QueryHookOptions<LoginWithProviderQuery, LoginWithProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginWithProviderQuery, LoginWithProviderQueryVariables>(LoginWithProviderDocument, options);
      }
export function useLoginWithProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginWithProviderQuery, LoginWithProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginWithProviderQuery, LoginWithProviderQueryVariables>(LoginWithProviderDocument, options);
        }
export type LoginWithProviderQueryHookResult = ReturnType<typeof useLoginWithProviderQuery>;
export type LoginWithProviderLazyQueryHookResult = ReturnType<typeof useLoginWithProviderLazyQuery>;
export type LoginWithProviderQueryResult = Apollo.QueryResult<LoginWithProviderQuery, LoginWithProviderQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    __typename
    ... on Session {
      id
    }
    ... on LoginError {
      message
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const ActionUpdateDocument = gql`
    mutation ActionUpdate($input: ActionInput!) {
  actionUpdate(input: $input) {
    feedback {
      type
      selectedIndex
      isCommentAllowed
      responseMessage
    }
    deflection {
      isSuccessful
    }
  }
}
    `;
export type ActionUpdateMutationFn = Apollo.MutationFunction<ActionUpdateMutation, ActionUpdateMutationVariables>;

/**
 * __useActionUpdateMutation__
 *
 * To run a mutation, you first call `useActionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionUpdateMutation, { data, loading, error }] = useActionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ActionUpdateMutation, ActionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActionUpdateMutation, ActionUpdateMutationVariables>(ActionUpdateDocument, options);
      }
export type ActionUpdateMutationHookResult = ReturnType<typeof useActionUpdateMutation>;
export type ActionUpdateMutationResult = Apollo.MutationResult<ActionUpdateMutation>;
export type ActionUpdateMutationOptions = Apollo.BaseMutationOptions<ActionUpdateMutation, ActionUpdateMutationVariables>;
export const SaveSettingsDocument = gql`
    mutation SaveSettings($feedback: FeedbackInput, $customization: SettingsCustomizationInput, $time: SettingsTimeInput, $channels: SettingsChannelsInput, $sla: SettingsSLAInput, $channelSlack: SettingsChannelSlackInput, $channelEmail: SettingsChannelEmailInput, $channelWebChat: SettingsChannelWebChatInput, $artificialIntelligence: SettingsArtificialIntelligenceInput, $identities: [Urn!]) {
  saveSettings(
    feedback: $feedback
    customization: $customization
    time: $time
    channels: $channels
    sla: $sla
    channelSlack: $channelSlack
    channelEmail: $channelEmail
    channelWebChat: $channelWebChat
    artificialIntelligence: $artificialIntelligence
    identities: $identities
  ) {
    ok
  }
}
    `;
export type SaveSettingsMutationFn = Apollo.MutationFunction<SaveSettingsMutation, SaveSettingsMutationVariables>;

/**
 * __useSaveSettingsMutation__
 *
 * To run a mutation, you first call `useSaveSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSettingsMutation, { data, loading, error }] = useSaveSettingsMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *      customization: // value for 'customization'
 *      time: // value for 'time'
 *      channels: // value for 'channels'
 *      sla: // value for 'sla'
 *      channelSlack: // value for 'channelSlack'
 *      channelEmail: // value for 'channelEmail'
 *      channelWebChat: // value for 'channelWebChat'
 *      artificialIntelligence: // value for 'artificialIntelligence'
 *      identities: // value for 'identities'
 *   },
 * });
 */
export function useSaveSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveSettingsMutation, SaveSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSettingsMutation, SaveSettingsMutationVariables>(SaveSettingsDocument, options);
      }
export type SaveSettingsMutationHookResult = ReturnType<typeof useSaveSettingsMutation>;
export type SaveSettingsMutationResult = Apollo.MutationResult<SaveSettingsMutation>;
export type SaveSettingsMutationOptions = Apollo.BaseMutationOptions<SaveSettingsMutation, SaveSettingsMutationVariables>;
export const GetArtificialIntelligenceSettingsDocument = gql`
    query GetArtificialIntelligenceSettings {
  artificialIntelligenceSettings {
    isEnabled
  }
}
    `;

/**
 * __useGetArtificialIntelligenceSettingsQuery__
 *
 * To run a query within a React component, call `useGetArtificialIntelligenceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtificialIntelligenceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtificialIntelligenceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArtificialIntelligenceSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetArtificialIntelligenceSettingsQuery, GetArtificialIntelligenceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtificialIntelligenceSettingsQuery, GetArtificialIntelligenceSettingsQueryVariables>(GetArtificialIntelligenceSettingsDocument, options);
      }
export function useGetArtificialIntelligenceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtificialIntelligenceSettingsQuery, GetArtificialIntelligenceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtificialIntelligenceSettingsQuery, GetArtificialIntelligenceSettingsQueryVariables>(GetArtificialIntelligenceSettingsDocument, options);
        }
export type GetArtificialIntelligenceSettingsQueryHookResult = ReturnType<typeof useGetArtificialIntelligenceSettingsQuery>;
export type GetArtificialIntelligenceSettingsLazyQueryHookResult = ReturnType<typeof useGetArtificialIntelligenceSettingsLazyQuery>;
export type GetArtificialIntelligenceSettingsQueryResult = Apollo.QueryResult<GetArtificialIntelligenceSettingsQuery, GetArtificialIntelligenceSettingsQueryVariables>;
export const SaveArtificialIntelligenceSettingsDocument = gql`
    mutation SaveArtificialIntelligenceSettings($settings: ArtificialIntelligenceSettingsInput!) {
  saveArtificialIntelligenceSettings(settings: $settings) {
    ok
  }
}
    `;
export type SaveArtificialIntelligenceSettingsMutationFn = Apollo.MutationFunction<SaveArtificialIntelligenceSettingsMutation, SaveArtificialIntelligenceSettingsMutationVariables>;

/**
 * __useSaveArtificialIntelligenceSettingsMutation__
 *
 * To run a mutation, you first call `useSaveArtificialIntelligenceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveArtificialIntelligenceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveArtificialIntelligenceSettingsMutation, { data, loading, error }] = useSaveArtificialIntelligenceSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveArtificialIntelligenceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveArtificialIntelligenceSettingsMutation, SaveArtificialIntelligenceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveArtificialIntelligenceSettingsMutation, SaveArtificialIntelligenceSettingsMutationVariables>(SaveArtificialIntelligenceSettingsDocument, options);
      }
export type SaveArtificialIntelligenceSettingsMutationHookResult = ReturnType<typeof useSaveArtificialIntelligenceSettingsMutation>;
export type SaveArtificialIntelligenceSettingsMutationResult = Apollo.MutationResult<SaveArtificialIntelligenceSettingsMutation>;
export type SaveArtificialIntelligenceSettingsMutationOptions = Apollo.BaseMutationOptions<SaveArtificialIntelligenceSettingsMutation, SaveArtificialIntelligenceSettingsMutationVariables>;
export const GetBillingDocument = gql`
    query GetBilling {
  billing {
    redirectUrl
    sessionId
    pricingTableId
    publishableKey
    currentUserEmail
  }
}
    `;

/**
 * __useGetBillingQuery__
 *
 * To run a query within a React component, call `useGetBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingQuery, GetBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingQuery, GetBillingQueryVariables>(GetBillingDocument, options);
      }
export function useGetBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingQuery, GetBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingQuery, GetBillingQueryVariables>(GetBillingDocument, options);
        }
export type GetBillingQueryHookResult = ReturnType<typeof useGetBillingQuery>;
export type GetBillingLazyQueryHookResult = ReturnType<typeof useGetBillingLazyQuery>;
export type GetBillingQueryResult = Apollo.QueryResult<GetBillingQuery, GetBillingQueryVariables>;
export const DeleteChannelInviteDocument = gql`
    mutation DeleteChannelInvite($id: ChannelInviteUrn!) {
  deleteChannelInvite(id: $id) {
    ok
  }
}
    `;
export type DeleteChannelInviteMutationFn = Apollo.MutationFunction<DeleteChannelInviteMutation, DeleteChannelInviteMutationVariables>;

/**
 * __useDeleteChannelInviteMutation__
 *
 * To run a mutation, you first call `useDeleteChannelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelInviteMutation, { data, loading, error }] = useDeleteChannelInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChannelInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelInviteMutation, DeleteChannelInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelInviteMutation, DeleteChannelInviteMutationVariables>(DeleteChannelInviteDocument, options);
      }
export type DeleteChannelInviteMutationHookResult = ReturnType<typeof useDeleteChannelInviteMutation>;
export type DeleteChannelInviteMutationResult = Apollo.MutationResult<DeleteChannelInviteMutation>;
export type DeleteChannelInviteMutationOptions = Apollo.BaseMutationOptions<DeleteChannelInviteMutation, DeleteChannelInviteMutationVariables>;
export const GetAdminChannelInviteDocument = gql`
    query GetAdminChannelInvite($id: ChannelInviteUrn!) {
  channelInvite(id: $id) {
    id
    name
    description
    channelNameTemplate
    introductionTemplate
    settings {
      ...chatSettings
    }
  }
}
    ${ChatSettingsFragmentDoc}`;

/**
 * __useGetAdminChannelInviteQuery__
 *
 * To run a query within a React component, call `useGetAdminChannelInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminChannelInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminChannelInviteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminChannelInviteQuery(baseOptions: Apollo.QueryHookOptions<GetAdminChannelInviteQuery, GetAdminChannelInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminChannelInviteQuery, GetAdminChannelInviteQueryVariables>(GetAdminChannelInviteDocument, options);
      }
export function useGetAdminChannelInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminChannelInviteQuery, GetAdminChannelInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminChannelInviteQuery, GetAdminChannelInviteQueryVariables>(GetAdminChannelInviteDocument, options);
        }
export type GetAdminChannelInviteQueryHookResult = ReturnType<typeof useGetAdminChannelInviteQuery>;
export type GetAdminChannelInviteLazyQueryHookResult = ReturnType<typeof useGetAdminChannelInviteLazyQuery>;
export type GetAdminChannelInviteQueryResult = Apollo.QueryResult<GetAdminChannelInviteQuery, GetAdminChannelInviteQueryVariables>;
export const GetChannelInvitesDocument = gql`
    query GetChannelInvites {
  channelInvites {
    id
    name
    description
  }
}
    `;

/**
 * __useGetChannelInvitesQuery__
 *
 * To run a query within a React component, call `useGetChannelInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelInvitesQuery, GetChannelInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelInvitesQuery, GetChannelInvitesQueryVariables>(GetChannelInvitesDocument, options);
      }
export function useGetChannelInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelInvitesQuery, GetChannelInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelInvitesQuery, GetChannelInvitesQueryVariables>(GetChannelInvitesDocument, options);
        }
export type GetChannelInvitesQueryHookResult = ReturnType<typeof useGetChannelInvitesQuery>;
export type GetChannelInvitesLazyQueryHookResult = ReturnType<typeof useGetChannelInvitesLazyQuery>;
export type GetChannelInvitesQueryResult = Apollo.QueryResult<GetChannelInvitesQuery, GetChannelInvitesQueryVariables>;
export const SaveChannelInviteDocument = gql`
    mutation SaveChannelInvite($id: ChannelInviteUrn, $invite: ChannelInviteInput!) {
  saveChannelInvite(id: $id, invite: $invite) {
    id
  }
}
    `;
export type SaveChannelInviteMutationFn = Apollo.MutationFunction<SaveChannelInviteMutation, SaveChannelInviteMutationVariables>;

/**
 * __useSaveChannelInviteMutation__
 *
 * To run a mutation, you first call `useSaveChannelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChannelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChannelInviteMutation, { data, loading, error }] = useSaveChannelInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useSaveChannelInviteMutation(baseOptions?: Apollo.MutationHookOptions<SaveChannelInviteMutation, SaveChannelInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveChannelInviteMutation, SaveChannelInviteMutationVariables>(SaveChannelInviteDocument, options);
      }
export type SaveChannelInviteMutationHookResult = ReturnType<typeof useSaveChannelInviteMutation>;
export type SaveChannelInviteMutationResult = Apollo.MutationResult<SaveChannelInviteMutation>;
export type SaveChannelInviteMutationOptions = Apollo.BaseMutationOptions<SaveChannelInviteMutation, SaveChannelInviteMutationVariables>;
export const AddEmailAliasDocument = gql`
    mutation AddEmailAlias($email: String!) {
  addEmailAlias(email: $email) {
    ok
  }
}
    `;
export type AddEmailAliasMutationFn = Apollo.MutationFunction<AddEmailAliasMutation, AddEmailAliasMutationVariables>;

/**
 * __useAddEmailAliasMutation__
 *
 * To run a mutation, you first call `useAddEmailAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailAliasMutation, { data, loading, error }] = useAddEmailAliasMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddEmailAliasMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailAliasMutation, AddEmailAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailAliasMutation, AddEmailAliasMutationVariables>(AddEmailAliasDocument, options);
      }
export type AddEmailAliasMutationHookResult = ReturnType<typeof useAddEmailAliasMutation>;
export type AddEmailAliasMutationResult = Apollo.MutationResult<AddEmailAliasMutation>;
export type AddEmailAliasMutationOptions = Apollo.BaseMutationOptions<AddEmailAliasMutation, AddEmailAliasMutationVariables>;
export const DeleteEmailAliasDocument = gql`
    mutation DeleteEmailAlias($id: ChannelEmailUrn!) {
  deleteEmailAlias(id: $id) {
    ok
  }
}
    `;
export type DeleteEmailAliasMutationFn = Apollo.MutationFunction<DeleteEmailAliasMutation, DeleteEmailAliasMutationVariables>;

/**
 * __useDeleteEmailAliasMutation__
 *
 * To run a mutation, you first call `useDeleteEmailAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailAliasMutation, { data, loading, error }] = useDeleteEmailAliasMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailAliasMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailAliasMutation, DeleteEmailAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailAliasMutation, DeleteEmailAliasMutationVariables>(DeleteEmailAliasDocument, options);
      }
export type DeleteEmailAliasMutationHookResult = ReturnType<typeof useDeleteEmailAliasMutation>;
export type DeleteEmailAliasMutationResult = Apollo.MutationResult<DeleteEmailAliasMutation>;
export type DeleteEmailAliasMutationOptions = Apollo.BaseMutationOptions<DeleteEmailAliasMutation, DeleteEmailAliasMutationVariables>;
export const DisableHubSpokeDocument = gql`
    mutation DisableHubSpoke($settings: HubSpokeDisable!) {
  disableHubAndSpoke(settings: $settings) {
    ok
  }
}
    `;
export type DisableHubSpokeMutationFn = Apollo.MutationFunction<DisableHubSpokeMutation, DisableHubSpokeMutationVariables>;

/**
 * __useDisableHubSpokeMutation__
 *
 * To run a mutation, you first call `useDisableHubSpokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableHubSpokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableHubSpokeMutation, { data, loading, error }] = useDisableHubSpokeMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useDisableHubSpokeMutation(baseOptions?: Apollo.MutationHookOptions<DisableHubSpokeMutation, DisableHubSpokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableHubSpokeMutation, DisableHubSpokeMutationVariables>(DisableHubSpokeDocument, options);
      }
export type DisableHubSpokeMutationHookResult = ReturnType<typeof useDisableHubSpokeMutation>;
export type DisableHubSpokeMutationResult = Apollo.MutationResult<DisableHubSpokeMutation>;
export type DisableHubSpokeMutationOptions = Apollo.BaseMutationOptions<DisableHubSpokeMutation, DisableHubSpokeMutationVariables>;
export const EnableHubSpokeDocument = gql`
    mutation EnableHubSpoke($settings: HubSpokeEnable!) {
  enableHubAndSpoke(settings: $settings) {
    ok
  }
}
    `;
export type EnableHubSpokeMutationFn = Apollo.MutationFunction<EnableHubSpokeMutation, EnableHubSpokeMutationVariables>;

/**
 * __useEnableHubSpokeMutation__
 *
 * To run a mutation, you first call `useEnableHubSpokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableHubSpokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableHubSpokeMutation, { data, loading, error }] = useEnableHubSpokeMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEnableHubSpokeMutation(baseOptions?: Apollo.MutationHookOptions<EnableHubSpokeMutation, EnableHubSpokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableHubSpokeMutation, EnableHubSpokeMutationVariables>(EnableHubSpokeDocument, options);
      }
export type EnableHubSpokeMutationHookResult = ReturnType<typeof useEnableHubSpokeMutation>;
export type EnableHubSpokeMutationResult = Apollo.MutationResult<EnableHubSpokeMutation>;
export type EnableHubSpokeMutationOptions = Apollo.BaseMutationOptions<EnableHubSpokeMutation, EnableHubSpokeMutationVariables>;
export const GetHubMetadataDocument = gql`
    query GetHubMetadata($token: String!) {
  getHubData(token: $token) {
    name
    isSameAsSource
  }
}
    `;

/**
 * __useGetHubMetadataQuery__
 *
 * To run a query within a React component, call `useGetHubMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubMetadataQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetHubMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetHubMetadataQuery, GetHubMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHubMetadataQuery, GetHubMetadataQueryVariables>(GetHubMetadataDocument, options);
      }
export function useGetHubMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHubMetadataQuery, GetHubMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHubMetadataQuery, GetHubMetadataQueryVariables>(GetHubMetadataDocument, options);
        }
export type GetHubMetadataQueryHookResult = ReturnType<typeof useGetHubMetadataQuery>;
export type GetHubMetadataLazyQueryHookResult = ReturnType<typeof useGetHubMetadataLazyQuery>;
export type GetHubMetadataQueryResult = Apollo.QueryResult<GetHubMetadataQuery, GetHubMetadataQueryVariables>;
export const GetHubSpokeStatusDocument = gql`
    query GetHubSpokeStatus {
  getHubSpokeStatus {
    forwardingTo {
      id
      name
    }
    forwardedFrom {
      id
      name
    }
  }
}
    `;

/**
 * __useGetHubSpokeStatusQuery__
 *
 * To run a query within a React component, call `useGetHubSpokeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubSpokeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubSpokeStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHubSpokeStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetHubSpokeStatusQuery, GetHubSpokeStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHubSpokeStatusQuery, GetHubSpokeStatusQueryVariables>(GetHubSpokeStatusDocument, options);
      }
export function useGetHubSpokeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHubSpokeStatusQuery, GetHubSpokeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHubSpokeStatusQuery, GetHubSpokeStatusQueryVariables>(GetHubSpokeStatusDocument, options);
        }
export type GetHubSpokeStatusQueryHookResult = ReturnType<typeof useGetHubSpokeStatusQuery>;
export type GetHubSpokeStatusLazyQueryHookResult = ReturnType<typeof useGetHubSpokeStatusLazyQuery>;
export type GetHubSpokeStatusQueryResult = Apollo.QueryResult<GetHubSpokeStatusQuery, GetHubSpokeStatusQueryVariables>;
export const GetHubSpokeTokenDocument = gql`
    query GetHubSpokeToken {
  hubSpokeToken {
    token
  }
}
    `;

/**
 * __useGetHubSpokeTokenQuery__
 *
 * To run a query within a React component, call `useGetHubSpokeTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubSpokeTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubSpokeTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHubSpokeTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetHubSpokeTokenQuery, GetHubSpokeTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHubSpokeTokenQuery, GetHubSpokeTokenQueryVariables>(GetHubSpokeTokenDocument, options);
      }
export function useGetHubSpokeTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHubSpokeTokenQuery, GetHubSpokeTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHubSpokeTokenQuery, GetHubSpokeTokenQueryVariables>(GetHubSpokeTokenDocument, options);
        }
export type GetHubSpokeTokenQueryHookResult = ReturnType<typeof useGetHubSpokeTokenQuery>;
export type GetHubSpokeTokenLazyQueryHookResult = ReturnType<typeof useGetHubSpokeTokenLazyQuery>;
export type GetHubSpokeTokenQueryResult = Apollo.QueryResult<GetHubSpokeTokenQuery, GetHubSpokeTokenQueryVariables>;
export const DeleteChatSettingsDocument = gql`
    mutation DeleteChatSettings($id: Urn!) {
  deleteChatSettings(id: $id) {
    ok
  }
}
    `;
export type DeleteChatSettingsMutationFn = Apollo.MutationFunction<DeleteChatSettingsMutation, DeleteChatSettingsMutationVariables>;

/**
 * __useDeleteChatSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteChatSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatSettingsMutation, { data, loading, error }] = useDeleteChatSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatSettingsMutation, DeleteChatSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatSettingsMutation, DeleteChatSettingsMutationVariables>(DeleteChatSettingsDocument, options);
      }
export type DeleteChatSettingsMutationHookResult = ReturnType<typeof useDeleteChatSettingsMutation>;
export type DeleteChatSettingsMutationResult = Apollo.MutationResult<DeleteChatSettingsMutation>;
export type DeleteChatSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteChatSettingsMutation, DeleteChatSettingsMutationVariables>;
export const GetSlackChannelSettingsDocument = gql`
    query GetSlackChannelSettings {
  chatSettingsMany(filter: SLACK_CHANNELS) {
    id
    options {
      slack {
        name
        workspaceName
        tags
      }
    }
  }
  channelTags: chatSettingsMany(filter: CHANNEL_TAGS) {
    id
    options {
      tag {
        name
      }
    }
  }
}
    `;

/**
 * __useGetSlackChannelSettingsQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSlackChannelSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSlackChannelSettingsQuery, GetSlackChannelSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlackChannelSettingsQuery, GetSlackChannelSettingsQueryVariables>(GetSlackChannelSettingsDocument, options);
      }
export function useGetSlackChannelSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlackChannelSettingsQuery, GetSlackChannelSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlackChannelSettingsQuery, GetSlackChannelSettingsQueryVariables>(GetSlackChannelSettingsDocument, options);
        }
export type GetSlackChannelSettingsQueryHookResult = ReturnType<typeof useGetSlackChannelSettingsQuery>;
export type GetSlackChannelSettingsLazyQueryHookResult = ReturnType<typeof useGetSlackChannelSettingsLazyQuery>;
export type GetSlackChannelSettingsQueryResult = Apollo.QueryResult<GetSlackChannelSettingsQuery, GetSlackChannelSettingsQueryVariables>;
export const GetChatSettingsDocument = gql`
    query GetChatSettings($id: Urn!) {
  chatSettings(id: $id) {
    ...chatSettings
  }
}
    ${ChatSettingsFragmentDoc}`;

/**
 * __useGetChatSettingsQuery__
 *
 * To run a query within a React component, call `useGetChatSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetChatSettingsQuery, GetChatSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatSettingsQuery, GetChatSettingsQueryVariables>(GetChatSettingsDocument, options);
      }
export function useGetChatSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatSettingsQuery, GetChatSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatSettingsQuery, GetChatSettingsQueryVariables>(GetChatSettingsDocument, options);
        }
export type GetChatSettingsQueryHookResult = ReturnType<typeof useGetChatSettingsQuery>;
export type GetChatSettingsLazyQueryHookResult = ReturnType<typeof useGetChatSettingsLazyQuery>;
export type GetChatSettingsQueryResult = Apollo.QueryResult<GetChatSettingsQuery, GetChatSettingsQueryVariables>;
export const SaveChatSettingsDocument = gql`
    mutation SaveChatSettings($settings: ChatSettingsInput!, $id: Urn!) {
  saveChatSettings(settings: $settings, id: $id) {
    ok
  }
}
    `;
export type SaveChatSettingsMutationFn = Apollo.MutationFunction<SaveChatSettingsMutation, SaveChatSettingsMutationVariables>;

/**
 * __useSaveChatSettingsMutation__
 *
 * To run a mutation, you first call `useSaveChatSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChatSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChatSettingsMutation, { data, loading, error }] = useSaveChatSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveChatSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveChatSettingsMutation, SaveChatSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveChatSettingsMutation, SaveChatSettingsMutationVariables>(SaveChatSettingsDocument, options);
      }
export type SaveChatSettingsMutationHookResult = ReturnType<typeof useSaveChatSettingsMutation>;
export type SaveChatSettingsMutationResult = Apollo.MutationResult<SaveChatSettingsMutation>;
export type SaveChatSettingsMutationOptions = Apollo.BaseMutationOptions<SaveChatSettingsMutation, SaveChatSettingsMutationVariables>;
export const DeleteFormFieldDocument = gql`
    mutation DeleteFormField($id: FormFieldUrn!) {
  deleteFormField(id: $id) {
    ok
  }
}
    `;
export type DeleteFormFieldMutationFn = Apollo.MutationFunction<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>;

/**
 * __useDeleteFormFieldMutation__
 *
 * To run a mutation, you first call `useDeleteFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormFieldMutation, { data, loading, error }] = useDeleteFormFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>(DeleteFormFieldDocument, options);
      }
export type DeleteFormFieldMutationHookResult = ReturnType<typeof useDeleteFormFieldMutation>;
export type DeleteFormFieldMutationResult = Apollo.MutationResult<DeleteFormFieldMutation>;
export type DeleteFormFieldMutationOptions = Apollo.BaseMutationOptions<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>;
export const GetFormFieldDocument = gql`
    query GetFormField($id: FormFieldUrn!) {
  formField(id: $id) {
    id
    options {
      ...OptionFields
    }
    name
    description
    placeholder
    type
    levels
    userGroupIds
    visibility
    asyncObjectType
    isTemplate
  }
}
    ${OptionFieldsFragmentDoc}`;

/**
 * __useGetFormFieldQuery__
 *
 * To run a query within a React component, call `useGetFormFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormFieldQuery(baseOptions: Apollo.QueryHookOptions<GetFormFieldQuery, GetFormFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormFieldQuery, GetFormFieldQueryVariables>(GetFormFieldDocument, options);
      }
export function useGetFormFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormFieldQuery, GetFormFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormFieldQuery, GetFormFieldQueryVariables>(GetFormFieldDocument, options);
        }
export type GetFormFieldQueryHookResult = ReturnType<typeof useGetFormFieldQuery>;
export type GetFormFieldLazyQueryHookResult = ReturnType<typeof useGetFormFieldLazyQuery>;
export type GetFormFieldQueryResult = Apollo.QueryResult<GetFormFieldQuery, GetFormFieldQueryVariables>;
export const SaveFormFieldDocument = gql`
    mutation SaveFormField($formField: FormFieldInput!, $id: FormFieldUrn) {
  saveFormField(formField: $formField, id: $id) {
    id
  }
}
    `;
export type SaveFormFieldMutationFn = Apollo.MutationFunction<SaveFormFieldMutation, SaveFormFieldMutationVariables>;

/**
 * __useSaveFormFieldMutation__
 *
 * To run a mutation, you first call `useSaveFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFormFieldMutation, { data, loading, error }] = useSaveFormFieldMutation({
 *   variables: {
 *      formField: // value for 'formField'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<SaveFormFieldMutation, SaveFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFormFieldMutation, SaveFormFieldMutationVariables>(SaveFormFieldDocument, options);
      }
export type SaveFormFieldMutationHookResult = ReturnType<typeof useSaveFormFieldMutation>;
export type SaveFormFieldMutationResult = Apollo.MutationResult<SaveFormFieldMutation>;
export type SaveFormFieldMutationOptions = Apollo.BaseMutationOptions<SaveFormFieldMutation, SaveFormFieldMutationVariables>;
export const SavePortalSettingsDocument = gql`
    mutation SavePortalSettings($portal: PortalSettingsInput!) {
  savePortal(portal: $portal) {
    id
  }
}
    `;
export type SavePortalSettingsMutationFn = Apollo.MutationFunction<SavePortalSettingsMutation, SavePortalSettingsMutationVariables>;

/**
 * __useSavePortalSettingsMutation__
 *
 * To run a mutation, you first call `useSavePortalSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePortalSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePortalSettingsMutation, { data, loading, error }] = useSavePortalSettingsMutation({
 *   variables: {
 *      portal: // value for 'portal'
 *   },
 * });
 */
export function useSavePortalSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SavePortalSettingsMutation, SavePortalSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePortalSettingsMutation, SavePortalSettingsMutationVariables>(SavePortalSettingsDocument, options);
      }
export type SavePortalSettingsMutationHookResult = ReturnType<typeof useSavePortalSettingsMutation>;
export type SavePortalSettingsMutationResult = Apollo.MutationResult<SavePortalSettingsMutation>;
export type SavePortalSettingsMutationOptions = Apollo.BaseMutationOptions<SavePortalSettingsMutation, SavePortalSettingsMutationVariables>;
export const GetPortalSettingsDocument = gql`
    query GetPortalSettings {
  portal {
    id
    title
    welcomeMessage
    chatToken
    domains
    publicPermissions
    guestPermissions
    isSharedChannelGuest
    portalIndexProvider
    publicFormIds
    guestFormIds
    isAIEnabled
    singleSignOn {
      isEnabled
      loginRedirectUrl
      identityProviderMetadata
      providerLoginUrl
    }
    userProvisioning {
      administratorGroupId
      providerSCIMUrl
    }
  }
}
    `;

/**
 * __useGetPortalSettingsQuery__
 *
 * To run a query within a React component, call `useGetPortalSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetPortalSettingsQuery, GetPortalSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalSettingsQuery, GetPortalSettingsQueryVariables>(GetPortalSettingsDocument, options);
      }
export function useGetPortalSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalSettingsQuery, GetPortalSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalSettingsQuery, GetPortalSettingsQueryVariables>(GetPortalSettingsDocument, options);
        }
export type GetPortalSettingsQueryHookResult = ReturnType<typeof useGetPortalSettingsQuery>;
export type GetPortalSettingsLazyQueryHookResult = ReturnType<typeof useGetPortalSettingsLazyQuery>;
export type GetPortalSettingsQueryResult = Apollo.QueryResult<GetPortalSettingsQuery, GetPortalSettingsQueryVariables>;
export const DeleteQueueDocument = gql`
    mutation DeleteQueue($id: QueueUrn!) {
  deleteQueue(id: $id) {
    ok
  }
}
    `;
export type DeleteQueueMutationFn = Apollo.MutationFunction<DeleteQueueMutation, DeleteQueueMutationVariables>;

/**
 * __useDeleteQueueMutation__
 *
 * To run a mutation, you first call `useDeleteQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueueMutation, { data, loading, error }] = useDeleteQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQueueMutation, DeleteQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQueueMutation, DeleteQueueMutationVariables>(DeleteQueueDocument, options);
      }
export type DeleteQueueMutationHookResult = ReturnType<typeof useDeleteQueueMutation>;
export type DeleteQueueMutationResult = Apollo.MutationResult<DeleteQueueMutation>;
export type DeleteQueueMutationOptions = Apollo.BaseMutationOptions<DeleteQueueMutation, DeleteQueueMutationVariables>;
export const GetQueueDocument = gql`
    query GetQueue($id: QueueUrn!) {
  queue(id: $id) {
    id
    name
    description
    channelTags
    integrationIds
    emailAliasIds
    userAssignmentType
    members {
      role
      userId
      memberId
      user {
        id
        name
        lastName
        name
        avatarUrl
      }
      group {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetQueueQuery__
 *
 * To run a query within a React component, call `useGetQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQueueQuery(baseOptions: Apollo.QueryHookOptions<GetQueueQuery, GetQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
      }
export function useGetQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueQuery, GetQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
        }
export type GetQueueQueryHookResult = ReturnType<typeof useGetQueueQuery>;
export type GetQueueLazyQueryHookResult = ReturnType<typeof useGetQueueLazyQuery>;
export type GetQueueQueryResult = Apollo.QueryResult<GetQueueQuery, GetQueueQueryVariables>;
export const GetQueuesDocument = gql`
    query GetQueues {
  queues {
    id
    name
    description
    userAssignmentType
    members {
      userId
      memberId
      user {
        firstName
        lastName
        name
        avatarUrl
      }
      group {
        id
        name
      }
    }
  }
  defaultQueue {
    id
    members {
      userId
      memberId
    }
  }
}
    `;

/**
 * __useGetQueuesQuery__
 *
 * To run a query within a React component, call `useGetQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQueuesQuery(baseOptions?: Apollo.QueryHookOptions<GetQueuesQuery, GetQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueuesQuery, GetQueuesQueryVariables>(GetQueuesDocument, options);
      }
export function useGetQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueuesQuery, GetQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueuesQuery, GetQueuesQueryVariables>(GetQueuesDocument, options);
        }
export type GetQueuesQueryHookResult = ReturnType<typeof useGetQueuesQuery>;
export type GetQueuesLazyQueryHookResult = ReturnType<typeof useGetQueuesLazyQuery>;
export type GetQueuesQueryResult = Apollo.QueryResult<GetQueuesQuery, GetQueuesQueryVariables>;
export const SaveDefaultQueueDocument = gql`
    mutation SaveDefaultQueue($id: QueueUrn) {
  saveDefaultQueue(id: $id) {
    ok
  }
}
    `;
export type SaveDefaultQueueMutationFn = Apollo.MutationFunction<SaveDefaultQueueMutation, SaveDefaultQueueMutationVariables>;

/**
 * __useSaveDefaultQueueMutation__
 *
 * To run a mutation, you first call `useSaveDefaultQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDefaultQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDefaultQueueMutation, { data, loading, error }] = useSaveDefaultQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveDefaultQueueMutation(baseOptions?: Apollo.MutationHookOptions<SaveDefaultQueueMutation, SaveDefaultQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDefaultQueueMutation, SaveDefaultQueueMutationVariables>(SaveDefaultQueueDocument, options);
      }
export type SaveDefaultQueueMutationHookResult = ReturnType<typeof useSaveDefaultQueueMutation>;
export type SaveDefaultQueueMutationResult = Apollo.MutationResult<SaveDefaultQueueMutation>;
export type SaveDefaultQueueMutationOptions = Apollo.BaseMutationOptions<SaveDefaultQueueMutation, SaveDefaultQueueMutationVariables>;
export const SaveQueueDocument = gql`
    mutation SaveQueue($queue: QueueInput!, $id: QueueUrn) {
  saveQueue(queue: $queue, id: $id) {
    id
  }
}
    `;
export type SaveQueueMutationFn = Apollo.MutationFunction<SaveQueueMutation, SaveQueueMutationVariables>;

/**
 * __useSaveQueueMutation__
 *
 * To run a mutation, you first call `useSaveQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQueueMutation, { data, loading, error }] = useSaveQueueMutation({
 *   variables: {
 *      queue: // value for 'queue'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveQueueMutation(baseOptions?: Apollo.MutationHookOptions<SaveQueueMutation, SaveQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQueueMutation, SaveQueueMutationVariables>(SaveQueueDocument, options);
      }
export type SaveQueueMutationHookResult = ReturnType<typeof useSaveQueueMutation>;
export type SaveQueueMutationResult = Apollo.MutationResult<SaveQueueMutation>;
export type SaveQueueMutationOptions = Apollo.BaseMutationOptions<SaveQueueMutation, SaveQueueMutationVariables>;
export const CloneFormDocument = gql`
    mutation CloneForm($id: FormUrn!) {
  cloneForm(id: $id) {
    id
  }
}
    `;
export type CloneFormMutationFn = Apollo.MutationFunction<CloneFormMutation, CloneFormMutationVariables>;

/**
 * __useCloneFormMutation__
 *
 * To run a mutation, you first call `useCloneFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneFormMutation, { data, loading, error }] = useCloneFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneFormMutation(baseOptions?: Apollo.MutationHookOptions<CloneFormMutation, CloneFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneFormMutation, CloneFormMutationVariables>(CloneFormDocument, options);
      }
export type CloneFormMutationHookResult = ReturnType<typeof useCloneFormMutation>;
export type CloneFormMutationResult = Apollo.MutationResult<CloneFormMutation>;
export type CloneFormMutationOptions = Apollo.BaseMutationOptions<CloneFormMutation, CloneFormMutationVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($id: FormUrn!) {
  deleteForm(id: $id) {
    ok
  }
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const GetExternalFormFieldsDocument = gql`
    query GetExternalFormFields($id: FormExternalUrn!) {
  externalFormFields(id: $id) {
    ...FieldInputs
  }
}
    ${FieldInputsFragmentDoc}`;

/**
 * __useGetExternalFormFieldsQuery__
 *
 * To run a query within a React component, call `useGetExternalFormFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalFormFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalFormFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExternalFormFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalFormFieldsQuery, GetExternalFormFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalFormFieldsQuery, GetExternalFormFieldsQueryVariables>(GetExternalFormFieldsDocument, options);
      }
export function useGetExternalFormFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalFormFieldsQuery, GetExternalFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalFormFieldsQuery, GetExternalFormFieldsQueryVariables>(GetExternalFormFieldsDocument, options);
        }
export type GetExternalFormFieldsQueryHookResult = ReturnType<typeof useGetExternalFormFieldsQuery>;
export type GetExternalFormFieldsLazyQueryHookResult = ReturnType<typeof useGetExternalFormFieldsLazyQuery>;
export type GetExternalFormFieldsQueryResult = Apollo.QueryResult<GetExternalFormFieldsQuery, GetExternalFormFieldsQueryVariables>;
export const GetFormDataDocument = gql`
    query GetFormData($shouldIncludeTemplateFields: Boolean! = false) {
  formFields(
    shouldIncludeSystemFields: true
    shouldIncludePrivate: true
    shouldIncludeTemplateFields: $shouldIncludeTemplateFields
  ) {
    id
    isSystemField
    options {
      ...OptionFields
    }
    name
    placeholder
    description
    type
    levels
    userGroupIds
    visibility
    asyncObjectType
  }
  integrations {
    id
    label
    type
    actions
  }
}
    ${OptionFieldsFragmentDoc}`;

/**
 * __useGetFormDataQuery__
 *
 * To run a query within a React component, call `useGetFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormDataQuery({
 *   variables: {
 *      shouldIncludeTemplateFields: // value for 'shouldIncludeTemplateFields'
 *   },
 * });
 */
export function useGetFormDataQuery(baseOptions?: Apollo.QueryHookOptions<GetFormDataQuery, GetFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormDataQuery, GetFormDataQueryVariables>(GetFormDataDocument, options);
      }
export function useGetFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormDataQuery, GetFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormDataQuery, GetFormDataQueryVariables>(GetFormDataDocument, options);
        }
export type GetFormDataQueryHookResult = ReturnType<typeof useGetFormDataQuery>;
export type GetFormDataLazyQueryHookResult = ReturnType<typeof useGetFormDataLazyQuery>;
export type GetFormDataQueryResult = Apollo.QueryResult<GetFormDataQuery, GetFormDataQueryVariables>;
export const GetFormDocument = gql`
    query GetForm($id: FormUrn!, $hasId: Boolean! = false) {
  form(id: $id) @include(if: $hasId) {
    id
    name
    type
    description
    tags
    jobFunctions
    iconUrl
    shouldCreateOnOnboarding
    fields {
      fieldId
      agentText
      requestorText
      isRequired
      isRequiredForAgent
      name
      description
      placeholder
      defaultValue {
        value {
          type
          string
          number
          options
          date
          boolean
        }
        replacements {
          groupId
          fieldId
          replacement
        }
      }
    }
    isCreatePrivate
    userGroupIds
    deflection {
      isEnabled
      identity
    }
    approvals {
      type
      integrationId
    }
    workflow {
      ...Workflow
    }
    externalFormId
    actionSettings {
      startCondition
    }
    exampleInput {
      body
      headers
      ipAddress
      method
    }
  }
}
    ${WorkflowFragmentDoc}`;

/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *      hasId: // value for 'hasId'
 *   },
 * });
 */
export function useGetFormQuery(baseOptions: Apollo.QueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
      }
export function useGetFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
        }
export type GetFormQueryHookResult = ReturnType<typeof useGetFormQuery>;
export type GetFormLazyQueryHookResult = ReturnType<typeof useGetFormLazyQuery>;
export type GetFormQueryResult = Apollo.QueryResult<GetFormQuery, GetFormQueryVariables>;
export const GetWebhookExampleDocument = gql`
    query getWebhookExample($stepId: WorkflowStepUrn!) {
  workflowServicePollWebhookExample(stepId: $stepId) {
    isFound
    formId
  }
}
    `;

/**
 * __useGetWebhookExampleQuery__
 *
 * To run a query within a React component, call `useGetWebhookExampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookExampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookExampleQuery({
 *   variables: {
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useGetWebhookExampleQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookExampleQuery, GetWebhookExampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookExampleQuery, GetWebhookExampleQueryVariables>(GetWebhookExampleDocument, options);
      }
export function useGetWebhookExampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookExampleQuery, GetWebhookExampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookExampleQuery, GetWebhookExampleQueryVariables>(GetWebhookExampleDocument, options);
        }
export type GetWebhookExampleQueryHookResult = ReturnType<typeof useGetWebhookExampleQuery>;
export type GetWebhookExampleLazyQueryHookResult = ReturnType<typeof useGetWebhookExampleLazyQuery>;
export type GetWebhookExampleQueryResult = Apollo.QueryResult<GetWebhookExampleQuery, GetWebhookExampleQueryVariables>;
export const SaveFormDocument = gql`
    mutation SaveForm($id: FormUrn, $form: FormInput!) {
  saveForm(id: $id, form: $form) {
    id
    name
    description
    tags
    jobFunctions
    iconUrl
    fields {
      fieldId
      isRequired
      isRequiredForAgent
      name
      description
      agentText
      requestorText
      placeholder
      defaultValue {
        value {
          type
          string
          number
          options
          date
          boolean
        }
        replacements {
          groupId
          fieldId
          replacement
        }
      }
    }
  }
}
    `;
export type SaveFormMutationFn = Apollo.MutationFunction<SaveFormMutation, SaveFormMutationVariables>;

/**
 * __useSaveFormMutation__
 *
 * To run a mutation, you first call `useSaveFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFormMutation, { data, loading, error }] = useSaveFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useSaveFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveFormMutation, SaveFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFormMutation, SaveFormMutationVariables>(SaveFormDocument, options);
      }
export type SaveFormMutationHookResult = ReturnType<typeof useSaveFormMutation>;
export type SaveFormMutationResult = Apollo.MutationResult<SaveFormMutation>;
export type SaveFormMutationOptions = Apollo.BaseMutationOptions<SaveFormMutation, SaveFormMutationVariables>;
export const GetRequestTypesDocument = gql`
    query GetRequestTypes($type: FormType) {
  forms(type: $type) {
    id
    name
    description
    userGroupIds
  }
  templates: forms(type: TEMPLATE) {
    id
    name
    description
    iconUrl
    jobFunctions
    tags
  }
  formFields {
    id
    name
    description
    type
    userGroupIds
  }
  userGroups {
    id
    name
  }
}
    `;

/**
 * __useGetRequestTypesQuery__
 *
 * To run a query within a React component, call `useGetRequestTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestTypesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetRequestTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestTypesQuery, GetRequestTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestTypesQuery, GetRequestTypesQueryVariables>(GetRequestTypesDocument, options);
      }
export function useGetRequestTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestTypesQuery, GetRequestTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestTypesQuery, GetRequestTypesQueryVariables>(GetRequestTypesDocument, options);
        }
export type GetRequestTypesQueryHookResult = ReturnType<typeof useGetRequestTypesQuery>;
export type GetRequestTypesLazyQueryHookResult = ReturnType<typeof useGetRequestTypesLazyQuery>;
export type GetRequestTypesQueryResult = Apollo.QueryResult<GetRequestTypesQuery, GetRequestTypesQueryVariables>;
export const GetTicketStateDocument = gql`
    query GetTicketState($id: TicketStateUrn!) {
  ticketState(id: $id) {
    id
    name
    description
    ticketStatuses
    chatStatuses
  }
}
    `;

/**
 * __useGetTicketStateQuery__
 *
 * To run a query within a React component, call `useGetTicketStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTicketStateQuery(baseOptions: Apollo.QueryHookOptions<GetTicketStateQuery, GetTicketStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketStateQuery, GetTicketStateQueryVariables>(GetTicketStateDocument, options);
      }
export function useGetTicketStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketStateQuery, GetTicketStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketStateQuery, GetTicketStateQueryVariables>(GetTicketStateDocument, options);
        }
export type GetTicketStateQueryHookResult = ReturnType<typeof useGetTicketStateQuery>;
export type GetTicketStateLazyQueryHookResult = ReturnType<typeof useGetTicketStateLazyQuery>;
export type GetTicketStateQueryResult = Apollo.QueryResult<GetTicketStateQuery, GetTicketStateQueryVariables>;
export const GetTicketStatesListDocument = gql`
    query GetTicketStatesList {
  ticketStates {
    id
    name
    description
    ticketStatuses
    chatStatuses
  }
}
    `;

/**
 * __useGetTicketStatesListQuery__
 *
 * To run a query within a React component, call `useGetTicketStatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketStatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketStatesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTicketStatesListQuery(baseOptions?: Apollo.QueryHookOptions<GetTicketStatesListQuery, GetTicketStatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketStatesListQuery, GetTicketStatesListQueryVariables>(GetTicketStatesListDocument, options);
      }
export function useGetTicketStatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketStatesListQuery, GetTicketStatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketStatesListQuery, GetTicketStatesListQueryVariables>(GetTicketStatesListDocument, options);
        }
export type GetTicketStatesListQueryHookResult = ReturnType<typeof useGetTicketStatesListQuery>;
export type GetTicketStatesListLazyQueryHookResult = ReturnType<typeof useGetTicketStatesListLazyQuery>;
export type GetTicketStatesListQueryResult = Apollo.QueryResult<GetTicketStatesListQuery, GetTicketStatesListQueryVariables>;
export const SaveTicketStateDocument = gql`
    mutation SaveTicketState($id: TicketStateUrn, $state: TicketStateInput!) {
  saveTicketState(id: $id, state: $state) {
    id
    name
    description
  }
}
    `;
export type SaveTicketStateMutationFn = Apollo.MutationFunction<SaveTicketStateMutation, SaveTicketStateMutationVariables>;

/**
 * __useSaveTicketStateMutation__
 *
 * To run a mutation, you first call `useSaveTicketStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTicketStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTicketStateMutation, { data, loading, error }] = useSaveTicketStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSaveTicketStateMutation(baseOptions?: Apollo.MutationHookOptions<SaveTicketStateMutation, SaveTicketStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTicketStateMutation, SaveTicketStateMutationVariables>(SaveTicketStateDocument, options);
      }
export type SaveTicketStateMutationHookResult = ReturnType<typeof useSaveTicketStateMutation>;
export type SaveTicketStateMutationResult = Apollo.MutationResult<SaveTicketStateMutation>;
export type SaveTicketStateMutationOptions = Apollo.BaseMutationOptions<SaveTicketStateMutation, SaveTicketStateMutationVariables>;
export const DeleteUserGroupDocument = gql`
    mutation DeleteUserGroup($id: UserGroupUrn!) {
  deleteUserGroup(id: $id) {
    ok
  }
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const GetUserGroupDocument = gql`
    query GetUserGroup($id: UserGroupUrn!) {
  userGroup(id: $id) {
    id
    name
    description
    userIds
    users {
      name
      lastName
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetUserGroupQuery__
 *
 * To run a query within a React component, call `useGetUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserGroupQuery(baseOptions: Apollo.QueryHookOptions<GetUserGroupQuery, GetUserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupQuery, GetUserGroupQueryVariables>(GetUserGroupDocument, options);
      }
export function useGetUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupQuery, GetUserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupQuery, GetUserGroupQueryVariables>(GetUserGroupDocument, options);
        }
export type GetUserGroupQueryHookResult = ReturnType<typeof useGetUserGroupQuery>;
export type GetUserGroupLazyQueryHookResult = ReturnType<typeof useGetUserGroupLazyQuery>;
export type GetUserGroupQueryResult = Apollo.QueryResult<GetUserGroupQuery, GetUserGroupQueryVariables>;
export const GetUserGroupsDocument = gql`
    query GetUserGroups {
  userGroups {
    id
    name
    description
    users {
      name
      lastName
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsQueryResult = Apollo.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const SaveUserGroupDocument = gql`
    mutation SaveUserGroup($userGroup: UserGroupInput!, $id: UserGroupUrn) {
  saveUserGroup(userGroup: $userGroup, id: $id) {
    id
  }
}
    `;
export type SaveUserGroupMutationFn = Apollo.MutationFunction<SaveUserGroupMutation, SaveUserGroupMutationVariables>;

/**
 * __useSaveUserGroupMutation__
 *
 * To run a mutation, you first call `useSaveUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserGroupMutation, { data, loading, error }] = useSaveUserGroupMutation({
 *   variables: {
 *      userGroup: // value for 'userGroup'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserGroupMutation, SaveUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserGroupMutation, SaveUserGroupMutationVariables>(SaveUserGroupDocument, options);
      }
export type SaveUserGroupMutationHookResult = ReturnType<typeof useSaveUserGroupMutation>;
export type SaveUserGroupMutationResult = Apollo.MutationResult<SaveUserGroupMutation>;
export type SaveUserGroupMutationOptions = Apollo.BaseMutationOptions<SaveUserGroupMutation, SaveUserGroupMutationVariables>;
export const GetUserAgentsDocument = gql`
    query GetUserAgents {
  users(filters: {roles: [AGENT, ADMINISTRATOR]}) {
    id
    name
    avatarUrl
    role
  }
  portal {
    billing {
      isSetup
      purchasedUserCount
    }
  }
}
    `;

/**
 * __useGetUserAgentsQuery__
 *
 * To run a query within a React component, call `useGetUserAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAgentsQuery, GetUserAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAgentsQuery, GetUserAgentsQueryVariables>(GetUserAgentsDocument, options);
      }
export function useGetUserAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAgentsQuery, GetUserAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAgentsQuery, GetUserAgentsQueryVariables>(GetUserAgentsDocument, options);
        }
export type GetUserAgentsQueryHookResult = ReturnType<typeof useGetUserAgentsQuery>;
export type GetUserAgentsLazyQueryHookResult = ReturnType<typeof useGetUserAgentsLazyQuery>;
export type GetUserAgentsQueryResult = Apollo.QueryResult<GetUserAgentsQuery, GetUserAgentsQueryVariables>;
export const SetUserRoleDocument = gql`
    mutation SetUserRole($ids: [Urn!]!, $role: UserRole!) {
  setUsersRole(ids: $ids, role: $role) {
    ok
  }
}
    `;
export type SetUserRoleMutationFn = Apollo.MutationFunction<SetUserRoleMutation, SetUserRoleMutationVariables>;

/**
 * __useSetUserRoleMutation__
 *
 * To run a mutation, you first call `useSetUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleMutation, { data, loading, error }] = useSetUserRoleMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRoleMutation, SetUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument, options);
      }
export type SetUserRoleMutationHookResult = ReturnType<typeof useSetUserRoleMutation>;
export type SetUserRoleMutationResult = Apollo.MutationResult<SetUserRoleMutation>;
export type SetUserRoleMutationOptions = Apollo.BaseMutationOptions<SetUserRoleMutation, SetUserRoleMutationVariables>;
export const GetWorkflowServiceDocument = gql`
    query GetWorkflowService($id: Urn!) {
  workflowService(id: $id) {
    id
    name
    longDescription
    iconUrl
    searchHighlight
    actionTypes
    actions {
      name
      description
    }
    installedIntegrationIds
    installedIntegrations {
      id
      label
      settings {
        fieldId
        type
        displayValue
        string
        boolean
        date
        number
        options
      }
      actionPermissions {
        groupIds
        action
      }
    }
    options {
      title
      description
      options {
        instructions
        input {
          ...FieldInputs
        }
      }
    }
    learnMore {
      websiteUrl
      termsOfServiceUrl
      privacyPolicyUrl
      dataProtectionUrl
      securityCenterUrl
      supportCenterUrl
    }
    connection {
      name
      buttonText
      apiKey {
        instructions
        placeholder
        apiKeyFieldName
        input {
          ...FieldInputs
        }
      }
      manual {
        instructions
        input {
          ...FieldInputs
        }
      }
      oauth {
        instructions
        input {
          ...FieldInputs
        }
      }
      url {
        url
      }
    }
  }
}
    ${FieldInputsFragmentDoc}`;

/**
 * __useGetWorkflowServiceQuery__
 *
 * To run a query within a React component, call `useGetWorkflowServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowServiceQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowServiceQuery, GetWorkflowServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowServiceQuery, GetWorkflowServiceQueryVariables>(GetWorkflowServiceDocument, options);
      }
export function useGetWorkflowServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowServiceQuery, GetWorkflowServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowServiceQuery, GetWorkflowServiceQueryVariables>(GetWorkflowServiceDocument, options);
        }
export type GetWorkflowServiceQueryHookResult = ReturnType<typeof useGetWorkflowServiceQuery>;
export type GetWorkflowServiceLazyQueryHookResult = ReturnType<typeof useGetWorkflowServiceLazyQuery>;
export type GetWorkflowServiceQueryResult = Apollo.QueryResult<GetWorkflowServiceQuery, GetWorkflowServiceQueryVariables>;
export const GetWorkflowServicesDocument = gql`
    query GetWorkflowServices($query: String) {
  workflowServices(query: $query) {
    id
    name
    shortDescription
    iconUrl
    searchHighlight
    actionTypes
    installedIntegrationIds
  }
}
    `;

/**
 * __useGetWorkflowServicesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowServicesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetWorkflowServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowServicesQuery, GetWorkflowServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowServicesQuery, GetWorkflowServicesQueryVariables>(GetWorkflowServicesDocument, options);
      }
export function useGetWorkflowServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowServicesQuery, GetWorkflowServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowServicesQuery, GetWorkflowServicesQueryVariables>(GetWorkflowServicesDocument, options);
        }
export type GetWorkflowServicesQueryHookResult = ReturnType<typeof useGetWorkflowServicesQuery>;
export type GetWorkflowServicesLazyQueryHookResult = ReturnType<typeof useGetWorkflowServicesLazyQuery>;
export type GetWorkflowServicesQueryResult = Apollo.QueryResult<GetWorkflowServicesQuery, GetWorkflowServicesQueryVariables>;
export const InstallWorkflowServiceDocument = gql`
    mutation InstallWorkflowService($install: WorkflowServiceInstallInput!) {
  workflowServiceInstall(install: $install) {
    ok
    redirectUrl
  }
}
    `;
export type InstallWorkflowServiceMutationFn = Apollo.MutationFunction<InstallWorkflowServiceMutation, InstallWorkflowServiceMutationVariables>;

/**
 * __useInstallWorkflowServiceMutation__
 *
 * To run a mutation, you first call `useInstallWorkflowServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallWorkflowServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installWorkflowServiceMutation, { data, loading, error }] = useInstallWorkflowServiceMutation({
 *   variables: {
 *      install: // value for 'install'
 *   },
 * });
 */
export function useInstallWorkflowServiceMutation(baseOptions?: Apollo.MutationHookOptions<InstallWorkflowServiceMutation, InstallWorkflowServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallWorkflowServiceMutation, InstallWorkflowServiceMutationVariables>(InstallWorkflowServiceDocument, options);
      }
export type InstallWorkflowServiceMutationHookResult = ReturnType<typeof useInstallWorkflowServiceMutation>;
export type InstallWorkflowServiceMutationResult = Apollo.MutationResult<InstallWorkflowServiceMutation>;
export type InstallWorkflowServiceMutationOptions = Apollo.BaseMutationOptions<InstallWorkflowServiceMutation, InstallWorkflowServiceMutationVariables>;
export const SaveIntegrationSettingsDocument = gql`
    mutation SaveIntegrationSettings($settings: IntegrationSettingsInput!) {
  integrationSaveSettings(settings: $settings) {
    ok
  }
}
    `;
export type SaveIntegrationSettingsMutationFn = Apollo.MutationFunction<SaveIntegrationSettingsMutation, SaveIntegrationSettingsMutationVariables>;

/**
 * __useSaveIntegrationSettingsMutation__
 *
 * To run a mutation, you first call `useSaveIntegrationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntegrationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntegrationSettingsMutation, { data, loading, error }] = useSaveIntegrationSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveIntegrationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveIntegrationSettingsMutation, SaveIntegrationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIntegrationSettingsMutation, SaveIntegrationSettingsMutationVariables>(SaveIntegrationSettingsDocument, options);
      }
export type SaveIntegrationSettingsMutationHookResult = ReturnType<typeof useSaveIntegrationSettingsMutation>;
export type SaveIntegrationSettingsMutationResult = Apollo.MutationResult<SaveIntegrationSettingsMutation>;
export type SaveIntegrationSettingsMutationOptions = Apollo.BaseMutationOptions<SaveIntegrationSettingsMutation, SaveIntegrationSettingsMutationVariables>;
export const UninstallWorkflowServiceDocument = gql`
    mutation UninstallWorkflowService($integrationId: IntegrationUrn!) {
  workflowServiceUninstall(integrationId: $integrationId) {
    ok
  }
}
    `;
export type UninstallWorkflowServiceMutationFn = Apollo.MutationFunction<UninstallWorkflowServiceMutation, UninstallWorkflowServiceMutationVariables>;

/**
 * __useUninstallWorkflowServiceMutation__
 *
 * To run a mutation, you first call `useUninstallWorkflowServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUninstallWorkflowServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uninstallWorkflowServiceMutation, { data, loading, error }] = useUninstallWorkflowServiceMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useUninstallWorkflowServiceMutation(baseOptions?: Apollo.MutationHookOptions<UninstallWorkflowServiceMutation, UninstallWorkflowServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UninstallWorkflowServiceMutation, UninstallWorkflowServiceMutationVariables>(UninstallWorkflowServiceDocument, options);
      }
export type UninstallWorkflowServiceMutationHookResult = ReturnType<typeof useUninstallWorkflowServiceMutation>;
export type UninstallWorkflowServiceMutationResult = Apollo.MutationResult<UninstallWorkflowServiceMutation>;
export type UninstallWorkflowServiceMutationOptions = Apollo.BaseMutationOptions<UninstallWorkflowServiceMutation, UninstallWorkflowServiceMutationVariables>;
export const GetSettingsDocument = gql`
    query GetSettings {
  settings {
    identities
    agents {
      id
      name
      firstName
      lastName
      avatarUrl
    }
    customization {
      tags
      requiredCloseFields
      allowOverrideTicketsGroups
    }
    channelSlack {
      name
      iconUrl
      shouldDisplayAgentJoin
      introduction {
        rawText
      }
      offHoursIntroduction {
        rawText
      }
      approvedBotIds
      channelMode
      ignoreTicketsFromEmailDomains
      formIds
      messageActionFormIds
      requestFormText
      shouldAllowUsersAddParticipants
      slaTierId
      ticketCreatedTemplate
      canFillOutForm
      emojiActions {
        emoji
        description
        workflowId
        allowedExecuteGroups
      }
    }
    channelEmail {
      footer
      feedbackIntroduction
      shouldSendFeedback
      emails {
        id
        originalDestinationEmail
        isDefault
      }
    }
    channelWebChat {
      allowedHosts
      isReferrerCheckRequired
      name
      welcomeMessage
      avatarUrl
      chatScript
    }
    channels {
      channelTags
    }
    feedback {
      type
      customMessage
      shouldAllowComments
      responses {
        value
        message
      }
    }
    time {
      timezone
      holidayCountryCode
      hoursOfOperations {
        startMinute
        endMinute
        dayOfWeek
      }
    }
    sla {
      severityLabels
      defaultSeverityIndex
      defaultSLAPolicyId
      tiers {
        id
        name
        description
        values {
          policies {
            value
            metric
            shouldAccountHoursOfOperation
          }
        }
      }
    }
    artificialIntelligence {
      deflection {
        message {
          rawText
        }
        deflectionTicketStatusAssignment
      }
    }
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
      }
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const ListAgentChatDocument = gql`
    query ListAgentChat($filter: TicketView, $dashboardId: DashboardUrn) {
  chats(filter: $filter, dashboardId: $dashboardId) {
    chats {
      ...ChatView
    }
  }
}
    ${ChatViewFragmentDoc}`;

/**
 * __useListAgentChatQuery__
 *
 * To run a query within a React component, call `useListAgentChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAgentChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAgentChatQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useListAgentChatQuery(baseOptions?: Apollo.QueryHookOptions<ListAgentChatQuery, ListAgentChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAgentChatQuery, ListAgentChatQueryVariables>(ListAgentChatDocument, options);
      }
export function useListAgentChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAgentChatQuery, ListAgentChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAgentChatQuery, ListAgentChatQueryVariables>(ListAgentChatDocument, options);
        }
export type ListAgentChatQueryHookResult = ReturnType<typeof useListAgentChatQuery>;
export type ListAgentChatLazyQueryHookResult = ReturnType<typeof useListAgentChatLazyQuery>;
export type ListAgentChatQueryResult = Apollo.QueryResult<ListAgentChatQuery, ListAgentChatQueryVariables>;
export const ListStatesDocument = gql`
    query ListStates {
  dashboard {
    id
    name
    settings {
      view
      groupBy
      sortBy
      ticketView
      lastConversationCount
    }
    ticketStates {
      locationIndex
      ticketStateId
      label
      ticketState {
        id
        name
        description
        ticketStatuses
        chatStatuses
      }
    }
  }
}
    `;

/**
 * __useListStatesQuery__
 *
 * To run a query within a React component, call `useListStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListStatesQuery(baseOptions?: Apollo.QueryHookOptions<ListStatesQuery, ListStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListStatesQuery, ListStatesQueryVariables>(ListStatesDocument, options);
      }
export function useListStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListStatesQuery, ListStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListStatesQuery, ListStatesQueryVariables>(ListStatesDocument, options);
        }
export type ListStatesQueryHookResult = ReturnType<typeof useListStatesQuery>;
export type ListStatesLazyQueryHookResult = ReturnType<typeof useListStatesLazyQuery>;
export type ListStatesQueryResult = Apollo.QueryResult<ListStatesQuery, ListStatesQueryVariables>;
export const UpdateDashboardDocument = gql`
    mutation UpdateDashboard($dashboard: DashboardInput!) {
  updateDashboard(dashboard: $dashboard) {
    ok
  }
}
    `;
export type UpdateDashboardMutationFn = Apollo.MutationFunction<UpdateDashboardMutation, UpdateDashboardMutationVariables>;

/**
 * __useUpdateDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardMutation, { data, loading, error }] = useUpdateDashboardMutation({
 *   variables: {
 *      dashboard: // value for 'dashboard'
 *   },
 * });
 */
export function useUpdateDashboardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardMutation, UpdateDashboardMutationVariables>(UpdateDashboardDocument, options);
      }
export type UpdateDashboardMutationHookResult = ReturnType<typeof useUpdateDashboardMutation>;
export type UpdateDashboardMutationResult = Apollo.MutationResult<UpdateDashboardMutation>;
export type UpdateDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>;
export const DeleteArticleDocument = gql`
    mutation DeleteArticle($id: ArticleUrn!) {
  deleteArticle(id: $id) {
    ok
  }
}
    `;
export type DeleteArticleMutationFn = Apollo.MutationFunction<DeleteArticleMutation, DeleteArticleMutationVariables>;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticleMutation, DeleteArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(DeleteArticleDocument, options);
      }
export type DeleteArticleMutationHookResult = ReturnType<typeof useDeleteArticleMutation>;
export type DeleteArticleMutationResult = Apollo.MutationResult<DeleteArticleMutation>;
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables>;
export const GetArticleDocument = gql`
    query GetArticle($id: ArticleUrn!) {
  article(id: $id) {
    id
    title
    iconUrl
    modifiedDate
    publishedDate
    tags {
      id
      title
    }
    publishedBy {
      id
      name
    }
    body {
      html
    }
    creator {
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a React component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArticleQuery(baseOptions: Apollo.QueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
      }
export function useGetArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
export type GetArticleQueryHookResult = ReturnType<typeof useGetArticleQuery>;
export type GetArticleLazyQueryHookResult = ReturnType<typeof useGetArticleLazyQuery>;
export type GetArticleQueryResult = Apollo.QueryResult<GetArticleQuery, GetArticleQueryVariables>;
export const PublishArticleDocument = gql`
    mutation PublishArticle($id: ArticleUrn!, $settings: ArticlePublishInput) {
  publishArticle(id: $id, settings: $settings) {
    ok
  }
}
    `;
export type PublishArticleMutationFn = Apollo.MutationFunction<PublishArticleMutation, PublishArticleMutationVariables>;

/**
 * __usePublishArticleMutation__
 *
 * To run a mutation, you first call `usePublishArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishArticleMutation, { data, loading, error }] = usePublishArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function usePublishArticleMutation(baseOptions?: Apollo.MutationHookOptions<PublishArticleMutation, PublishArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishArticleMutation, PublishArticleMutationVariables>(PublishArticleDocument, options);
      }
export type PublishArticleMutationHookResult = ReturnType<typeof usePublishArticleMutation>;
export type PublishArticleMutationResult = Apollo.MutationResult<PublishArticleMutation>;
export type PublishArticleMutationOptions = Apollo.BaseMutationOptions<PublishArticleMutation, PublishArticleMutationVariables>;
export const SaveArticleDocument = gql`
    mutation SaveArticle($id: ArticleUrn, $article: ArticleInput!) {
  saveArticle(id: $id, article: $article) {
    id
    modifiedDate
    title
    iconUrl
    publishedDate
    tags {
      id
      title
      description
      iconUrl
    }
    publishedBy {
      id
      name
    }
    body {
      html
    }
    creator {
      name
      avatarUrl
    }
  }
}
    `;
export type SaveArticleMutationFn = Apollo.MutationFunction<SaveArticleMutation, SaveArticleMutationVariables>;

/**
 * __useSaveArticleMutation__
 *
 * To run a mutation, you first call `useSaveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveArticleMutation, { data, loading, error }] = useSaveArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      article: // value for 'article'
 *   },
 * });
 */
export function useSaveArticleMutation(baseOptions?: Apollo.MutationHookOptions<SaveArticleMutation, SaveArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveArticleMutation, SaveArticleMutationVariables>(SaveArticleDocument, options);
      }
export type SaveArticleMutationHookResult = ReturnType<typeof useSaveArticleMutation>;
export type SaveArticleMutationResult = Apollo.MutationResult<SaveArticleMutation>;
export type SaveArticleMutationOptions = Apollo.BaseMutationOptions<SaveArticleMutation, SaveArticleMutationVariables>;
export const SetIndexArticleDocument = gql`
    mutation SetIndexArticle($id: ArticleUrn!) {
  setIndexArticle(id: $id) {
    ok
  }
}
    `;
export type SetIndexArticleMutationFn = Apollo.MutationFunction<SetIndexArticleMutation, SetIndexArticleMutationVariables>;

/**
 * __useSetIndexArticleMutation__
 *
 * To run a mutation, you first call `useSetIndexArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndexArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndexArticleMutation, { data, loading, error }] = useSetIndexArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetIndexArticleMutation(baseOptions?: Apollo.MutationHookOptions<SetIndexArticleMutation, SetIndexArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndexArticleMutation, SetIndexArticleMutationVariables>(SetIndexArticleDocument, options);
      }
export type SetIndexArticleMutationHookResult = ReturnType<typeof useSetIndexArticleMutation>;
export type SetIndexArticleMutationResult = Apollo.MutationResult<SetIndexArticleMutation>;
export type SetIndexArticleMutationOptions = Apollo.BaseMutationOptions<SetIndexArticleMutation, SetIndexArticleMutationVariables>;
export const UnpublishArticleDocument = gql`
    mutation UnpublishArticle($id: ArticleUrn!) {
  unpublishArticle(id: $id) {
    ok
  }
}
    `;
export type UnpublishArticleMutationFn = Apollo.MutationFunction<UnpublishArticleMutation, UnpublishArticleMutationVariables>;

/**
 * __useUnpublishArticleMutation__
 *
 * To run a mutation, you first call `useUnpublishArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishArticleMutation, { data, loading, error }] = useUnpublishArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishArticleMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishArticleMutation, UnpublishArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishArticleMutation, UnpublishArticleMutationVariables>(UnpublishArticleDocument, options);
      }
export type UnpublishArticleMutationHookResult = ReturnType<typeof useUnpublishArticleMutation>;
export type UnpublishArticleMutationResult = Apollo.MutationResult<UnpublishArticleMutation>;
export type UnpublishArticleMutationOptions = Apollo.BaseMutationOptions<UnpublishArticleMutation, UnpublishArticleMutationVariables>;
export const ListArticlesDocument = gql`
    query ListArticles($query: String, $limit: Float) {
  articles(query: $query, limit: $limit) {
    count
    nextPageToken
    answer {
      body
    }
    results {
      id
      title
      iconUrl
      modifiedDate
      previewText
      publishedDate
      publishedBy {
        name
      }
      body {
        html
        plaintext
      }
      creator {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useListArticlesQuery__
 *
 * To run a query within a React component, call `useListArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListArticlesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListArticlesQuery(baseOptions?: Apollo.QueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListArticlesQuery, ListArticlesQueryVariables>(ListArticlesDocument, options);
      }
export function useListArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListArticlesQuery, ListArticlesQueryVariables>(ListArticlesDocument, options);
        }
export type ListArticlesQueryHookResult = ReturnType<typeof useListArticlesQuery>;
export type ListArticlesLazyQueryHookResult = ReturnType<typeof useListArticlesLazyQuery>;
export type ListArticlesQueryResult = Apollo.QueryResult<ListArticlesQuery, ListArticlesQueryVariables>;
export const StoreFeedbackDocument = gql`
    mutation StoreFeedback($feedback: ArticleFeedbackType!) {
  articleSearchFeedback(feedback: $feedback) {
    ok
  }
}
    `;
export type StoreFeedbackMutationFn = Apollo.MutationFunction<StoreFeedbackMutation, StoreFeedbackMutationVariables>;

/**
 * __useStoreFeedbackMutation__
 *
 * To run a mutation, you first call `useStoreFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeFeedbackMutation, { data, loading, error }] = useStoreFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useStoreFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<StoreFeedbackMutation, StoreFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreFeedbackMutation, StoreFeedbackMutationVariables>(StoreFeedbackDocument, options);
      }
export type StoreFeedbackMutationHookResult = ReturnType<typeof useStoreFeedbackMutation>;
export type StoreFeedbackMutationResult = Apollo.MutationResult<StoreFeedbackMutation>;
export type StoreFeedbackMutationOptions = Apollo.BaseMutationOptions<StoreFeedbackMutation, StoreFeedbackMutationVariables>;
export const GetChannelInviteDocument = gql`
    query GetChannelInvite($id: ChannelInviteUrn!) {
  channelInvite(id: $id) {
    name
  }
}
    `;

/**
 * __useGetChannelInviteQuery__
 *
 * To run a query within a React component, call `useGetChannelInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInviteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChannelInviteQuery(baseOptions: Apollo.QueryHookOptions<GetChannelInviteQuery, GetChannelInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelInviteQuery, GetChannelInviteQueryVariables>(GetChannelInviteDocument, options);
      }
export function useGetChannelInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelInviteQuery, GetChannelInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelInviteQuery, GetChannelInviteQueryVariables>(GetChannelInviteDocument, options);
        }
export type GetChannelInviteQueryHookResult = ReturnType<typeof useGetChannelInviteQuery>;
export type GetChannelInviteLazyQueryHookResult = ReturnType<typeof useGetChannelInviteLazyQuery>;
export type GetChannelInviteQueryResult = Apollo.QueryResult<GetChannelInviteQuery, GetChannelInviteQueryVariables>;
export const SendChannelInviteDocument = gql`
    mutation SendChannelInvite($invite: SendChannelInviteInput!) {
  sendChannelInvite(invite: $invite) {
    ok
  }
}
    `;
export type SendChannelInviteMutationFn = Apollo.MutationFunction<SendChannelInviteMutation, SendChannelInviteMutationVariables>;

/**
 * __useSendChannelInviteMutation__
 *
 * To run a mutation, you first call `useSendChannelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChannelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChannelInviteMutation, { data, loading, error }] = useSendChannelInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useSendChannelInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendChannelInviteMutation, SendChannelInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChannelInviteMutation, SendChannelInviteMutationVariables>(SendChannelInviteDocument, options);
      }
export type SendChannelInviteMutationHookResult = ReturnType<typeof useSendChannelInviteMutation>;
export type SendChannelInviteMutationResult = Apollo.MutationResult<SendChannelInviteMutation>;
export type SendChannelInviteMutationOptions = Apollo.BaseMutationOptions<SendChannelInviteMutation, SendChannelInviteMutationVariables>;
export const FinishOnboardingDocument = gql`
    mutation finishOnboarding {
  finishOnboarding {
    ok
  }
}
    `;
export type FinishOnboardingMutationFn = Apollo.MutationFunction<FinishOnboardingMutation, FinishOnboardingMutationVariables>;

/**
 * __useFinishOnboardingMutation__
 *
 * To run a mutation, you first call `useFinishOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishOnboardingMutation, { data, loading, error }] = useFinishOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinishOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<FinishOnboardingMutation, FinishOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishOnboardingMutation, FinishOnboardingMutationVariables>(FinishOnboardingDocument, options);
      }
export type FinishOnboardingMutationHookResult = ReturnType<typeof useFinishOnboardingMutation>;
export type FinishOnboardingMutationResult = Apollo.MutationResult<FinishOnboardingMutation>;
export type FinishOnboardingMutationOptions = Apollo.BaseMutationOptions<FinishOnboardingMutation, FinishOnboardingMutationVariables>;
export const GetOnboardingProfileDocument = gql`
    query GetOnboardingProfile {
  onboardingProfile {
    ...OnboardingProfile
  }
}
    ${OnboardingProfileFragmentDoc}`;

/**
 * __useGetOnboardingProfileQuery__
 *
 * To run a query within a React component, call `useGetOnboardingProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnboardingProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetOnboardingProfileQuery, GetOnboardingProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardingProfileQuery, GetOnboardingProfileQueryVariables>(GetOnboardingProfileDocument, options);
      }
export function useGetOnboardingProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingProfileQuery, GetOnboardingProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardingProfileQuery, GetOnboardingProfileQueryVariables>(GetOnboardingProfileDocument, options);
        }
export type GetOnboardingProfileQueryHookResult = ReturnType<typeof useGetOnboardingProfileQuery>;
export type GetOnboardingProfileLazyQueryHookResult = ReturnType<typeof useGetOnboardingProfileLazyQuery>;
export type GetOnboardingProfileQueryResult = Apollo.QueryResult<GetOnboardingProfileQuery, GetOnboardingProfileQueryVariables>;
export const SaveOnboardingProfileDocument = gql`
    mutation SaveOnboardingProfile($profile: OnboardingProfileInput!) {
  saveOnboardingProfile(profile: $profile) {
    ...OnboardingProfile
  }
}
    ${OnboardingProfileFragmentDoc}`;
export type SaveOnboardingProfileMutationFn = Apollo.MutationFunction<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>;

/**
 * __useSaveOnboardingProfileMutation__
 *
 * To run a mutation, you first call `useSaveOnboardingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnboardingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnboardingProfileMutation, { data, loading, error }] = useSaveOnboardingProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useSaveOnboardingProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>(SaveOnboardingProfileDocument, options);
      }
export type SaveOnboardingProfileMutationHookResult = ReturnType<typeof useSaveOnboardingProfileMutation>;
export type SaveOnboardingProfileMutationResult = Apollo.MutationResult<SaveOnboardingProfileMutation>;
export type SaveOnboardingProfileMutationOptions = Apollo.BaseMutationOptions<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>;
export const GetReportsDataDocument = gql`
    query GetReportsData($input: MetricsInput!) {
  metricsDashboardWithData(input: $input) {
    dashboard {
      id
      name
      settings {
        graphs {
          type
          dataSource
          title
          locationX
          locationY
          width
          height
          dimensions {
            fieldId
            label
            format
          }
          metrics {
            fieldId
            aggregation
            label
            display
          }
          filters {
            fieldId
            comparer
            value {
              type
              string
              boolean
              date
              options
              number
            }
          }
          sort {
            fieldId
            direction
          }
        }
      }
    }
    data {
      dataSource
      rows {
        id
        values
      }
      columns {
        id
        field {
          name
          type
        }
      }
      labels {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useGetReportsDataQuery__
 *
 * To run a query within a React component, call `useGetReportsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReportsDataQuery(baseOptions: Apollo.QueryHookOptions<GetReportsDataQuery, GetReportsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsDataQuery, GetReportsDataQueryVariables>(GetReportsDataDocument, options);
      }
export function useGetReportsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsDataQuery, GetReportsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsDataQuery, GetReportsDataQueryVariables>(GetReportsDataDocument, options);
        }
export type GetReportsDataQueryHookResult = ReturnType<typeof useGetReportsDataQuery>;
export type GetReportsDataLazyQueryHookResult = ReturnType<typeof useGetReportsDataLazyQuery>;
export type GetReportsDataQueryResult = Apollo.QueryResult<GetReportsDataQuery, GetReportsDataQueryVariables>;
export const GetTemplateFieldsDocument = gql`
    query GetTemplateFields {
  formFields(shouldIncludeTemplateFields: true) {
    id
    name
    description
  }
}
    `;

/**
 * __useGetTemplateFieldsQuery__
 *
 * To run a query within a React component, call `useGetTemplateFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplateFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplateFieldsQuery, GetTemplateFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateFieldsQuery, GetTemplateFieldsQueryVariables>(GetTemplateFieldsDocument, options);
      }
export function useGetTemplateFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateFieldsQuery, GetTemplateFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateFieldsQuery, GetTemplateFieldsQueryVariables>(GetTemplateFieldsDocument, options);
        }
export type GetTemplateFieldsQueryHookResult = ReturnType<typeof useGetTemplateFieldsQuery>;
export type GetTemplateFieldsLazyQueryHookResult = ReturnType<typeof useGetTemplateFieldsLazyQuery>;
export type GetTemplateFieldsQueryResult = Apollo.QueryResult<GetTemplateFieldsQuery, GetTemplateFieldsQueryVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates {
  forms(type: TEMPLATE) {
    id
    name
    description
    tags
    jobFunctions
    iconUrl
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetTicketsDocument = gql`
    query GetTickets($filters: TicketFilters, $filter: TicketView) {
  tickets(filters: $filters, filter: $filter) {
    id
    subject
    description
    ticketNumber
    createdDate
    lastResponseDate
    hasUnreadByCurrentUser
    currentUserLastReadDate
    status
    chatId
    assignee {
      name
      avatarUrl
    }
    creator {
      name
      avatarUrl
    }
    form {
      name
    }
  }
}
    `;

/**
 * __useGetTicketsQuery__
 *
 * To run a query within a React component, call `useGetTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTicketsQuery(baseOptions?: Apollo.QueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, options);
      }
export function useGetTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketsQuery, GetTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketsQuery, GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
export type GetTicketsQueryHookResult = ReturnType<typeof useGetTicketsQuery>;
export type GetTicketsLazyQueryHookResult = ReturnType<typeof useGetTicketsLazyQuery>;
export type GetTicketsQueryResult = Apollo.QueryResult<GetTicketsQuery, GetTicketsQueryVariables>;